import LocationWindowsTab from './LocationWindowsTab';
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import {withStyles} from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";
import { PageToolbarRow } from "../common/PageToolbarRow";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import DeleteIcon from "@mui/icons-material/Delete";
import AddBoxIcon from "@mui/icons-material/Add";
import AddBoxImage from "@mui/icons-material/CloudUpload";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import Dropzone from "react-dropzone";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Selector from "../select";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import SwipeableViews from "react-swipeable-views";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import MaskedInput from "react-text-mask";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForward from "@mui/icons-material/ArrowForward";
import {toast} from "react-toastify";
import Divider from "@mui/material/Divider";
import Switch from "@mui/material/Switch";
import {ValidatorForm, TextValidator} from "react-material-ui-form-validator";
import spinner from "../assign-prescriptions/images/spinner.gif";
import {Input, InputAdornment} from "@mui/material";
import {Visibility, VisibilityOff, Help, Info, CreditCard} from "@mui/icons-material";
import SettingIcon from "@mui/icons-material/Settings";
import BOX_TYPE from "../enum/box_type";
import COOL_UNIT_TEMP from "../enum/cool_unit_temp";
import LOCATION_TYPE from "../enum/location_type";
import SearchUtils from "../assign-prescriptions/counter/utils/SearchUtils";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Box from "@mui/material/Box";
import {withTranslation} from "react-i18next";
import {navigate, Link} from "@reach/router";
import CONNECTION_TYPE from "../common/connection-type";
import {isTruthyPreAssignmentFlag, isPreAssignmentAccountFromSession, } from "../../utils/preAssignment";
import PaymentGatewayTypes from "../common/payment-gateways";
import {
  fetchEntitlements,
  getSelectedBoxId,
  isManageLocationTypeUsable,
  featureKeyForManageLocationName,
  getFeatureLockedRedirectPath,
} from "../../utils/productLicensing";
import userroles from "../common/userroles";
import ROLES_TYPE from "../enum/role_type";
import {convertToTimeZone} from "../../utils/datetime.utils";
import ColumnMappingTab from "./ColumnMappingTab";
import AutoUpdateSettingsTab from "./AutoUpdateSettingsTab";
import PickupSwitchingTab, {
  defaultPickupSwitching,
  normalizePickupSwitching,
  PickupSwitchingTabIcon,
} from "./PickupSwitchingTab";
import ILocalAGGrid, {
  getDefaultColDef,
  createServerSideDatasource,
  buildManageBoxesSearchObject,
  getAddressColumns,
  getActionsColumn,
  openAgGridContextMenu,
  actionMenuItem,
} from "../grid/iLocalAGGrid";


const getApiErrorMessage = (response) =>
  (response && response.error && response.error.message) ||
  (response && response.message) ||
  null;

const storedText = (value) => {
  if (
    value === "" ||
    value === "null" ||
    value === null ||
    value === undefined ||
    value === "undefined"
  ) {
    return "";
  }
  return value;
};

const locationFieldLabel = (label, tooltip) => (
  <Box
    component="span"
    sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}
  >
    {label}
    <Tooltip title={tooltip}>
      <IconButton
        size="small"
        component="span"
        tabIndex={-1}
        aria-label={tooltip}
        sx={{ p: 0, color: "primary.main" }}
        onMouseDown={(event) => event.preventDefault()}
        onClick={(event) => event.preventDefault()}
      >
        <Info sx={{ fontSize: 16 }} />
      </IconButton>
    </Tooltip>
  </Box>
);

// The location record omits a kiosk flag whose column is not in this
// environment's database yet; null keeps that switch hidden.
const kioskFlagValue = (value) => (typeof value === "boolean" ? value : null);

const MAIN_UNIT_BOX_TYPES = [
  BOX_TYPE.Locker,
  BOX_TYPE.M22,
  BOX_TYPE.M24,
  BOX_TYPE.M41,
  BOX_TYPE.FASTLANE,
  BOX_TYPE.FASTLANEGOLIATH,
];

let addonUnitsCount = 46;
const PERSISTED_ADDON_ID =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const createAddonClientId = () =>
  `new-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;

const addonRowId = (item) =>
  item && item.id !== undefined && item.id !== null && item.id !== ""
    ? item.id
    : createAddonClientId();

const PAYMENT_DEVICE_FIELDS = [
  "XWebId",
  "XWebAuthKey",
  "XWebTerminalId",
  "pos_bridge_hostname",
  "pos_bridge_port",
  "pos_bridge_https_hostname",
  "pos_bridge_https_port",
  "pos_bridge_protocol",
  "pos_merchant_name",
  "pos_merchant_site_id",
  "pos_merchant_key",
  "pos_software_name",
  "pos_software_version",
  "pos_terminal_id",
  "pos_api_url",
  "pos_clerk_id",
  "instamed_sso_alias",
  "instamed_workstation_id",
  "instamed_additional_info_6",
  "pos_manual_entry_enabled",
  "pos_manual_entry_button_enabled",
  "pos_clover_go_enabled",
];

const PAY_LATER_MODES = {
  DISABLED: "disabled",
  ALL_ORDERS: "all_orders",
  SELECT_ORDERS: "select_orders",
};

const normalizePayLaterMode = (value, payrollDeduct) => {
  const legacyOn = payrollDeduct === true || payrollDeduct === "true";
  if (value === PAY_LATER_MODES.ALL_ORDERS || value === PAY_LATER_MODES.SELECT_ORDERS) {
    return value;
  }
  // Default "disabled" on older locations must not hide Pay Later while
  // payroll deduct is still enabled.
  if (legacyOn) {
    return PAY_LATER_MODES.ALL_ORDERS;
  }
  if (Object.values(PAY_LATER_MODES).includes(value)) {
    return value;
  }
  return PAY_LATER_MODES.DISABLED;
};

const isPayLaterEnabledForMode = (mode) =>
  mode === PAY_LATER_MODES.ALL_ORDERS || mode === PAY_LATER_MODES.SELECT_ORDERS;

const createPaymentDeviceLocalId = () =>
  `payment-device-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;

const getPaymentDeviceUiId = (device) => (device && (device.id || device.local_id)) || "";

const getPaymentDeviceLabel = (index) => `Lane ${index + 1}`;

const getPaymentDeviceDefaults = (gateway, index = 0) => ({
  id: "",
  local_id: createPaymentDeviceLocalId(),
  name: getPaymentDeviceLabel(index),
  payment_gateway_id: gateway || PaymentGatewayTypes.GLOBAL_PAYMENTS,
  is_active: true,
  XWebId: "",
  XWebAuthKey: "",
  XWebTerminalId: "",
  pos_bridge_hostname: "",
  pos_bridge_port: 8080,
  pos_bridge_https_hostname: "",
  pos_bridge_https_port: 8443,
  pos_bridge_protocol: "http",
  pos_merchant_name: "",
  pos_merchant_site_id: "",
  pos_merchant_key: "",
  pos_software_name: "",
  pos_software_version: "",
  pos_terminal_id: "",
  pos_api_url: "",
  pos_clerk_id: "",
  instamed_sso_alias: "",
  instamed_workstation_id: "",
  instamed_additional_info_6: "",
  pos_manual_entry_enabled: false,
  pos_manual_entry_button_enabled: false,
  pos_clover_go_enabled: false,
});

const paymentFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    backgroundColor: "#fff",
    fontSize: "0.92rem",
    "& fieldset": {
      borderColor: "rgba(15, 23, 42, 0.16)",
    },
    "&:hover fieldset": {
      borderColor: "rgba(25, 118, 210, 0.55)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#1976d2",
      borderWidth: "1px",
    },
  },
  "& .MuiInputLabel-root": {
    color: "#64748b",
    fontSize: "0.88rem",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#1976d2",
  },
  "& .MuiFormHelperText-root": {
    marginLeft: 0,
    color: "#64748b",
  },
};

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      mask={[/[0-9]/, /[0-9]/, ":", /[0-9]/, /[0-9]/]}
    />
  );
}
TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

function TabContainer({ children, dir, classes }) {
  return (
    <Typography component="div" dir={dir} style={{ padding: 0 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

const LOCATION_TAB_MIN_WIDTH = 120;

const isAllowedPermissionFlag = (value) =>
  value === 1 ||
  value === true ||
  value === "1" ||
  value === "true" ||
  value === "t";

const pickupSwitchingPermissionTokens = (item) =>
  [
    item && item.name,
    item && item.permission_name,
    item && item.name_lang_key,
    item && item.permission_lang_key,
  ]
    .filter(Boolean)
    .map((value) =>
      String(value)
        .trim()
        .toLowerCase()
        .replace(/[_-\s]/g, "")
    );

const isPickupSwitchingPermission = (item) =>
  pickupSwitchingPermissionTokens(item).some(
    (token) =>
      token === "pickupswitching" ||
      token === "api.roles.permission.pickupswitching" ||
      token.indexOf("pickupswitching") !== -1
  );

const hasPickupSwitchingPermission = (permissions) =>
  (permissions || []).some(
    (item) =>
      isPickupSwitchingPermission(item) &&
      isAllowedPermissionFlag(item.is_allowed)
  );


// function onDrop(acceptedFiles, rejectedFiles) {
//   // do stuff with files...
// }

class EnhancedTableHead extends React.Component {
  createSortHandler = (property, field) => (event) => {
    this.props.onRequestSort(event, property, field);
  };

  render() {
    const {onSelectAllClick, order, orderBy, sortId, numSelected, rowCount, t} = this.props;

    const rows = [
      {
        id: "avatar",
        numeric: false,
        disablePadding: true,
        label: t("Location.Picture"),
        field: "picture_url",
      },
      {
        id: "name",
        numeric: false,
        disablePadding: false,
        label: t("Location.Name"),
        field: "name",
      },
      {
        id: "description",
        numeric: false,
        disablePadding: false,
        label: t("Location.Description"),
        field: "description",
      },
      {
        id: "type",
        numeric: false,
        disablePadding: false,
        label: t("Location.Type"),
        field: "location_type_id",
      },
      {
        id: "city",
        numeric: false,
        disablePadding: false,
        label: t("Location.City"),
        field: "city",
      },
      {
        id: "state",
        numeric: false,
        disablePadding: false,
        label: t("Location.State"),
        field: "state",
      },
      {
        id: "ParentAccount",
        numeric: false,
        disablePadding: false,
        label: t("Location.ParentAccount"),
        field: "name",
      },
      {
        id: "actions",
        numeric: false,
        disablePadding: false,
        label: t("Location.Actions"),
      },
    ];

    return (
      <TableHead sx={{ height: "56px" }}>
        <TableRow>
          <TableCell sx={{ padding: "0 12px" }}>
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected === rowCount}
              onChange={onSelectAllClick}
              sx={{
                "&.Mui-checked": { color: "#0ae" },
                "&.MuiCheckbox-indeterminate": { color: "#0ae" },
              }}
            />
          </TableCell>
          {rows.map((row) => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                sx={{
                  color: "rgba(0, 0, 0, 0.54)",
                  fontSize: "0.75rem",
                  fontWeight: 500,
                }}
              >
                {["Picture", "Actions", "Parent Account"].includes(
                  row.label
                ) ? (
                  <TableSortLabel style={{ cursor: "text" }}>
                    {row.label}
                  </TableSortLabel>
                ) : (
                  <Tooltip
                    title={t("Global.Label.Filter.Sort")}
                    placement={row.numeric ? "bottom-end" : "bottom-start"}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={orderBy === row.field && sortId === row.id}
                      direction={order}
                      onClick={this.createSortHandler(row.id, row.field)}
                    >
                      {row.label}
                    </TableSortLabel>
                  </Tooltip>
                )}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.mode === "light"
      ? {
        color: "#4fc3f7",
        backgroundColor: "rgb(255, 234, 231)",
      }
      : {
        color: "#4fc3f7",
        backgroundColor: "rgb(255, 234, 231)",
      },
  spacer: {
    flex: "1 1 100%",
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: "0 0 auto",
  },
  add: {
    backgroundColor: "#00a7e1",
    transition: "background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#6cca98",
      color: "#fff",
    },
  },
  gridActions: {
    display: "inline-block",
    width: "144px",
  },
});

let EnhancedTableToolbar = (props) => {
  const {
    numSelected,
    classes,
    add,
    confirmDelete,
    badd,
    bdelete,
    t,
  } = props;

  return (
    <PageToolbarRow highlight={numSelected > 0}>
      {numSelected > 0 ? (
        <Typography variant="subheading">
          {numSelected} {t("Location.SelectedRowsCount")}
        </Typography>
      ) : null}
      <div className={classes.actions}>
        {numSelected === 1 ? (
          <div>
            {bdelete === true ? (
              <Tooltip
                key="single-delete"
                title={t("Location.DeleteLocationTooltip")}
              >
                <IconButton
                  aria-label="Delete"
                  onClick={confirmDelete}
                  sx={() => ({
                    "&:hover": { backgroundColor: "#6cca98", color: "#fff" },
                  })}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            ) : (
              ""
            )}
          </div>
        ) : numSelected > 1 ? (
          bdelete === true ? (
            <Tooltip
              key="multi-delete"
              title={t("Location.DeleteLocationTooltip")}
            >
              <IconButton
                aria-label="Delete"
                onClick={confirmDelete}
                sx={() => ({
                  "&:hover": { backgroundColor: "#6cca98", color: "#fff" },
                })}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          ) : (
            ""
          )
        ) : badd === true ? (
          <Tooltip key="single-add" title={t("Location.AddLocationTooltip")}>
            <IconButton
              aria-label="Add Location"
              className={classes.add}
              onClick={add}
            >
              <AddBoxIcon />
            </IconButton>
          </Tooltip>
        ) : (
          ""
        )}
      </div>
    </PageToolbarRow>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(
  withTranslation()(EnhancedTableToolbar)
);

const styles = (theme) => ({
  Paper: {
    minWidth: "985px",
  },
  tabsroot: {
    backgroundColor: theme.palette.background.paper,
    width: 500,
  },
  "@media only screen and (min-width: 1024px) and (max-width:1440px) and (orientation:landscape)": {
    root: {
      width: "100%",
      marginTop: theme.spacing.unit * 3,
    },
  },
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    // marginTop: theme.spacing.unit * 3,
  },
  table: {
    minWidth: 1020,
  },
  mytablebody: {
    marginLeft: "0% !important",
  },
  tableWrapper: {
    overflowX: "auto",
  },
  halfTextField: {
    marginRight: "20px",
    width: 300,
  },
  oneThirdTextField: {
    marginRight: "20px",
  },
  dropbox: {
    width: "140px",
    height: "115px",
    float: "right",
    textAlign: "center",
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    overflow: "hidden",
    top: "42px",
    right: "2px",
    position: "relative",
    minHight: "48px",
  },
  innerBox: {
    margin: "0 auto",
    display: "block",
    height: "100%",
  },
  dropImage: {
    width: "80%",
    height: "100%",
  },
  dropPic: {
    width: "100%",
    height: "100%",
  },
  errorDiv: {
    paddingTop: "10px",
    color: "red",
  },
  boxType: {
    marginRight: "20px",
    width: 300,
  },
  mypaper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  boxDesign: {
    padding: "24px",
    display: "grid",
    alignItems: "center",
    justifyContent: "center",
  },
  boxId: {
    padding: "10px 0px",
    display: "flex",
  },
  imgProperty: {
    border: "2px solid #000",
    cursor: "pointer",
  },
  spaceDiv: {
    width: "5%",
  },
  paddedDiv: {
    padding: "0px 3% !important",
    lineHeight: "3.6em",
  },
  paddedBoxDiv: {
    padding: "5% 24px !important",
  },
  paddedBoxDivEdit: {
    paddingTop: "24px !important",
  },
  tab2Container: {},
  iconStyle: {
    color: "#0a5d66",
  },
  iconGroup: {
    display: "flex",
  },
  tableDropdown: {
    width: "100px",
    margin: theme.spacing.unit,
  },
  tableIcon: {
    color: "#000",
  },
  captionText: {
    lineHeight: "1",
    color: "#8a8a8a",
    fontSize: "13px",
    textAlign: "center",
  },
  twoChildren: {
    display: "flex",
    justifyContent: "space-between",
  },
  leftChild: {},
  rightChild: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  addRowIcon: {
    width: "20%",
  },
  arrowIcon: {
    display: "flex",
  },
  tableCell: {
    width: "50%",
    padding: "4px 0px 4px 10px !important",
  },
  tableAddRowCell: {
    padding: "4px 20px 4px 32px !important",
  },
  tableTd: {
    padding: "4px 0px 4px 10px !important",
  },
  spinner: {
    position: "absolute",
    background: "rgba(255,255,255,.4)",
    width: "100%",
    height: "100%",
    zIndex: "9999",
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: "calc(50% - 32.5px)",
    left: "calc(50% - 65px)",
    position: "absolute",
    width: "130px",
    userSelect: "none",
  },
  hidden: {
    display: "none",
  },
  halfTextFieldPOS: {
    marginRight: "20px",
    marginBottom: "20px",
    width: 425,
  },
  primaryButton: {
    background: "#6cca98",
    color: "#fff",
    "&:hover": {
      background: "#6cca98",
      color: "#fff",
    },
    "&:disabled": {
      color: "rgba(0, 0, 0, 0.38)",
      cursor: "not-allowed",
      background: "#E4E5E8",
    },
  },
  menuItem: {
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  ThirdTextField: {
    width: "90%",
    marginRight: "46px",
  },
});


const TransactionSortObj = {
  name: { tableName: "boxes", sortColumn: "name" },
  description: { tableName: "boxes", sortColumn: "description" },
  "address.city": { tableName: "addresses", sortColumn: "city" },
  "address.state": { tableName: "addresses", sortColumn: "state" },
  "address.zip": { tableName: "addresses", sortColumn: "zip" },
  "account.name": { tableName: "accounts", sortColumn: "name" },
};

let TransactionFilterObj = {
  searchtext: "",
  searchObject: null,
  pageNo: 0,
  pageSize: 10,
  sortOrder: "desc",
  sortColumn: "created_on",
  tableName: "",
  listView: true,
};

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "desc",
      orderBy: "created_on",
      selected: [],
      Rows: [],
      page: 0,
      rowsPerPage: 10,
      selectedTab: 0,
      isButtonDisabled: false,
      kiosk_box_id: "",
      searchtext: "",
      addonUnits: [],
      boxTypes: [],
      IsActive: true,
      boxview: true,
      boxadd: true,
      boxdelete: true,
      boxedit: true,
      loader: false,
      TimevalidateDialog: false,
      Sun: false,
      Mon: false,
      Tue: false,
      Wed: false,
      Thu: false,
      Fri: false,
      Sat: false,
      pos: {},
      XWebAuthKey: "",
      XWebId: "",
      XWebTerminalId: "",
      isXWebIdSecretVisible: false,
      isXWebAuthKeySecretVisible: false,
      isXWebTerminalIdSecretVisible: false,
      maxtemp: "",
      setTemp: "",
      mintemp: "",
      errorMaxTemp: false,
      errorMinTemp: false,
      errorSetTemp: false,
      manage_location_name: "",
      location_notes: "",
      branding_name: "",
      location_type_id: "",
      featureEntitlements: null,
      selectCourierType: ["Fed Ex"],
      Fed_Ex: false,
      UPS: false,
      DHL: false,
      third_Party: false,
      Self_Service: false,
      US_Postal: false,
      selectedRadio: "Fed Ex",
      is_marketplace: false,
      simpleOrExpressUI: false,
      SimplifiedEnrollment: false,
      openpath: false,
      totalRecords: 0,
      paymentType: PaymentGatewayTypes.GLOBAL_PAYMENTS,
      selected_regioin: "c10342aa-0c44-41c6-9b50-cf401c7244a9",
      countryList: [],
      preferLanguage: "en",
      preferredLanguage: [
        { id: "en", label: this.props.t("Global.Language.English") },
        { id: "es", label: this.props.t("Global.Language.Spanish") },
        { id: "fr", label: this.props.t("Global.Language.French") },
      ],
      door_open_debounce_interval: 0,
      door_interval_between_two_bins: 0,
      boxTypeId: "",
      allow_multi_bins_pickup: false,
      OpenPathEmailId: "",
      OpenPathPassword: "",
      payroll_deduct: true,
      pay_later_mode: PAY_LATER_MODES.ALL_ORDERS,
      openPathUserList: [],
      openPathUser: "",
      isUnplugged: false,
      com_port: "",
      KioskHoursOfOperaionsArray: [
        { id: 0, value: 'Sunday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 1, value: 'Monday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 2, value: 'Tuesday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 3, value: 'Wednesday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 4, value: 'Thursday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 5, value: 'Friday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 6, value: 'Saturday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
      ],
      KioksDummyHoursOfOperaionsArray: [
        { id: 0, value: 'Sunday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 1, value: 'Monday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 2, value: 'Tuesday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 3, value: 'Wednesday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 4, value: 'Thursday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 5, value: 'Friday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 6, value: 'Saturday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
      ],
      lunchStart:'',
      lunchEnd:'',
      is_eseek: false,
      is_install_mode: false,
      external_id: "",
      is_strict_check:false,
      auto_release_on_id_scan: false,
      is_lifeboat_enabled: false,
      is_ecom_enabled: false,
      is_non_rx_deliver_enabled: false,
      is_pos: false,
      is_consult: false,
      is_dl_capture: false,
      is_kiosk_dob_enabled: true,
      is_kiosk_dob_camera_enabled: true,
      is_survey: false,
      test_details:[],
      isCloneDialog: false,
      is_partial_payment_enabled: false,
      binoccupancy_check: true,
      show_request_assistance: false,
      enable_evaporator_temperature: false,
      strict_patient_verification: false,
      enable_trim: false,
      trim_chars: SearchUtils.defaultTrimChars,
      isGeneratingCode: false,
      pos_bridge_hostname: "",
      pos_bridge_port: 8080,
      pos_bridge_https_hostname: "",
      pos_bridge_https_port: 8443,
      pos_bridge_protocol: "http",
      pos_merchant_name: "",
      pos_merchant_site_id: "",
      pos_merchant_key: "",
      pos_software_name: "",
      pos_software_version: "",
      kiosk_version_current: "",
      kiosk_version_available: "",
      original_kiosk_version_available: "",
      engine_version_current: "",
      engine_version_target: "",
      original_engine_version_target: "",
      wrapper_version_current: "",
      wrapper_version_target: "",
      original_wrapper_version_target: "",
      pos_bridge_version_current: "",
      pos_bridge_version_target: "",
      original_pos_bridge_version_target: "",
      component_update_paused: false,
      original_component_update_paused: false,
      component_update_ring: "fleet",
      original_component_update_ring: "fleet",
      component_update_mismatch: false,
      updater_last_check_at: "",
      enable_bulk_remove: null,
      original_enable_bulk_remove: null,
      pos_terminal_id: "",
      pos_api_url: "",
      pos_clerk_id: "",
      instamed_sso_alias: "",
      instamed_workstation_id: "",
      instamed_additional_info_6: "",
      pos_manual_entry_enabled: false,
      pos_manual_entry_button_enabled: false,
      pos_clover_go_enabled: false,
      paymentDevices: [getPaymentDeviceDefaults(PaymentGatewayTypes.GLOBAL_PAYMENTS)],
      locationWindows: null,
      selectedPaymentDeviceId: "",
      canManageColumnMappings: true,
      canManagePickupSwitching: false,
      pickupSwitching: defaultPickupSwitching(),
      columnMappings: [],
      userGroupType: null,
      validationErrors: {},
    };

    this.firstErrorRef = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleShowHideXWebIdSecrets = this.handleShowHideXWebIdSecrets.bind(
      this
    );
    this.handleShowHideXWebAuthKeySecrets = this.handleShowHideXWebAuthKeySecrets.bind(
      this
    );
    this.handleShowHideXWebTerminalIdSecrets = this.handleShowHideXWebTerminalIdSecrets.bind(
      this
    );
  }

  componentDidMount() {
    TransactionFilterObj.searchtext = '';
    TransactionFilterObj.searchObject = null;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.pageSize = 10;
    this.isCheckBoxHandler();
    this.getPaymentGateways();
    this.getCountryListWithRegion();
    this.setPermissions();
    this.loadFeatureEntitlements();
    fetch(process.env.REACT_APP_BASEURL + "accounts", {
      method: "GET",
      withCredentials: true,
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((accounts) => {
        const accountValues = accounts.map((account) => {
          return { value: account.id, label: account.name };
        });
        const accountPreAssignment =
          accounts[0] && accounts[0].is_pre_assignment;
        sessionStorage.setItem("is_pre_assignment", accountPreAssignment);
        if (accounts[0].connection.id === CONNECTION_TYPE.UNPLUGGED) { // for pre-assignment
          this.setState({ accountValues, isUnplugged: true })
        } else {
          this.setState({ accountValues });
        }
      });
    fetch(process.env.REACT_APP_BASEURL + "box-types", {
      method: "GET",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => response.json())
      .then((boxtypes) => {
        if (boxtypes) {
          const boxTypes = boxtypes.map((type) => {
            return { id: type.id, label: type.name };
          });
          this.setState({ boxTypes: boxTypes });
        }
      });
    fetch(process.env.REACT_APP_BASEURL + "roles", {
      method: "GET",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => response.json())
      .then((roleLookupValues) => this.setState({ roleLookupValues }));
  }

  fetchBoxForManage = async (boxId) => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    const response = await fetch(
      process.env.REACT_APP_BASEURL + `getBoxForManage/${boxId}`,
      {
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " + user.signInUserSession.idToken.jwtToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error("Failed to load location details");
    }
    return response.json();
  };

  getBoxLevelKioskHours = (selectedObject, boxId) => {
    const allKioskHours =
      (selectedObject &&
        (selectedObject.kiosk_hoursof_operations ||
          selectedObject.kiosk_hours_of_operations ||
          selectedObject.kiosk_hours_of_operation)) ||
      [];
    const normalizedBoxId = String(boxId || (selectedObject && selectedObject.id) || "");

    if (!Array.isArray(allKioskHours) || allKioskHours.length === 0) {
      return [];
    }

    const boxLevelHours = allKioskHours.filter((item) => {
      const hopType = String((item && item.hop_type) || "").toLowerCase();
      const isBoxLevel = hopType === "boxlevel" || hopType === "box_level";
      const itemBoxId = String((item && item.box_id) || "");
      return isBoxLevel && itemBoxId === normalizedBoxId;
    });

    if (boxLevelHours.length > 0) {
      return boxLevelHours;
    }

    return [];
  };

  refreshGrid = (deletedCount = 0) => {
    if (!this.gridApi) return;
    if (deletedCount > 0) {
      if (this.gridDatasource) this.gridDatasource.invalidateCache();
      this.gridApi.deselectAll();
      const pageSize = this.gridApi.paginationGetPageSize();
      const lastPage = Math.max(0, Math.ceil((this.state.totalRecords - deletedCount) / pageSize) - 1);
      if (this.gridApi.paginationGetCurrentPage() > lastPage) {
        this.gridApi.paginationGoToPage(lastPage);
      }
    }
    if (typeof this.gridApi.refreshServerSideStore === "function") {
      this.gridApi.refreshServerSideStore({ purge: true });
    } else if (typeof this.gridApi.refreshServerSide === "function") {
      this.gridApi.refreshServerSide({ purge: true });
    }
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    const datasource = createServerSideDatasource({
      filterBody: TransactionFilterObj,
      mapFilterModel: buildManageBoxesSearchObject,
      sortMap: TransactionSortObj,
      pageZeroBased: true,
      getPageSize: () => TransactionFilterObj.pageSize || 10,
      fetchPage: (body) =>
        fetch(process.env.REACT_APP_BASEURL + "getBoxes", {
          method: "post",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        }).then((response) => response.json()),
      onSuccess: (results, total) => {
        this.setState({
          data: results,
          totalRecords: total,
          loader: false,
          isDataEmpty: !results || results.length === 0,
          selected: [],
        });
      },
      onError: () => this.setState({ loader: false, selected: [] }),
    });
    this.gridDatasource = datasource;
    if (typeof params.api.setServerSideDatasource === "function") {
      params.api.setServerSideDatasource(datasource);
    }
  };

  clearFilters = () => {
    if (!this.gridApi) return;
    const filterModel = this.gridApi.getFilterModel();
    if (filterModel && Object.keys(filterModel).length > 0) {
      this.gridApi.setFilterModel(null);
    }
    TransactionFilterObj.searchObject = null;
    TransactionFilterObj.searchtext = "";
    this.setState({ searchtext: "" });
    this.refreshGrid();
  };

  onRowSelected = (params) => {
    if (!params || !params.api) return;
    let selectedNodes = params.api.getSelectedNodes() || [];
    if (!selectedNodes.length && typeof params.api.forEachNode === 'function') {
      const collected = [];
      params.api.forEachNode((node) => {
        if (node && node.isSelected()) collected.push(node);
      });
      selectedNodes = collected;
    }
    this.setState({
      selected: selectedNodes.map((n) => n.data && n.data.id).filter(Boolean),
    });
  };

  onPaginationChanged = (params) => {
    if (!params.api) return;
    const newPageSize = params.api.paginationGetPageSize();
    if (newPageSize && TransactionFilterObj.pageSize !== newPageSize) {
      TransactionFilterObj.pageSize = newPageSize;
    }
  };

  //Bind Boxes | Naresh Makwana
  BindBoxes() {
    if (this.gridApi) {
      this.refreshGrid();
      return;
    }
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "getBoxes", {
      method: "post",
      withCredentials: true,
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(TransactionFilterObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        this.setState({ totalRecords: uData && uData.total });
        if (uData && uData.results && uData.results.length > 0) {
          this.setState({
            data: uData && uData.results,
            loader: false,
            isDataEmpty: false,
          });
        } else {
          this.setState({ data: null, loader: false, isDataEmpty: true });
        }
      });
  }

  handleChangeRadio = (evt) => {
    let courier = this.state.selectCourierType;
    const index = courier.indexOf(this.state.selectedRadio);
    if (index > -1) {
      courier.splice(index, 1);
    }
    courier.push(evt);
    this.setState({ selectCourierType: courier, selectedRadio: evt }, () => {
      this.isCheckBoxHandler();
    });
  };

  selectDefaultHandler = (value) => {
    let courier = this.state.selectCourierType;
    const index = courier.indexOf(value);
    if (!(index > -1)) {
      courier.push(value);
    }
    this.setState({ selectCourierType: courier }, () => {
      this.isCheckBoxHandler();
    });
  };

  gettingOnSortTableName = (field) => {
    let tablename = "";
    if (["name", "description", "type"].includes(field)) {
      tablename = "boxes";
    }
    if (["city", "state"].includes(field)) {
      tablename = "addresses";
    }
    return tablename;
  };

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.order === "desc") {
      order = "asc";
    }
    this.setState({ order, orderBy, sortId: property });
    TransactionFilterObj.sortOrder = order;
    TransactionFilterObj.sortColumn = field;
    TransactionFilterObj.tableName = this.gettingOnSortTableName(orderBy);
    if (this.state.data && this.state.data.length > 0) {
      this.BindBoxes();
    }
  };

  handleSelectAllClick = (event) => {
    if (event.target.checked) {
      this.setState((state) => ({ selected: state.data.map((n) => n.id) }));
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const {selected} = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    TransactionFilterObj.pageNo = page;
    if (this.state.data && this.state.data.length > 0) {
      this.BindBoxes();
    }
  };

  handleChangeRowsPerPage = (event) => {
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.pageSize = event.target.value;
    if (this.state.data && this.state.data.length > 0) {
      this.BindBoxes();
    }
  };

  addBox = (event) => {
    this.setState({
      showNewBoxDialog: true,
      box: {},
      operation: "Add",
      pickupSwitching: defaultPickupSwitching(),
      payroll_deduct: false,
      pay_later_mode: PAY_LATER_MODES.DISABLED,
      name: "",
      branding_name: "",
      description: "",
      type: "",
      avatarPreview: null,
      manage_location_name: null,
      location_notes: '',
      parent_id: null,
      type_id: null,
      address1: null,
      address2: null,
      city: null,
      state: null,
      zip: null,
      status: "",
      TimevalidateDialog: false,
      Sun: false,
      Mon: false,
      Tue: false,
      Wed: false,
      Thu: false,
      Fri: false,
      Sat: false,
      pos: {},
      XWebAuthKey: "",
      XWebId: "",
      XWebTerminalId: "",
      pos_bridge_hostname: "",
      pos_bridge_port: 8080,
      pos_bridge_https_hostname: "",
      pos_bridge_https_port: 8443,
      pos_bridge_protocol: "http",
      pos_merchant_name: "",
      pos_merchant_site_id: "",
      pos_merchant_key: "",
      pos_software_name: "",
      pos_software_version: "",
      pos_terminal_id: "",
      pos_api_url: "",
      pos_clerk_id: "",
      instamed_sso_alias: "",
      instamed_workstation_id: "",
      instamed_additional_info_6: "",
      pos_manual_entry_enabled: false,
      pos_manual_entry_button_enabled: false,
      pos_clover_go_enabled: false,
      paymentType: PaymentGatewayTypes.GLOBAL_PAYMENTS,
      paymentDevices: [getPaymentDeviceDefaults(PaymentGatewayTypes.GLOBAL_PAYMENTS)],
      locationWindows: null,
      selectedPaymentDeviceId: "",
      maxtemp: "",
      setTemp: "",
      mintemp: "",
      selectedTab: 0,
      KioskHoursOfOperaionsArray: [
        {
          id: 0,
          value: this.props.t('Accounts.Branding.Sunday'),
          openTime: '',
          closeTime: '',
          isClosed: false,
          isOpenAll: true
        },
        {
          id: 1,
          value: this.props.t('Accounts.Branding.Monday'),
          openTime: '',
          closeTime: '',
          isClosed: false,
          isOpenAll: true
        },
        {
          id: 2,
          value: this.props.t('Accounts.Branding.Tuesday'),
          openTime: '',
          closeTime: '',
          isClosed: false,
          isOpenAll: true
        },
        {
          id: 3,
          value: this.props.t('Accounts.Branding.Wednesday'),
          openTime: '',
          closeTime: '',
          isClosed: false,
          isOpenAll: true
        },
        {
          id: 4,
          value: this.props.t('Accounts.Branding.Thursday'),
          openTime: '',
          closeTime: '',
          isClosed: false,
          isOpenAll: true
        },
        {
          id: 5,
          value: this.props.t('Accounts.Branding.Friday'),
          openTime: '',
          closeTime: '',
          isClosed: false,
          isOpenAll: true
        },
        {
          id: 6,
          value: this.props.t('Accounts.Branding.Saturday'),
          openTime: '',
          closeTime: '',
          isClosed: false,
          isOpenAll: true
        },
      ],
      lunchStart:'',
      lunchEnd:'',
      is_eseek: false,
      is_install_mode: false,
      is_strict_check:false,
      auto_release_on_id_scan: false,
      is_lifeboat_enabled: false,
      is_ecom_enabled: false,
      is_non_rx_deliver_enabled: false,
      is_pos: false,
      is_consult: false,
      is_dl_capture: false,
      is_kiosk_dob_enabled: true,
      is_kiosk_dob_camera_enabled: true,
      is_survey: false,
      is_partial_payment_enabled: false,
      enable_evaporator_temperature: false,
      strict_patient_verification: false,
      enable_trim: false,
      trim_chars: SearchUtils.defaultTrimChars,
      isGeneratingCode: false,
      validationErrors: {},
      enable_bulk_remove: null,
      original_enable_bulk_remove: null,
    });
  };

  deleteBoxes = (event) => {
    this.setState({ loader: true });
    const result = fetch(
      process.env.REACT_APP_BASEURL +
      "boxes/" +
      this.state.selected.join(",").trim(","),
      {
        method: "DELETE",
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
        },
      }
    );
    result
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((result) => {
        let isoccupy = JSON.parse(result);
        if (isoccupy.message) {
          this.setState({ loader: false, selected: [] });
          toast.error(isoccupy.message);
        } else if (isoccupy.res === true || isoccupy.res === "true") {
          this.setState({ loader: false, selected: [] });
          toast.error(this.props.t("Toast.Error.BoxItemRemove"));
        } else {
          this.setState({ loader: false });
          toast.success(this.props.t("Toast.Success.BoxRemove"));
          const deletedCount = this.state.selected.length;
          const newData = [];
          this.state.data.forEach((item) => {
            if (this.state.selected.indexOf(item.id) === -1) {
              newData.push(item);
            }
          });

          this.setState({
            data: JSON.parse(JSON.stringify(newData)),
            selected: [],
            selectedRowId: null,
          });
          this.refreshGrid(deletedCount);
        }
      });
  };

  handleColumnMappingsSaved = async () => {
    // Refresh the box data for the currently selected box to get updated column_mappings
    const selectedObject = this.state.data.find(
      (x) => x.id === this.state.selectedRowId
    );
    if (selectedObject && selectedObject.id) {
      try {
        const user = JSON.parse(sessionStorage.getItem('user'));
        if (user && user.signInUserSession && user.signInUserSession.idToken) {
          const response = await fetch(
            process.env.REACT_APP_BASEURL + `boxes/${selectedObject.id}`,
            {
              method: 'GET',
              headers: {
                Authorization: 'Bearer ' + user.signInUserSession.idToken.jwtToken,
              },
            }
          );
          const boxData = await response.json();
          if (boxData && boxData.length > 0 && boxData[0]) {
            const updatedBox = boxData[0];
            // Update the box in the data array
            const updatedData = this.state.data.map((box) =>
              box.id === updatedBox.id ? updatedBox : box
            );
            this.setState({ data: updatedData });
            // Update columnMappings in state if this box is currently being viewed
            if (this.state.selectedRowId === updatedBox.id) {
              this.setState({
                columnMappings: updatedBox.column_mappings || [],
              });
            }
          }
        }
      } catch (error) {
        console.error('Error refreshing box data after saving column mappings:', error);
      }
    }
  };

  handleClose = (event) => {
    this.setState({
      showNewBoxDialog: false,
      box: {},
      errorMessage: "",
      validationErrors: {},
      selectedTab: 0,
      isGeneratingCode: false,
    });
  };
  handleCloseTimeDialog = (event) => {
    this.setState({ TimevalidateDialog: false });
  };

  handleDrop = (acceptedFiles, rejectedFiles) => {
    this.setState({
      avatarPreview: acceptedFiles[0].preview,
      file: acceptedFiles,
    });
  };

  removeImg = () => {
    this.setState({ avatarPreview: null });
  };

  handleChange = async (event) => {
    if (event.preventDefault) event.preventDefault();
    const {box} = this.state;
    const fieldKey = event.target.id || event.target.name;
    const nextValue = event.target.value;
    const prevValue = fieldKey === "type_id" ? this.state.type_id : box[fieldKey];
    box[fieldKey] = nextValue;
    const validationErrorKey = fieldKey === "type_id" ? "box_type" : fieldKey;
    const rootConnectedAddonUnits =
      fieldKey === "type_id"
        ? (this.state.addonUnits || []).map((item) => {
            if (!item || item.connected_box_id !== prevValue) {
              return item;
            }

            return {
              ...item,
              connected_box_id: nextValue,
            };
          })
        : this.state.addonUnits;
    this.setState({
      ...box,
      boxTypeId: fieldKey === "type_id" ? nextValue : this.state.boxTypeId,
      addonUnits: rootConnectedAddonUnits,
      validationErrors: {
        ...(this.state.validationErrors || {}),
        [validationErrorKey]: "",
      },
    }, () => {
      if (fieldKey === "parent_id") {
        this.loadFeatureEntitlements(nextValue);
      }
    });
  };

  loadFeatureEntitlements = (accountId) => {
    fetchEntitlements({
      accountId: accountId || this.state.parent_id || undefined,
      boxId: accountId || this.state.parent_id ? undefined : getSelectedBoxId(),
    })
      .then((data) => {
        this.setState({ featureEntitlements: (data && data.entitlements) || [] });
      })
      .catch(() => {
        this.setState({ featureEntitlements: [] });
      });
  };

  getManageLocationOptions = (t) => [
    { id: 1, value: "Kiosk", label: t("Global.Patients.Type.Kiosk") },
    { id: 2, value: "Curbside", label: t("Login.CurbsideImageTitle") },
    { id: 3, value: "Counter", label: t("Login.CounterImageTitle") },
    { id: 4, value: "Courier", label: t("Login.CourierImageTitle") },
    { id: 6, value: "Bedside", label: t("Console.Bedside.BedsideTitle") },
    {
      id: 7,
      value: "Other",
      label: t("Report.Stocked.ManualOverride.Other"),
    },
  ].map((type) => {
    const locked = !isManageLocationTypeUsable(
      type.value,
      this.state.featureEntitlements
    );
    return {
      ...type,
      locked,
      featureKey: featureKeyForManageLocationName(type.value),
      label: locked
        ? `${type.label} (${t("Features.StatusLocked", { defaultValue: "Not enabled" })})`
        : type.label,
    };
  });

  isSelectedLocationTypeLicensed = () =>
    isManageLocationTypeUsable(
      this.state.manage_location_name,
      this.state.featureEntitlements
    );

  renderLocationTypeLicenseHelp = (t) => {
    if (this.isSelectedLocationTypeLicensed()) {
      return null;
    }
    const featureKey = featureKeyForManageLocationName(
      this.state.manage_location_name
    );
    if (!featureKey) {
      return null;
    }
    return (
      <FormHelperText error>
        {t("Location.Details.LicenseRequired", {
          defaultValue: "This location type is not enabled for this account.",
        })}{" "}
        <Link to={getFeatureLockedRedirectPath(featureKey)}>
          {t("Location.Details.LicenseLearnMore", { defaultValue: "Learn more" })}
        </Link>
      </FormHelperText>
    );
  };

  handleLocationType = (value) => {
    const locationTypeMap = {
      Kiosk: LOCATION_TYPE.Kiosk,
      Curbside: LOCATION_TYPE.Curbside,
      Counter: LOCATION_TYPE.Counter,
      Courier: LOCATION_TYPE.Courier,
      Other: LOCATION_TYPE.Other,
      Bedside: LOCATION_TYPE.Bedside,
    };
    this.setState({
      manage_location_name: value,
      location_type_id: locationTypeMap[value] || "",
      selectedTab: 0,
      validationErrors: {
        ...(this.state.validationErrors || {}),
        location_type: "",
      },
    });
  };

  handleTabChange = (event, value) => {
    this.setState({ selectedTab: value });
  };

  handleChangeIndex(index) {
    this.setState({ selectedTab: index });
  }
  handleOpentimeChange = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ opentime: event.target.value });
  };
  handleClosetimeChange = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ closetime: event.target.value });
  };
  handleBlurTime = (event) => {
    if (event.target.value > "23:59") {
      this.setState({ TimevalidateDialog: true });
    }
  };
  handleDaysChange = (value) => {
    if (value === "Sun") {
      this.setState({ Sun: !this.state.Sun });
    }
    if (value === "Mon") {
      this.setState({ Mon: !this.state.Mon });
    }
    if (value === "Tue") {
      this.setState({ Tue: !this.state.Tue });
    }
    if (value === "Wed") {
      this.setState({ Wed: !this.state.Wed });
    }
    if (value === "Thu") {
      this.setState({ Thu: !this.state.Thu });
    }
    if (value === "Fri") {
      this.setState({ Fri: !this.state.Fri });
    }
    if (value === "Sat") {
      this.setState({ Sat: !this.state.Sat });
    }
  };

  getTestDetails = async () => {
    const result = fetch(`${process.env.REACT_APP_BASEURL}test_result/${this.state.selectedRowId}`,
      {
        method: "get",
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
        },
      }
    );
    result
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((res) => {
        const parsedTestResults = res && res.map(item => JSON.parse(item.test_result));
        this.setState({
          test_details: parsedTestResults
        })
      });
  }

  createTestDetailsRow = () => {
    return this.state.test_details.length > 0 && this.state.test_details.map((val, idx) => (
      <TableRow key={idx}>
        <TableCell align="left">
          {convertToTimeZone(val.test_date)}
        </TableCell>
        <TableCell align="left">
        {val.hardwareTest}
        </TableCell>
        <TableCell align="left">
        {val.networkTest}
        </TableCell>
      </TableRow>
    ));
  };

  handleView = async (event) => {
    const boxId = this.state.selectedRowId;
    if (!boxId) {
      return;
    }
    this.setState({ loader: true });
    let selectedObject;
    try {
      selectedObject = await this.fetchBoxForManage(boxId);
    } catch (error) {
      this.setState({ loader: false });
      toast.error(this.props.t("Toast.Error.Generic") || "Failed to load location");
      return;
    }
    this.setState({ loader: false });
    if (selectedObject.location_type_id === LOCATION_TYPE.Kiosk) {
      this.setState({ manage_location_name: "Kiosk" });
    } else if (selectedObject.location_type_id === LOCATION_TYPE.Curbside) {
      this.setState({ manage_location_name: "Curbside" });
    } else if (selectedObject.location_type_id === LOCATION_TYPE.Counter) {
      this.setState({ manage_location_name: "Counter" });
    } else if (selectedObject.location_type_id === LOCATION_TYPE.Courier) {
      this.setState({ manage_location_name: "Courier" });
    } else if (selectedObject.location_type_id === LOCATION_TYPE.Other) {
      this.setState({ manage_location_name: "Other" });
    } else if (selectedObject.location_type_id === LOCATION_TYPE.Bedside) {
      this.setState({ manage_location_name: "Bedside" });
    }
    // else if(selectedObject.location_type_id === LOCATION_TYPE.Mail_Order){
    //   this.setState({manage_location_name: 'Mail Order'});
    // }
    if (selectedObject) {
      const selectedPaymentGateway =
        selectedObject.selected_payment_gateway === null ||
        selectedObject.selected_payment_gateway === "" ||
        selectedObject.selected_payment_gateway === "null" ||
        selectedObject.selected_payment_gateway === undefined ||
        selectedObject.selected_payment_gateway === "undefined"
          ? PaymentGatewayTypes.GLOBAL_PAYMENTS
          : selectedObject.selected_payment_gateway;
      const paymentDevices = this.normalizePaymentDevices(selectedObject, selectedPaymentGateway);
      const selectedPaymentDevice = paymentDevices.find(
        (device) => device.payment_gateway_id === selectedPaymentGateway
      ) || paymentDevices[0];
      this.setState({
        selectedTab: 0,
        showNewBoxDialog: true,
        operation: "View",
        locationWindowsBoxId: selectedObject.id,
        locationWindows: null,
        location_notes: selectedObject.location_notes,
        branding_name: storedText(selectedObject.branding_name),
        selectCourierType:
          selectedObject.courier_type && selectedObject.courier_type.length > 0
            ? selectedObject.courier_type[0].split(",")
            : [],
        name:
          selectedObject.name === "" ||
            selectedObject.name === "null" ||
            selectedObject.name === null ||
            selectedObject.name === undefined ||
            selectedObject.name === "undefined"
            ? ""
            : selectedObject.name,
        parent_id: selectedObject.parent_account_id,
        description:
          selectedObject.description === "" ||
            selectedObject.description === "null" ||
            selectedObject.description === null ||
            selectedObject.description === undefined
            ? ""
            : selectedObject.description,
        type_id:
          selectedObject.type && selectedObject.type.id
            ? selectedObject.type.id
            : null,
        avatarPreview: selectedObject.picture_url,
        address1:
          selectedObject.address &&
            (selectedObject.address.address_line_1 === "" ||
              selectedObject.address.address_line_1 === "null" ||
              selectedObject.address.address_line_1 === null ||
              selectedObject.address.address_line_1 === undefined ||
              selectedObject.address.address_line_1 === "undefined")
            ? ""
            : selectedObject.address.address_line_1,
        address2:
          selectedObject.address &&
            (selectedObject.address.address_line_2 === "" ||
              selectedObject.address.address_line_2 === "null" ||
              selectedObject.address.address_line_2 === null ||
              selectedObject.address.address_line_2 === undefined ||
              selectedObject.address.address_line_2 === "undefined")
            ? ""
            : selectedObject.address.address_line_2,
        zip:
          selectedObject.address &&
            (selectedObject.address.zip === "" ||
              selectedObject.address.zip === "null" ||
              selectedObject.address.zip === null ||
              selectedObject.address.zip === undefined ||
              selectedObject.address.zip === "undefined")
            ? ""
            : selectedObject.address.zip,
        state:
          selectedObject.address &&
            (selectedObject.address.state === "" ||
              selectedObject.address.state === "null" ||
              selectedObject.address.state === null ||
              selectedObject.address.state === undefined ||
              selectedObject.address.state === "undefined")
            ? ""
            : selectedObject.address.state,
        city:
          selectedObject.address &&
            (selectedObject.address.city === "" ||
              selectedObject.address.city === "null" ||
              selectedObject.address.city === null ||
              selectedObject.address.city === undefined ||
              selectedObject.address.city === "undefined")
            ? ""
            : selectedObject.address.city,
        status:
          selectedObject.boxstatus &&
            (selectedObject.boxstatus === "" ||
              selectedObject.boxstatus === "null" ||
              selectedObject.boxstatus === null ||
              selectedObject.boxstatus === undefined ||
              selectedObject.boxstatus === "undefined")
            ? ""
            : selectedObject.boxstatus,
        kiosk_box_id:
          selectedObject.kiosk_box_id === "null" ||
            selectedObject.kiosk_box_id === null ||
            selectedObject.kiosk_box_id === undefined ||
            selectedObject.kiosk_box_id === "undefined"
            ? ""
            : selectedObject.kiosk_box_id,
        kiosk_version_current: selectedObject.kiosk_version_current || "",
        kiosk_version_available: selectedObject.kiosk_version_available || "",
        original_kiosk_version_available: selectedObject.kiosk_version_available || "",
        engine_version_current: selectedObject.engine_version_current || "",
        engine_version_target: selectedObject.engine_version_target || "",
        original_engine_version_target: selectedObject.engine_version_target || "",
        wrapper_version_current: selectedObject.wrapper_version_current || "",
        wrapper_version_target: selectedObject.wrapper_version_target || "",
        original_wrapper_version_target: selectedObject.wrapper_version_target || "",
        pos_bridge_version_current: selectedObject.pos_bridge_version_current || "",
        pos_bridge_version_target: selectedObject.pos_bridge_version_target || "",
        original_pos_bridge_version_target: selectedObject.pos_bridge_version_target || "",
        component_update_paused: Boolean(selectedObject.component_update_paused),
        original_component_update_paused: Boolean(selectedObject.component_update_paused),
        component_update_ring: selectedObject.component_update_ring || "fleet",
        original_component_update_ring: selectedObject.component_update_ring || "fleet",
        component_update_mismatch: Boolean(selectedObject.component_update_mismatch),
        updater_last_check_at: selectedObject.updater_last_check_at || "",
        enable_bulk_remove: kioskFlagValue(selectedObject.enable_bulk_remove),
        original_enable_bulk_remove: kioskFlagValue(selectedObject.enable_bulk_remove),
        columnMappings:
          selectedObject.column_mappings && Array.isArray(selectedObject.column_mappings)
            ? selectedObject.column_mappings
            : [],
        pickupSwitching: normalizePickupSwitching(selectedObject.pickup_switching),
        IsActive:
          selectedObject.IsActive !== "" &&
            selectedObject.IsActive !== "null" &&
            selectedObject.IsActive !== null &&
            selectedObject.IsActive !== undefined &&
            selectedObject.IsActive !== "undefined"
            ? selectedObject.IsActive
            : "",
        XWebId:
          selectedObject.xwebid === null ||
            selectedObject.xwebid === "" ||
            selectedObject.xwebid === "null" ||
            selectedObject.xwebid === "" ||
            selectedObject.xwebid === "null" ||
            selectedObject.xwebid === null ||
            selectedObject.xwebid === undefined ||
            selectedObject.xwebid === "undefined"
            ? ""
            : selectedObject.xwebid,
        XWebAuthKey:
          selectedObject.xwebauthkey === null ||
            selectedObject.xwebauthkey === "" ||
            selectedObject.xwebauthkey === "null" ||
            selectedObject.xwebauthkey === "" ||
            selectedObject.xwebauthkey === "null" ||
            selectedObject.xwebauthkey === null ||
            selectedObject.xwebauthkey === undefined ||
            selectedObject.xwebauthkey === "undefined"
            ? ""
            : selectedObject.xwebauthkey,
        XWebTerminalId:
          selectedObject.xwebterminalid === null ||
            selectedObject.xwebterminalid === "" ||
            selectedObject.xwebterminalid === "null" ||
            selectedObject.xwebterminalid === "" ||
            selectedObject.xwebterminalid === "null" ||
            selectedObject.xwebterminalid === null ||
            selectedObject.xwebterminalid === undefined ||
            selectedObject.xwebterminalid === "undefined"
            ? ""
            : selectedObject.xwebterminalid,
        addonUnits: selectedObject && selectedObject.box_expansions,
        is_marketplace:
          selectedObject.is_marketplace !== "" &&
            selectedObject.is_marketplace !== "null" &&
            selectedObject.is_marketplace !== null &&
            selectedObject.is_marketplace !== undefined &&
            selectedObject.is_marketplace !== "undefined"
            ? selectedObject.is_marketplace
            : "",
        simpleOrExpressUI: !selectedObject.simple_start,
        express_ui:
          selectedObject.express_ui !== "" &&
          selectedObject.express_ui !== "null" &&
          selectedObject.express_ui !== null &&
          selectedObject.express_ui !== undefined &&
          selectedObject.express_ui !== "undefined" &&
          selectedObject.express_ui &&
          true,
        SimplifiedEnrollment:
          selectedObject.simplified_enrollment !== "" &&
            selectedObject.simplified_enrollment !== "null" &&
            selectedObject.simplified_enrollment !== null &&
            selectedObject.simplified_enrollment !== undefined &&
            selectedObject.simplified_enrollment !== "undefined"
            ? selectedObject.simplified_enrollment
            : "",
        paymentType: selectedPaymentGateway,
        paymentDevices,
        selectedPaymentDeviceId: selectedPaymentDevice && getPaymentDeviceUiId(selectedPaymentDevice),
        selected_regioin:
          selectedObject.selected_regioin === null ||
            selectedObject.selected_regioin === "" ||
            selectedObject.selected_regioin === "null" ||
            selectedObject.selected_regioin === "" ||
            selectedObject.selected_regioin === "null" ||
            selectedObject.selected_regioin === null ||
            selectedObject.selected_regioin === undefined ||
            selectedObject.selected_regioin === "undefined"
            ? ""
            : selectedObject.selected_regioin,
        preferLanguage: selectedObject && selectedObject.preferred_language,
        door_open_debounce_interval:
          selectedObject && selectedObject.door_open_debounce_interval,
        door_interval_between_two_bins:
          selectedObject && selectedObject.door_interval_between_two_bins,
        boxTypeId: selectedObject && selectedObject.type_id,
        allow_multi_bins_pickup:
          selectedObject && selectedObject.allow_multi_bins_pickup,
        openpath: selectedObject.openpath,
        payroll_deduct: isPayLaterEnabledForMode(
          normalizePayLaterMode(
            selectedObject && selectedObject.pay_later_mode,
            selectedObject && selectedObject.payroll_deduct
          )
        ),
        pay_later_mode: normalizePayLaterMode(
          selectedObject && selectedObject.pay_later_mode,
          selectedObject && selectedObject.payroll_deduct
        ),
        openPathUser: selectedObject && selectedObject.openpathuser,
        is_eseek: selectedObject && selectedObject.is_eseek,
        external_id: selectedObject && selectedObject.external_id,
        is_strict_check: selectedObject && selectedObject.is_strict_check,
        auto_release_on_id_scan:
          (selectedObject && selectedObject.auto_release_on_id_scan) || false,
        is_lifeboat_enabled: selectedObject && selectedObject.is_lifeboat_enabled,
        is_ecom_enabled: selectedObject && selectedObject.is_ecom_enabled,
        is_non_rx_deliver_enabled: selectedObject && selectedObject.is_non_rx_deliver_enabled,
        is_pos: selectedObject && selectedObject.is_pos,
        is_consult: selectedObject && selectedObject.is_consult,
        is_dl_capture: selectedObject && selectedObject.is_dl_capture,
        is_kiosk_dob_enabled:
          selectedObject && selectedObject.is_kiosk_dob_enabled !== undefined
            ? selectedObject.is_kiosk_dob_enabled
            : true,
        is_kiosk_dob_camera_enabled:
          selectedObject && selectedObject.is_kiosk_dob_camera_enabled !== undefined
            ? selectedObject.is_kiosk_dob_camera_enabled
            : true,
        is_survey: selectedObject && selectedObject.is_survey,
        is_partial_payment_enabled: selectedObject && selectedObject.is_partial_payment_enabled,
        binoccupancy_check: selectedObject && selectedObject.binoccupancy_check,
        show_request_assistance: selectedObject && selectedObject.show_request_assistance,
        enable_evaporator_temperature: selectedObject && selectedObject.enable_evaporator_temperature,
        strict_patient_verification: selectedObject && selectedObject.strict_patient_verification,
        enable_trim: selectedObject && selectedObject.enable_trim !== undefined ? selectedObject.enable_trim : false,
        trim_chars: selectedObject && typeof selectedObject.trim_chars === "string" ? selectedObject.trim_chars : SearchUtils.defaultTrimChars,
        pos_bridge_hostname: selectedObject && selectedObject.pos_bridge_hostname ? selectedObject.pos_bridge_hostname : "",
        pos_bridge_port: selectedObject && selectedObject.pos_bridge_port ? selectedObject.pos_bridge_port : 8080,
        pos_bridge_https_hostname: selectedObject && selectedObject.pos_bridge_https_hostname ? selectedObject.pos_bridge_https_hostname : "",
        pos_bridge_https_port: selectedObject && selectedObject.pos_bridge_https_port ? selectedObject.pos_bridge_https_port : 8443,
        pos_bridge_protocol: selectedObject && selectedObject.pos_bridge_protocol ? selectedObject.pos_bridge_protocol : "http",
        pos_merchant_name: selectedObject && selectedObject.pos_merchant_name ? selectedObject.pos_merchant_name : "",
        pos_merchant_site_id: selectedObject && selectedObject.pos_merchant_site_id ? selectedObject.pos_merchant_site_id : "",
        pos_merchant_key: selectedObject && selectedObject.pos_merchant_key ? selectedObject.pos_merchant_key : "",
        pos_software_name: selectedObject && selectedObject.pos_software_name ? selectedObject.pos_software_name : "",
        pos_software_version: selectedObject && selectedObject.pos_software_version ? selectedObject.pos_software_version : "",
        pos_terminal_id: selectedObject && selectedObject.pos_terminal_id ? selectedObject.pos_terminal_id : "",
        pos_api_url: selectedObject && selectedObject.pos_api_url ? selectedObject.pos_api_url : "",
        pos_clerk_id: selectedObject && selectedObject.pos_clerk_id ? selectedObject.pos_clerk_id : "",
        instamed_sso_alias: selectedObject && selectedObject.instamed_sso_alias ? selectedObject.instamed_sso_alias : "",
        instamed_workstation_id: selectedObject && selectedObject.instamed_workstation_id ? selectedObject.instamed_workstation_id : "",
        instamed_additional_info_6: selectedObject && selectedObject.instamed_additional_info_6 ? selectedObject.instamed_additional_info_6 : "",
        pos_manual_entry_enabled:
          selectedObject && selectedObject.pos_manual_entry_enabled !== undefined
            ? selectedObject.pos_manual_entry_enabled
            : false,
        pos_manual_entry_button_enabled:
          selectedObject && selectedObject.pos_manual_entry_button_enabled !== undefined
            ? selectedObject.pos_manual_entry_button_enabled
            : false,
        pos_clover_go_enabled:
          selectedObject && selectedObject.pos_clover_go_enabled !== undefined
            ? selectedObject.pos_clover_go_enabled
            : false,
        ...this.getPaymentDeviceStateValues(selectedPaymentDevice),
        location_type_id: selectedObject && selectedObject.location_type_id ? selectedObject.location_type_id : "",
      });

      const _kiosk_hoursof_operations = this.getBoxLevelKioskHours(
        selectedObject,
        boxId
      );
      this.setState({
        lunchStart:_kiosk_hoursof_operations[0] && _kiosk_hoursof_operations[0].lunch_start,
        lunchEnd:_kiosk_hoursof_operations[0] && _kiosk_hoursof_operations[0].lunch_end,
      })
      const KioskHOPObject = await this.convertAccountHoursOfOperationsObject(_kiosk_hoursof_operations[0]);
      const KioskHoursOfOperations = await this.hanldeAccountHoursOfOperations(KioskHOPObject);
      await this.getTestDetails()
      if (KioskHoursOfOperations && KioskHoursOfOperations.length && KioskHoursOfOperations.length > 0) {
        this.setState({ KioskHoursOfOperaionsArray: KioskHoursOfOperations });
      } else {
        this.setState({
          KioskHoursOfOperaionsArray: this.state.KioksDummyHoursOfOperaionsArray,
        });
      }
    }
    this.handleContextClose(event);
  };

  handleEdit = async (event) => {
    const boxId = this.state.selectedRowId;
    if (!boxId) {
      return;
    }
    this.setState({ loader: true });
    let selectedObject;
    try {
      selectedObject = await this.fetchBoxForManage(boxId);
    } catch (error) {
      this.setState({ loader: false });
      toast.error(this.props.t("Toast.Error.Generic") || "Failed to load location");
      return;
    }
    this.setState({ loader: false });
    if (selectedObject.location_type_id === LOCATION_TYPE.Kiosk) {
      this.setState({ manage_location_name: "Kiosk" });
    } else if (selectedObject.location_type_id === LOCATION_TYPE.Curbside) {
      this.setState({ manage_location_name: "Curbside" });
    } else if (selectedObject.location_type_id === LOCATION_TYPE.Counter) {
      this.setState({ manage_location_name: "Counter" });
    } else if (selectedObject.location_type_id === LOCATION_TYPE.Courier) {
      this.setState({ manage_location_name: "Courier" });
    } else if (selectedObject.location_type_id === LOCATION_TYPE.Other) {
      this.setState({ manage_location_name: "Other" });
    } else if (selectedObject.location_type_id === LOCATION_TYPE.Bedside) {
      this.setState({ manage_location_name: "Bedside" });
    }
    // else if(selectedObject.location_type_id === LOCATION_TYPE.Mail_Order){
    //   this.setState({manage_location_name: 'Mail Order'});
    // }
    const selectedPaymentGateway =
      selectedObject.selected_payment_gateway === null ||
      selectedObject.selected_payment_gateway === "" ||
      selectedObject.selected_payment_gateway === "null" ||
      selectedObject.selected_payment_gateway === undefined ||
      selectedObject.selected_payment_gateway === "undefined"
        ? PaymentGatewayTypes.GLOBAL_PAYMENTS
        : selectedObject.selected_payment_gateway;
    const paymentDevices = this.normalizePaymentDevices(selectedObject, selectedPaymentGateway);
    const selectedPaymentDevice = paymentDevices.find(
      (device) => device.payment_gateway_id === selectedPaymentGateway
    ) || paymentDevices[0];
    this.setState(
      {
        selectedTab: 0,
        showNewBoxDialog: true,
        operation: "Edit",
        locationWindowsBoxId: selectedObject.id,
        locationWindows: null,
        box: selectedObject,
        selectedRadio:
          selectedObject.courier_type && selectedObject.courier_type.length > 0
            ? selectedObject.courier_type[0].default_courier_type
            : [],
        selectCourierType:
          selectedObject.courier_type && selectedObject.courier_type.length > 0
            ? selectedObject.courier_type.map((val) => {
              return val.courier_type;
            })
            : [],
        location_notes: selectedObject.location_notes,
        branding_name: storedText(selectedObject.branding_name),
        name:
          selectedObject.name === null ||
            selectedObject.name === "null" ||
            selectedObject.name === "" ||
            selectedObject.name === undefined ||
            selectedObject.name === "undefined"
            ? ""
            : selectedObject.name,
        parent_id: selectedObject.parent_account_id,
        description:
          selectedObject.description === "" ||
            selectedObject.description === "null" ||
            selectedObject.description === null ||
            selectedObject.description === undefined
            ? ""
            : selectedObject.description,
        type_id:
          selectedObject.type && selectedObject.type.id
            ? selectedObject.type.id
            : null,
        avatarPreview: selectedObject.picture_url,
        address1:
          selectedObject.address &&
            (selectedObject.address.address_line_1 === "" ||
              selectedObject.address.address_line_1 === "null" ||
              selectedObject.address.address_line_1 === null ||
              selectedObject.address.address_line_1 === undefined ||
              selectedObject.address.address_line_1 === "undefined")
            ? ""
            : selectedObject.address.address_line_1,
        address2:
          selectedObject.address &&
            (selectedObject.address.address_line_2 === "" ||
              selectedObject.address.address_line_2 === "null" ||
              selectedObject.address.address_line_2 === null ||
              selectedObject.address.address_line_2 === undefined ||
              selectedObject.address.address_line_2 === "undefined")
            ? ""
            : selectedObject.address.address_line_2,
        zip:
          selectedObject.address &&
            (selectedObject.address.zip === "" ||
              selectedObject.address.zip === "null" ||
              selectedObject.address.zip === null ||
              selectedObject.address.zip === undefined ||
              selectedObject.address.zip === "undefined")
            ? ""
            : selectedObject.address.zip,
        state:
          selectedObject.address &&
            (selectedObject.address.state === "" ||
              selectedObject.address.state === "null" ||
              selectedObject.address.state === null ||
              selectedObject.address.state === undefined ||
              selectedObject.address.state === "undefined")
            ? ""
            : selectedObject.address.state,
        city:
          selectedObject.address &&
            (selectedObject.address.city === "" ||
              selectedObject.address.city === "null" ||
              selectedObject.address.city === null ||
              selectedObject.address.city === undefined ||
              selectedObject.address.city === "undefined")
            ? ""
            : selectedObject.address.city,
        status:
          selectedObject.boxstatus &&
            (selectedObject.boxstatus === "" ||
              selectedObject.boxstatus === "null" ||
              selectedObject.boxstatus === null ||
              selectedObject.boxstatus === undefined ||
              selectedObject.boxstatus === "undefined")
            ? ""
            : selectedObject.boxstatus,
        kiosk_box_id:
          selectedObject.kiosk_box_id === "null" ||
            selectedObject.kiosk_box_id === null ||
            selectedObject.kiosk_box_id === undefined ||
            selectedObject.kiosk_box_id === "undefined"
            ? ""
            : selectedObject.kiosk_box_id,
        kiosk_version_current: selectedObject.kiosk_version_current || "",
        kiosk_version_available: selectedObject.kiosk_version_available || "",
        original_kiosk_version_available: selectedObject.kiosk_version_available || "",
        engine_version_current: selectedObject.engine_version_current || "",
        engine_version_target: selectedObject.engine_version_target || "",
        original_engine_version_target: selectedObject.engine_version_target || "",
        wrapper_version_current: selectedObject.wrapper_version_current || "",
        wrapper_version_target: selectedObject.wrapper_version_target || "",
        original_wrapper_version_target: selectedObject.wrapper_version_target || "",
        pos_bridge_version_current: selectedObject.pos_bridge_version_current || "",
        pos_bridge_version_target: selectedObject.pos_bridge_version_target || "",
        original_pos_bridge_version_target: selectedObject.pos_bridge_version_target || "",
        component_update_paused: Boolean(selectedObject.component_update_paused),
        original_component_update_paused: Boolean(selectedObject.component_update_paused),
        component_update_ring: selectedObject.component_update_ring || "fleet",
        original_component_update_ring: selectedObject.component_update_ring || "fleet",
        component_update_mismatch: Boolean(selectedObject.component_update_mismatch),
        updater_last_check_at: selectedObject.updater_last_check_at || "",
        enable_bulk_remove: kioskFlagValue(selectedObject.enable_bulk_remove),
        original_enable_bulk_remove: kioskFlagValue(selectedObject.enable_bulk_remove),
        columnMappings:
          selectedObject.column_mappings && Array.isArray(selectedObject.column_mappings)
            ? selectedObject.column_mappings
            : [],
        pickupSwitching: normalizePickupSwitching(selectedObject.pickup_switching),
        IsActive:
          selectedObject.IsActive !== "" &&
            selectedObject.IsActive !== "null" &&
            selectedObject.IsActive !== null &&
            selectedObject.IsActive !== undefined &&
            selectedObject.IsActive !== "undefined"
            ? selectedObject.IsActive
            : "",
        XWebId:
          selectedObject.xwebid === null ||
            selectedObject.xwebid === "" ||
            selectedObject.xwebid === "null" ||
            selectedObject.xwebid === "" ||
            selectedObject.xwebid === "null" ||
            selectedObject.xwebid === null ||
            selectedObject.xwebid === undefined ||
            selectedObject.xwebid === "undefined"
            ? ""
            : selectedObject.xwebid,
        XWebAuthKey:
          selectedObject.xwebauthkey === null ||
            selectedObject.xwebauthkey === "" ||
            selectedObject.xwebauthkey === "null" ||
            selectedObject.xwebauthkey === "" ||
            selectedObject.xwebauthkey === "null" ||
            selectedObject.xwebauthkey === null ||
            selectedObject.xwebauthkey === undefined ||
            selectedObject.xwebauthkey === "undefined"
            ? ""
            : selectedObject.xwebauthkey,
        XWebTerminalId:
          selectedObject.xwebterminalid === null ||
            selectedObject.xwebterminalid === "" ||
            selectedObject.xwebterminalid === "null" ||
            selectedObject.xwebterminalid === "" ||
            selectedObject.xwebterminalid === "null" ||
            selectedObject.xwebterminalid === null ||
            selectedObject.xwebterminalid === undefined ||
            selectedObject.xwebterminalid === "undefined"
            ? ""
            : selectedObject.xwebterminalid,
        addonUnits: selectedObject && selectedObject.box_expansions,
        is_marketplace:
          selectedObject.is_marketplace !== "" &&
            selectedObject.is_marketplace !== "null" &&
            selectedObject.is_marketplace !== null &&
            selectedObject.is_marketplace !== undefined &&
            selectedObject.is_marketplace !== "undefined"
            ? selectedObject.is_marketplace
            : "",
        simpleOrExpressUI: !selectedObject.simple_start,
        SimplifiedEnrollment:
          selectedObject.simplified_enrollment !== "" &&
            selectedObject.simplified_enrollment !== "null" &&
            selectedObject.simplified_enrollment !== null &&
            selectedObject.simplified_enrollment !== undefined &&
            selectedObject.simplified_enrollment !== "undefined"
            ? selectedObject.simplified_enrollment
            : "",
        paymentType: selectedPaymentGateway,
        paymentDevices,
        selectedPaymentDeviceId: selectedPaymentDevice && getPaymentDeviceUiId(selectedPaymentDevice),
        selected_regioin:
          selectedObject.selected_regioin === null ||
            selectedObject.selected_regioin === "" ||
            selectedObject.selected_regioin === "null" ||
            selectedObject.selected_regioin === "" ||
            selectedObject.selected_regioin === "null" ||
            selectedObject.selected_regioin === null ||
            selectedObject.selected_regioin === undefined ||
            selectedObject.selected_regioin === "undefined"
            ? ""
            : selectedObject.selected_regioin,
        preferLanguage: selectedObject && selectedObject.preferred_language,
        door_open_debounce_interval:
          selectedObject && selectedObject.door_open_debounce_interval,
        door_interval_between_two_bins:
          selectedObject && selectedObject.door_interval_between_two_bins,
        boxTypeId: selectedObject && selectedObject.type_id,
        allow_multi_bins_pickup:
          selectedObject && selectedObject.allow_multi_bins_pickup,
        openpath: selectedObject.openpath,
        OpenPathEmailId: selectedObject.openpathemail,
        OpenPathPassword: selectedObject.openpathpassword,
        payroll_deduct: isPayLaterEnabledForMode(
          normalizePayLaterMode(
            selectedObject && selectedObject.pay_later_mode,
            selectedObject && selectedObject.payroll_deduct
          )
        ),
        pay_later_mode: normalizePayLaterMode(
          selectedObject && selectedObject.pay_later_mode,
          selectedObject && selectedObject.payroll_deduct
        ),
        openPathUser: selectedObject && selectedObject.openpathuser,
        is_eseek: selectedObject && selectedObject.is_eseek,
        external_id: selectedObject && selectedObject.external_id,
        is_strict_check: selectedObject && selectedObject.is_strict_check,
        auto_release_on_id_scan:
          (selectedObject && selectedObject.auto_release_on_id_scan) || false,
        is_lifeboat_enabled: selectedObject && selectedObject.is_lifeboat_enabled,
        is_ecom_enabled: selectedObject && selectedObject.is_ecom_enabled,
        is_non_rx_deliver_enabled: selectedObject && selectedObject.is_non_rx_deliver_enabled,
        is_pos: selectedObject && selectedObject.is_pos,
        is_consult: selectedObject && selectedObject.is_consult,
        is_dl_capture: selectedObject && selectedObject.is_dl_capture,
        is_kiosk_dob_enabled:
          selectedObject && selectedObject.is_kiosk_dob_enabled !== undefined
            ? selectedObject.is_kiosk_dob_enabled
            : true,
        is_kiosk_dob_camera_enabled:
          selectedObject && selectedObject.is_kiosk_dob_camera_enabled !== undefined
            ? selectedObject.is_kiosk_dob_camera_enabled
            : true,
        is_survey: selectedObject && selectedObject.is_survey,
        is_partial_payment_enabled: selectedObject && selectedObject.is_partial_payment_enabled,
        binoccupancy_check: selectedObject && selectedObject.binoccupancy_check,
        show_request_assistance: selectedObject && selectedObject.show_request_assistance,
        enable_evaporator_temperature: selectedObject && selectedObject.enable_evaporator_temperature,
        strict_patient_verification: selectedObject && selectedObject.strict_patient_verification,
        enable_trim: selectedObject && selectedObject.enable_trim !== undefined ? selectedObject.enable_trim : false,
        trim_chars: selectedObject && typeof selectedObject.trim_chars === "string" ? selectedObject.trim_chars : SearchUtils.defaultTrimChars,
        pos_bridge_hostname: selectedObject && selectedObject.pos_bridge_hostname ? selectedObject.pos_bridge_hostname : "",
        pos_bridge_port: selectedObject && selectedObject.pos_bridge_port ? selectedObject.pos_bridge_port : 8080,
        pos_bridge_https_hostname: selectedObject && selectedObject.pos_bridge_https_hostname ? selectedObject.pos_bridge_https_hostname : "",
        pos_bridge_https_port: selectedObject && selectedObject.pos_bridge_https_port ? selectedObject.pos_bridge_https_port : 8443,
        pos_bridge_protocol: selectedObject && selectedObject.pos_bridge_protocol ? selectedObject.pos_bridge_protocol : "http",
        pos_merchant_name: selectedObject && selectedObject.pos_merchant_name ? selectedObject.pos_merchant_name : "",
        pos_merchant_site_id: selectedObject && selectedObject.pos_merchant_site_id ? selectedObject.pos_merchant_site_id : "",
        pos_merchant_key: selectedObject && selectedObject.pos_merchant_key ? selectedObject.pos_merchant_key : "",
        pos_software_name: selectedObject && selectedObject.pos_software_name ? selectedObject.pos_software_name : "",
        pos_software_version: selectedObject && selectedObject.pos_software_version ? selectedObject.pos_software_version : "",
        pos_terminal_id: selectedObject && selectedObject.pos_terminal_id ? selectedObject.pos_terminal_id : "",
        pos_api_url: selectedObject && selectedObject.pos_api_url ? selectedObject.pos_api_url : "",
        pos_clerk_id: selectedObject && selectedObject.pos_clerk_id ? selectedObject.pos_clerk_id : "",
        instamed_sso_alias: selectedObject && selectedObject.instamed_sso_alias ? selectedObject.instamed_sso_alias : "",
        instamed_workstation_id: selectedObject && selectedObject.instamed_workstation_id ? selectedObject.instamed_workstation_id : "",
        instamed_additional_info_6: selectedObject && selectedObject.instamed_additional_info_6 ? selectedObject.instamed_additional_info_6 : "",
        pos_manual_entry_enabled:
          selectedObject && selectedObject.pos_manual_entry_enabled !== undefined
            ? selectedObject.pos_manual_entry_enabled
            : false,
        pos_manual_entry_button_enabled:
          selectedObject && selectedObject.pos_manual_entry_button_enabled !== undefined
            ? selectedObject.pos_manual_entry_button_enabled
            : false,
        pos_clover_go_enabled:
          selectedObject && selectedObject.pos_clover_go_enabled !== undefined
            ? selectedObject.pos_clover_go_enabled
            : false,
        ...this.getPaymentDeviceStateValues(selectedPaymentDevice),
        location_type_id: selectedObject && selectedObject.location_type_id ? selectedObject.location_type_id : "",
      },
      () => {
        this.isCheckBoxHandler();
      }
    );
    this.handleContextClose(event);
    if ([true, "true"].includes(selectedObject.openpath)) {
      this.getOpenPathUser(
        selectedObject.openpathemail,
        selectedObject.openpathpassword
      );
    } else {
      this.setState({ openPathUserList: [] });
    }
    const _kiosk_hoursof_operations = this.getBoxLevelKioskHours(
      selectedObject,
      boxId
    );
    this.setState({
      lunchStart:_kiosk_hoursof_operations[0] && _kiosk_hoursof_operations[0].lunch_start,
      lunchEnd:_kiosk_hoursof_operations[0] && _kiosk_hoursof_operations[0].lunch_end,
    })
    const KioskHOPObject = await this.convertAccountHoursOfOperationsObject(_kiosk_hoursof_operations[0]);
    const KioskHoursOfOperations = await this.hanldeAccountHoursOfOperations(KioskHOPObject);
    if (KioskHoursOfOperations && KioskHoursOfOperations.length && KioskHoursOfOperations.length > 0) {
      this.setState({ KioskHoursOfOperaionsArray: KioskHoursOfOperations });
    } else {
      this.setState({
        KioskHoursOfOperaionsArray: this.state.KioksDummyHoursOfOperaionsArray,
      });
    }
  };

  confirmDelete = (event) => {
    // this.forDeletion
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: this.state.data.filter(
          (x) => x.id === this.state.selectedRowId
        ),
      });
    } else {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: this.state.data.filter(
          (x) => this.state.selected.indexOf(x.id) > -1
        ),
      });
    }
  };

  handleSearchChange = (event) => {
    let searchtxt = "";
    searchtxt = event.target.value;
    this.setState({ searchtext: event.target.value });
    TransactionFilterObj.sortOrder = "desc";
    TransactionFilterObj.sortColumn = "created_on";
    TransactionFilterObj.tableName = "";
    TransactionFilterObj.pageNo = 0;
    if (searchtxt.length >= 3) {
      TransactionFilterObj.searchtext = searchtxt;
      this.BindBoxes();
    } else if (searchtxt.length === 0) {
      TransactionFilterObj.searchtext = "";
      this.BindBoxes();
    }
  };

  deleteConfirmClose = (event) => {
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
      this.handleContextClose(event);
    } else {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
    }
  };

  deleteConfirmed = (event) => {
    if (this.state.selectedRowId) {
      this.handleDelete(event);
    } else {
      this.deleteBoxes();
    }
    this.setState({ deleteDialogOpen: false });
  };

  handleDelete = (event) => {
    this.setState({ loader: true });
    const rowIdToDelete = this.state.selectedRowId;
    const result = fetch(
      process.env.REACT_APP_BASEURL + "boxes/" + rowIdToDelete,
      {
        method: "DELETE",
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
        },
      }
    );
    result
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((result) => {
        let isoccupy = JSON.parse(result);
        if (isoccupy.message) {
          this.setState({ loader: false, selected: [] });
          toast.error(isoccupy.message);
        } else if (isoccupy.res === true || isoccupy.res === "true") {
          this.setState({ loader: false, selected: [] });
          toast.error(this.props.t("Toast.Error.BoxItemRemove"));
        } else {
          this.setState({ loader: false });
          toast.success(this.props.t("Toast.Success.BoxRemove"));
          this.handleContextClose(event);
          const newData = this.state.data.filter((x) => x.id !== rowIdToDelete);

          this.setState({
            data: JSON.parse(JSON.stringify(newData)),
            selected: [],
            selectedRowId: null,
          });
          this.refreshGrid(1);
          this.handleContextClose(event);
        }
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ loader: true, isButtonDisabled: true });
    const selectedLocationTypeId = this.state.location_type_id;
    const isKioskLocationType = selectedLocationTypeId === LOCATION_TYPE.Kiosk;

    // Client-side validation for Add Location: prevent empty form submission and preAssignmentBoxes 500
    if (this.state.operation === "Add") {
      const {t} = this.props;
      const empty = (v) =>
        [undefined, "undefined", null, "null", ""].includes(v) ||
        (typeof v === "string" && v.trim() === "");
      const validationErrors = {};
      if (empty(this.state.parent_id)) {
        validationErrors.parent_id = t("Validation.Location.ParentAccountRequired");
      }
      if (empty(this.state.manage_location_name)) {
        validationErrors.location_type = t("Validation.Location.LocationTypeRequired");
      } else if (!this.isSelectedLocationTypeLicensed()) {
        validationErrors.location_type = t("Location.Details.LicenseRequired", {
          defaultValue: "This location type is not enabled for this account.",
        });
      }
      if (isKioskLocationType && empty(this.state.type_id)) {
        validationErrors.box_type = t("Validation.Location.BoxTypeRequired");
      }
      if (empty(this.state.name)) {
        validationErrors.name = t("Validation.Location.LocationNameRequired");
      }
      if (empty(this.state.address1)) {
        validationErrors.address1 = t("Validation.EnterAddressLine");
      }
      if (empty(this.state.city)) {
        validationErrors.city = t("Validation.EnterCity");
      }
      if (empty(this.state.state)) {
        validationErrors.state = t("Validation.EnterState");
      }
      if (empty(this.state.zip)) {
        validationErrors.zip = t("Validation.zip");
      }
      const errorKeys = Object.keys(validationErrors);
      if (errorKeys.length > 0) {
        this.setState({ loader: false, isButtonDisabled: false, errorMessage: "", validationErrors }, () => {
          this.firstErrorRef.current && this.firstErrorRef.current.scrollIntoView && this.firstErrorRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
        });
        return;
      }
      this.setState({ errorMessage: "", validationErrors: {} });
    }

    const count = this.getAddonUnitsCount();
    if (count > 300) {
      this.setState({ isInsufficientBin: true });
    } else {
      const paymentDeviceSubmission = this.getSelectedPaymentDeviceSubmissionValues();
      var input = document.querySelector('input[type="file"]');
      var data = new FormData();
      data.append("file", input.files[0]);
      data.append("parent_account_id", this.state.parent_id);
      data.append("name", this.state.name);
      data.append("branding_name", this.state.branding_name || "");
      data.append("description", this.state.description);
      data.append("type_id", this.state.type_id);
      data.append("address_line_1", this.state.address1);
      data.append("address_line_2", this.state.address2);
      data.append("city", this.state.city);
      data.append("state", this.state.state);
      data.append("zip", this.state.zip);
      data.append("box_expansions", JSON.stringify(this.state.addonUnits));
      data.append("IsActive", this.state.IsActive);
      data.append(
        "kiosk_box_id",
        this.state.kiosk_box_id === "" ? "" : this.state.kiosk_box_id
      );
      data.append("Sunday", this.state.Sun);
      data.append("Monday", this.state.Mon);
      data.append("Tuesday", this.state.Tue);
      data.append("Wednesday", this.state.Wed);
      data.append("Thursday", this.state.Thu);
      data.append("Friday", this.state.Fri);
      data.append("Saturday", this.state.Sat);
      data.append("OpenTime", this.state.opentime);
      data.append("CloseTime", this.state.closetime);
      data.append("HopType", "BoxLevel");
      data.append("courier_type", this.state.selectCourierType);
      data.append("default_courier_type", this.state.selectedRadio);
      data.append("xwebid", paymentDeviceSubmission.XWebId || "");
      data.append("xwebauthkey", paymentDeviceSubmission.XWebAuthKey || "");
      data.append("xwebterminalid", paymentDeviceSubmission.XWebTerminalId || "");
      data.append("pos_merchant_name", paymentDeviceSubmission.pos_merchant_name || "");
      data.append("pos_merchant_site_id", paymentDeviceSubmission.pos_merchant_site_id || "");
      data.append("pos_merchant_key", paymentDeviceSubmission.pos_merchant_key || "");
      data.append("pos_software_name", paymentDeviceSubmission.pos_software_name || "");
      data.append("pos_software_version", paymentDeviceSubmission.pos_software_version || "");
      data.append("pos_terminal_id", paymentDeviceSubmission.pos_terminal_id || "");
      data.append("pos_api_url", paymentDeviceSubmission.pos_api_url || "");
      data.append("pos_clerk_id", paymentDeviceSubmission.pos_clerk_id || "");
      data.append("instamed_sso_alias", paymentDeviceSubmission.instamed_sso_alias || "");
      data.append("instamed_workstation_id", paymentDeviceSubmission.instamed_workstation_id || "");
      data.append("instamed_additional_info_6", paymentDeviceSubmission.instamed_additional_info_6 || "");
      data.append(
        "pos_manual_entry_enabled",
        paymentDeviceSubmission.pos_manual_entry_enabled
      );
      data.append(
        "pos_manual_entry_button_enabled",
        paymentDeviceSubmission.pos_manual_entry_button_enabled
      );
      data.append("pos_clover_go_enabled", paymentDeviceSubmission.pos_clover_go_enabled);
      data.append("payment_devices", paymentDeviceSubmission.payment_devices);
      data.append("location_notes", this.state.location_notes);
      data.append("is_marketplace", this.state.is_marketplace);
      data.append("SimpleStart", this.state.simpleOrExpressUI ? false : true);
      data.append("express_ui", this.state.simpleOrExpressUI ? true : false);
      data.append("SimplifiedEnrollment", this.state.SimplifiedEnrollment);
      data.append("openpath", this.state.openpath);
      data.append("openpathemail", this.state.OpenPathEmailId);
      data.append("openpathpassword", this.state.OpenPathPassword);
      data.append("selected_payment_gateway", this.state.paymentType);
      if (this.state.manage_location_name === "Kiosk") {
        data.append("location_type_id", LOCATION_TYPE.Kiosk);
      } else if (this.state.manage_location_name === "Curbside") {
        data.append("location_type_id", LOCATION_TYPE.Curbside);
      } else if (this.state.manage_location_name === "Counter") {
        data.append("location_type_id", LOCATION_TYPE.Counter);
      } else if (this.state.manage_location_name === "Courier") {
        data.append("location_type_id", LOCATION_TYPE.Courier);
      } else if (this.state.manage_location_name === "Other") {
        data.append("location_type_id", LOCATION_TYPE.Other);
      } else if (this.state.manage_location_name === "Bedside") {
        data.append("location_type_id", LOCATION_TYPE.Bedside);
      }
      data.append("selected_regioin", this.state.selected_regioin);
      data.append("preferredlanguage", this.state.preferLanguage);
      data.append(
        "door_open_debounce_interval",
        this.state.door_open_debounce_interval
      );
      data.append(
        "door_interval_between_two_bins",
        this.state.door_interval_between_two_bins
      );
      data.append(
        "allow_multi_bins_pickup",
        this.state && this.state.allow_multi_bins_pickup
      );
      data.append('payroll_deduct', isPayLaterEnabledForMode(this.state.pay_later_mode));
      data.append('pay_later_mode', this.state.pay_later_mode || PAY_LATER_MODES.DISABLED);
      data.append('openpathuser', this.state.openPathUser);
      data.append('kiosk_hoursof_operations', JSON.stringify(this.state.KioskHoursOfOperaionsArray));
      data.append('lunch_start',this.state.lunchStart);
      data.append('lunch_end',this.state.lunchEnd);
      data.append('is_eseek',this.state.is_eseek);
      data.append('is_install_mode',this.state.is_install_mode);
      data.append('external_id',this.state.external_id);
      data.append('is_strict_check',this.state.is_strict_check);
      data.append('auto_release_on_id_scan',this.state.auto_release_on_id_scan);
      data.append('is_lifeboat_enabled',this.state.is_lifeboat_enabled);
      data.append('is_ecom_enabled',this.state.is_ecom_enabled);
      data.append('is_non_rx_deliver_enabled',this.state.is_non_rx_deliver_enabled);
      data.append('is_pos',this.state.is_pos);
      data.append('is_consult',this.state.is_consult);
      data.append('is_dl_capture',this.state.is_dl_capture);
      data.append('is_kiosk_dob_enabled', this.state.is_kiosk_dob_enabled);
      data.append('is_kiosk_dob_camera_enabled', this.state.is_kiosk_dob_camera_enabled);
      data.append('is_survey',this.state.is_survey);
      data.append('is_partial_payment_enabled',this.state.is_partial_payment_enabled);
      data.append('binoccupancy_check',this.state.binoccupancy_check);
      data.append('show_request_assistance', this.state.show_request_assistance);
      data.append('enable_evaporator_temperature', this.state.enable_evaporator_temperature);
      data.append(
        'pickup_switching',
        JSON.stringify(normalizePickupSwitching(this.state.pickupSwitching))
      );
      data.append('strict_patient_verification', this.state.strict_patient_verification);
      data.append('enable_trim', this.state.enable_trim);
      data.append('trim_chars', this.state.trim_chars != null ? this.state.trim_chars : SearchUtils.defaultTrimChars);
      data.append("pos_bridge_hostname", paymentDeviceSubmission.pos_bridge_hostname || "");
      data.append("pos_bridge_port", paymentDeviceSubmission.pos_bridge_port || 8080);
      data.append("pos_bridge_https_hostname", paymentDeviceSubmission.pos_bridge_https_hostname || "");
      data.append("pos_bridge_https_port", paymentDeviceSubmission.pos_bridge_https_port || 8443);
      data.append("pos_bridge_protocol", paymentDeviceSubmission.pos_bridge_protocol || "http");
      const result = fetch(process.env.REACT_APP_BASEURL + "boxes", {
        method: "POST",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
        },
        body: data,
      });
      result
        .then((result) => {
          result.json().then((res) => {
            this.setState({ loader: false });
            const apiErrorMessage = getApiErrorMessage(res);
            if (apiErrorMessage) {
              this.setState({ isButtonDisabled: false });
              toast.error(apiErrorMessage);
            } else {
              this.setState({
                isButtonDisabled: false,
                showNewBoxDialog: false,
                box: {},
                avatarPreview: null,
                errorMessage: "",
                kiosk_box_id: "",
                Sun: false,
                Mon: false,
                Tue: false,
                Wed: false,
                Thu: false,
                Fri: false,
                Sat: false,
                searchtext: "",
              });
              addonUnitsCount = 46;
              TransactionFilterObj.searchtext = "";
              TransactionFilterObj.sortOrder = "desc";
              TransactionFilterObj.sortColumn = "created_on";
              TransactionFilterObj.tableName = "";
              this.BindBoxes();
              if (res.save_outcome === 'partial') toast.warn('Some location settings were not saved: ' + (res.failed_sections || []).join(', '));
              else toast.success(this.props.t("Toast.Success.BoxAdded"));
              setTimeout(() => {
                this.syncPreAssignmentMatrix(res);
              }, 20);
            }
          });
        })
        .catch((error) => {
          this.setState({ loader: false });
          this.setState({ isButtonDisabled: false });
          toast.error(error && error.message ? error.message : "Failed to save box.");
        });
    }
  };

  getAddonUnitsCount = () => {
    const addonUnits = this.state.addonUnits;
    addonUnitsCount = 46;
    addonUnits.map((item) => {
      let boxType = item && item.boxes_type && item.boxes_type.name;
      let expansionId = item && item.expansion_id;
      if (
        boxType === "Cool (Temp controlled with 8 bins)" ||
        expansionId === BOX_TYPE.Cool
      ) {
        addonUnitsCount = addonUnitsCount + 8;
      } else if (
        boxType === "HD36 (Locker add on with 36 bins)" ||
        expansionId === BOX_TYPE.HD36
      ) {
        addonUnitsCount = addonUnitsCount + 36;
      } else if (
        boxType === "L60 (Locker Addon with 60 bins)" ||
        expansionId === BOX_TYPE.L60
      ) {
        addonUnitsCount = addonUnitsCount + 60;
      } else if (
        boxType === "C30 (C30 with 30 bins)" ||
        expansionId === BOX_TYPE.C30
      ) {
        addonUnitsCount = addonUnitsCount + 30;
      } else if (
        boxType === "Cool12(Temp controlled with 12 bins)" ||
        expansionId === BOX_TYPE.COOL_12
      ) {
        addonUnitsCount = addonUnitsCount + 12;
      } else if (
        boxType === "A12 (12 bins)" ||
        expansionId === BOX_TYPE.A12
      ) {
        addonUnitsCount = addonUnitsCount + 12;
      } else if (
        boxType === "V12 (12 bins)" ||
        expansionId === BOX_TYPE.V12
      ) {
        addonUnitsCount = addonUnitsCount + 12;
      } else if (
        boxType === "C28 (C28 with 28 bins)" ||
        expansionId === BOX_TYPE.C28
      ) {
        addonUnitsCount = addonUnitsCount + 28;
      } else if (
        boxType === "HD33 (Locker add on with 33 bins)" ||
        expansionId === BOX_TYPE.HD33
      ) {
        addonUnitsCount = addonUnitsCount + 33;
      }
      return true;
    });
    return addonUnitsCount;
  };
  handleChangeHandler = (value) => {
    this.setState({ location_notes: value });
  };
  duplicateComPorts(data) {
    const comPorts = new Set();
    for (const item of data) {
      if (comPorts.has(item.com_port)) {
        return true;
      }
      comPorts.add(item.com_port);
    }
    return false;
  }
  handleLocationWindowsChange = locationWindows => this.setState({ locationWindows });

  handleUpdate = (event) => {
    event.preventDefault();
    const windows = this.state.locationWindows;
    const canSaveWindows = windows && windows.boxId === this.state.box.id && !windows.loading && !windows.error && windows.available;
    if (windows && windows.dirty && !canSaveWindows) {
      toast.error("Window edits could not be saved. Reload windows before saving those edits.");
      return;
    }
    this.setState({ loader: true });
    const count = this.getAddonUnitsCount();
    const coolUnits = this.state.addonUnits && this.state.addonUnits.filter((unit) => [BOX_TYPE.Cool, BOX_TYPE.COOL_12].includes(unit.expansion_id))
    const isDuplicatePorts = this.duplicateComPorts(coolUnits)
    this.setState({ isButtonDisabled: true });
    if (count > 300) {
      this.setState({ isInsufficientBin: true });
    } else if(isDuplicatePorts){
      this.setState({loader:false,isButtonDisabled:false})
      toast.error("Cool Units have same port.");
    } else {
      const paymentDeviceSubmission = this.getSelectedPaymentDeviceSubmissionValues();
      const paymentDevicesAtSave = this.state.paymentDevices;
      var data = new FormData();

      let input = document.querySelector('input[type="file"]');
      if (input && input.files && input.files.length > 0) {
        data.append('file', input.files[0]);
      } else if (this.state.avatarPreview === null) {
        data.append('file', '');
      } else {
        data.append('file', this.state.box.picture_url);
      }
      
      data.append("id", this.state.box.id);
      data.append("parent_account_id", this.state.parent_id);
      data.append("name", this.state.name);
      data.append("branding_name", this.state.branding_name || "");
      data.append("description", this.state.description);
      data.append("type_id", this.state.type_id);
      data.append("address_line_1", this.state.address1);
      data.append("address_line_2", this.state.address2);
      data.append("city", this.state.city);
      data.append("state", this.state.state);
      data.append("zip", this.state.zip);
      data.append("boxId", this.state.box.id);
      data.append("box_expansions", JSON.stringify(this.state.addonUnits));
      data.append("IsActive", this.state.IsActive);
      data.append(
        "kiosk_box_id",
        this.state.kiosk_box_id === "" ? "" : this.state.kiosk_box_id
      );
      data.append("Sunday", this.state.Sun);
      data.append("Monday", this.state.Mon);
      data.append("Tuesday", this.state.Tue);
      data.append("Wednesday", this.state.Wed);
      data.append("Thursday", this.state.Thu);
      data.append("Friday", this.state.Fri);
      data.append("Saturday", this.state.Sat);
      data.append("OpenTime", this.state.opentime);
      data.append("CloseTime", this.state.closetime);
      data.append("HopType", "BoxLevel");
      data.append("xwebid", paymentDeviceSubmission.XWebId || "");
      data.append("xwebauthkey", paymentDeviceSubmission.XWebAuthKey || "");
      data.append("xwebterminalid", paymentDeviceSubmission.XWebTerminalId || "");
      data.append("pos_merchant_name", paymentDeviceSubmission.pos_merchant_name || "");
      data.append("pos_merchant_site_id", paymentDeviceSubmission.pos_merchant_site_id || "");
      data.append("pos_merchant_key", paymentDeviceSubmission.pos_merchant_key || "");
      data.append("pos_software_name", paymentDeviceSubmission.pos_software_name || "");
      data.append("pos_software_version", paymentDeviceSubmission.pos_software_version || "");
      data.append("pos_terminal_id", paymentDeviceSubmission.pos_terminal_id || "");
      data.append("pos_api_url", paymentDeviceSubmission.pos_api_url || "");
      data.append("pos_clerk_id", paymentDeviceSubmission.pos_clerk_id || "");
      data.append("instamed_sso_alias", paymentDeviceSubmission.instamed_sso_alias || "");
      data.append("instamed_workstation_id", paymentDeviceSubmission.instamed_workstation_id || "");
      data.append("instamed_additional_info_6", paymentDeviceSubmission.instamed_additional_info_6 || "");
      data.append(
        "pos_manual_entry_enabled",
        paymentDeviceSubmission.pos_manual_entry_enabled
      );
      data.append(
        "pos_manual_entry_button_enabled",
        paymentDeviceSubmission.pos_manual_entry_button_enabled
      );
      data.append("pos_clover_go_enabled", paymentDeviceSubmission.pos_clover_go_enabled);
      data.append("payment_devices", paymentDeviceSubmission.payment_devices);
      if (canSaveWindows) {
        data.append("location_windows", JSON.stringify({
          revision: windows.revision,
          windows: windows.windows.map(row => {
            const index = (this.state.paymentDevices || []).findIndex(device => getPaymentDeviceUiId(device) === row.default_payment_device_id);
            return row.is_active && index >= 0 ? { ...row, default_payment_device_index: index } : row;
          }),
        }));
      }
      data.append("location_notes", this.state.location_notes);
      data.append("courier_type", this.state.selectCourierType);
      data.append("default_courier_type", this.state.selectedRadio);
      data.append("SimpleStart", this.state.simpleOrExpressUI ? false : true);
      data.append("express_ui", this.state.simpleOrExpressUI ? true : false);
      data.append("SimplifiedEnrollment", this.state.SimplifiedEnrollment);
      data.append("openpath", this.state.openpath);
      data.append("openpathemail", this.state.OpenPathEmailId);
      data.append("openpathpassword", this.state.OpenPathPassword);
      data.append("selected_payment_gateway", this.state.paymentType);
      if (this.state.manage_location_name === "Kiosk") {
        data.append("location_type_id", LOCATION_TYPE.Kiosk);
      } else if (this.state.manage_location_name === "Curbside") {
        data.append("location_type_id", LOCATION_TYPE.Curbside);
      } else if (this.state.manage_location_name === "Counter") {
        data.append("location_type_id", LOCATION_TYPE.Counter);
      } else if (this.state.manage_location_name === "Courier") {
        data.append("location_type_id", LOCATION_TYPE.Courier);
      } else if (this.state.manage_location_name === "Other") {
        data.append("location_type_id", LOCATION_TYPE.Other);
      } else if (this.state.manage_location_name === "Bedside") {
        data.append("location_type_id", LOCATION_TYPE.Bedside);
      }
      data.append("is_marketplace", this.state.is_marketplace);
      data.append("selected_regioin", this.state.selected_regioin);
      data.append("preferredlanguage", this.state.preferLanguage);
      data.append(
        "door_open_debounce_interval",
        this.state.door_open_debounce_interval
      );
      data.append(
        "door_interval_between_two_bins",
        this.state.door_interval_between_two_bins
      );
      data.append(
        "allow_multi_bins_pickup",
        this.state && this.state.allow_multi_bins_pickup
      );
      data.append('payroll_deduct', isPayLaterEnabledForMode(this.state.pay_later_mode));
      data.append('pay_later_mode', this.state.pay_later_mode || PAY_LATER_MODES.DISABLED);
      data.append('openpathuser', this.state.openPathUser);
      data.append('kiosk_hoursof_operations', JSON.stringify(this.state.KioskHoursOfOperaionsArray));
      data.append('selected_location_id', localStorage.getItem('selectedLocation'));
      data.append('lunch_start',this.state.lunchStart);
      data.append('lunch_end',this.state.lunchEnd);
      data.append('is_eseek',this.state.is_eseek);
      data.append('is_install_mode',this.state.is_install_mode);
      data.append('external_id',this.state.external_id);
      data.append('is_strict_check',this.state.is_strict_check);
      data.append('auto_release_on_id_scan',this.state.auto_release_on_id_scan);
      data.append('is_lifeboat_enabled',this.state.is_lifeboat_enabled);
      data.append('is_ecom_enabled',this.state.is_ecom_enabled);
      data.append('is_non_rx_deliver_enabled',this.state.is_non_rx_deliver_enabled);
      data.append('is_pos',this.state.is_pos);
      data.append('is_consult',this.state.is_consult);
      data.append('is_dl_capture',this.state.is_dl_capture);
      data.append('is_kiosk_dob_enabled', this.state.is_kiosk_dob_enabled);
      data.append('is_kiosk_dob_camera_enabled', this.state.is_kiosk_dob_camera_enabled);
      data.append('is_survey',this.state.is_survey);
      data.append('is_partial_payment_enabled',this.state.is_partial_payment_enabled);
      data.append('binoccupancy_check',this.state.binoccupancy_check);
      data.append('show_request_assistance', this.state.show_request_assistance);
      data.append('enable_evaporator_temperature',this.state.enable_evaporator_temperature);
      data.append(
        'pickup_switching',
        JSON.stringify(normalizePickupSwitching(this.state.pickupSwitching))
      );
      data.append('strict_patient_verification',this.state.strict_patient_verification);
      data.append('enable_trim', this.state.enable_trim);
      data.append('trim_chars', this.state.trim_chars != null ? this.state.trim_chars : SearchUtils.defaultTrimChars);
      data.append("pos_bridge_hostname", paymentDeviceSubmission.pos_bridge_hostname || "");
      data.append("pos_bridge_port", paymentDeviceSubmission.pos_bridge_port || 8080);
      data.append("pos_bridge_https_hostname", paymentDeviceSubmission.pos_bridge_https_hostname || "");
      data.append("pos_bridge_https_port", paymentDeviceSubmission.pos_bridge_https_port || 8443);
      data.append("pos_bridge_protocol", paymentDeviceSubmission.pos_bridge_protocol || "http");
      const result = fetch(process.env.REACT_APP_BASEURL + "boxes", {
        method: "PUT",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
        },
        body: data,
      });
      result
        .then((result) => {
          result.json().then(async (res) => {
            const committedWindows = res.location_windows || (res.box && res.box.location_windows);
            if (committedWindows) {
              const savedDevices = committedWindows.payment_devices;
              const devicePatch = {};
              // Reconcile newly persisted device IDs without replacing edits made during the request.
              if (paymentDevicesAtSave && this.state.paymentDevices === paymentDevicesAtSave && savedDevices && savedDevices.length === paymentDevicesAtSave.length) {
                const selectedIndex = paymentDevicesAtSave.findIndex(device => getPaymentDeviceUiId(device) === this.state.selectedPaymentDeviceId);
                devicePatch.paymentDevices = paymentDevicesAtSave.map((device, index) => ({ ...device, id: savedDevices[index].id }));
                if (selectedIndex >= 0) devicePatch.selectedPaymentDeviceId = savedDevices[selectedIndex].id;
              }
              this.setState({ ...devicePatch, locationWindows: { ...committedWindows, boxId: this.state.box.id,
                originalWindows: committedWindows.windows, dirty: false, loading: false } });
            }
            const apiErrorMessage = getApiErrorMessage(res);
            if (apiErrorMessage) {
              this.setState({
                loader: false,
                isButtonDisabled: false,
              });
              toast.error(apiErrorMessage);
              return;
            }
            try {
              await this.updateKioskTargetVersion();
              await this.updateNativeComponentTargets();
              await this.updateKioskFlags();
            } catch (versionError) {
              this.setState({
                loader: false,
                isButtonDisabled: false,
              });
              toast.error(
                versionError && versionError.message
                  ? versionError.message
                  : "Failed to update kiosk target version."
              );
              return;
            }
            TransactionFilterObj.searchtext = "";
            TransactionFilterObj.sortOrder = "desc";
            TransactionFilterObj.sortColumn = "created_on";
            TransactionFilterObj.tableName = "";
            if(res && res.box && res.box.id) {
              let preferredLocationArray = res.box.preferredLocation;
              if(preferredLocationArray.length > 0) {
                const filteredLocations = preferredLocationArray.filter((x) => x.selected_location_id === this.state.box.id)[0];
                const localSelectedLocationId = localStorage.getItem('selectedLocation')
                if(![undefined, undefined, null, null, ''].includes(filteredLocations)) {
                  if(filteredLocations.selected_location_id === localSelectedLocationId) {
                    localStorage.setItem('selected_location_name', filteredLocations.selected_location_name );
                  }
                }
              }
            }
            this.BindBoxes();
            this.setState({
              loader: false,
              isButtonDisabled: false,
              showNewBoxDialog: false,
              box: {},
              avatarPreview: null,
              errorMessage: "",
              Sun: false,
              Mon: false,
              Tue: false,
              Wed: false,
              Thu: false,
              Fri: false,
              Sat: false,
              searchtext: "",
            });
            addonUnitsCount = 46;
            if (res.save_outcome === 'partial') toast.warn('Some location settings were not saved: ' + (res.failed_sections || []).join(', '));
            else toast.success(this.props.t("Toast.Success.BoxUpdated"));
            setTimeout(() => {
              this.syncPreAssignmentMatrix(res);
            }, 20);
          });
        })
        .catch((error) => {
          this.setState({ loader: false });
          this.setState({ isButtonDisabled: false });
          toast.error(
            error && error.message ? error.message : "Failed to update box."
          );
        });
    }
  };

  addonConfigClose = () => {
    this.setState({ isInsufficientBin: false, isButtonDisabled: false });
  };

  isSelected = (id) => this.state.selected.indexOf(id) !== -1;

  handleContextClick = (event, id, onReady) => {
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    // Avoid setState when opening ⋮ menu — full page re-render causes flicker.
    if (typeof onReady === 'function') {
      // Intentional: skip setState so opening ⋮ does not re-render the page.
      // eslint-disable-next-line react/no-direct-mutation-state
      this.state.selectedRowId = id;
      onReady();
      return;
    }
    this.setState({ selectedRowId: id });
  };

  handleContextClose = (event) => {
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    this.setState({ selectedRowId: null });
  };

  openRowActionsMenu = (event, params, menuHelpers) => {
    const rowId = params && params.data && params.data.id;
    const openMenu = () => {
      const items = this.getContextMenuItems({
        ...params,
        column: params.column,
        node: params.node,
        value: params.value,
      });
      if (menuHelpers && typeof menuHelpers.openMenu === 'function') {
        menuHelpers.openMenu(items);
        return;
      }
      openAgGridContextMenu(params, (menuHelpers && menuHelpers.positionEvent) || event);
    };
    this.handleContextClick(event, rowId, openMenu);
  };

  getContextMenuItems = (params) => {
    const colId =
      params &&
      params.column &&
      (params.column.getColId ? params.column.getColId() : params.column.colId);
    if (colId !== "actions") {
      return [];
    }
    const {t} = this.props;
    const row = params.node && params.node.data;
    if (!row) {
      return [];
    }
    const isIlocalUser = localStorage.getItem("isIlocalUser");
    const boxTypeId = row.type_id || (row.type && row.type.id);
    const isGoliath =
      row.location_type_id === LOCATION_TYPE.Kiosk &&
      boxTypeId === BOX_TYPE.FASTLANEGOLIATH;
    const items = [];
    if (this.state.boxview === true) {
      items.push(actionMenuItem({
        name: t("Location.ViewActions"),
        icon: "view",
        action: () => this.handleView(),
      }));
    }
    if (this.state.boxedit === true) {
      items.push(actionMenuItem({
        name: t("Location.EditActions"),
        icon: "edit",
        action: () => this.handleEdit(),
      }));
    }
    if ([true, "true"].includes(isIlocalUser)) {
      items.push(actionMenuItem({
        name: t("Location.CloneActions"),
        icon: "clone",
        action: () => this.handleOpenCloneDialog(),
      }));
    }
    if (this.state.boxdelete === true) {
      items.push(actionMenuItem({
        name: t("Location.DeleteActions"),
        icon: "delete",
        action: () => this.confirmDelete(),
      }));
    }
    if (isGoliath) {
      items.push(actionMenuItem({
        name: t("Location.BinOrderMappings") || "Bin Order Mappings",
        icon: "mapping",
        action: () => this.handleBinOrderMappings(),
      }));
      items.push(actionMenuItem({
        name: t("Location.BinMovementHistory") || "Bin Movement History",
        icon: "history",
        action: () => this.handleBinMovementHistory(),
      }));
    }
    return items;
  };

  handleBinOrderMappings = () => {
    const selectedRow = (this.state.data || []).find(
      (x) => x.id === this.state.selectedRowId
    );
    const boxId = selectedRow && selectedRow.id;
    const boxName = (selectedRow && selectedRow.name) || "";
    const query = new URLSearchParams();
    if (boxId) {
      query.set("boxId", boxId);
    }
    if (boxName) {
      query.set("boxName", boxName);
    }
    const queryString = query.toString();
    navigate(
      `/home/manage/locations/bin-order-mappings${
        queryString ? `?${queryString}` : ""
      }`
    );
    this.setState({ anchorEl: null, selectedRowId: null });
  };

  handleBinMovementHistory = () => {
    const selectedRow = (this.state.data || []).find(
      (x) => x.id === this.state.selectedRowId
    );
    const boxId = selectedRow && selectedRow.id;
    const boxName = (selectedRow && selectedRow.name) || "";
    const query = new URLSearchParams();
    if (boxId) {
      query.set("boxId", boxId);
    }
    if (boxName) {
      query.set("boxName", boxName);
    }
    const queryString = query.toString();
    navigate(
      `/home/manage/locations/bin-movement-history${
        queryString ? `?${queryString}` : ""
      }`
    );
    this.setState({ anchorEl: null, selectedRowId: null });
  };

  handleKioskBoxIDChangeEvent = (event) => {
    event.persist();
    this.setState({ kiosk_box_id: event.target.value });
  };

  updateKioskTargetVersion = async () => {
    const isIlocalUser = [true, "true"].includes(localStorage.getItem("isIlocalUser"));
    const isKioskType =
      this.state.manage_location_name === "Kiosk" ||
      this.state.location_type_id === LOCATION_TYPE.Kiosk;

    if (!isIlocalUser || !isKioskType) {
      return { success: true, skipped: true };
    }

    if (
      this.state.kiosk_version_available ===
      this.state.original_kiosk_version_available
    ) {
      return { success: true, skipped: true };
    }

    const boxId =
      (this.state.box && this.state.box.id) || this.state.kiosk_box_id;
    if (!boxId) {
      throw new Error("Box id is required to update kiosk target version.");
    }

    const token = JSON.parse(sessionStorage.getItem("user")).signInUserSession
      .idToken.jwtToken;
    const response = await fetch(
      `${process.env.REACT_APP_BASEURL}api/v2/box/${encodeURIComponent(boxId)}/version`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          availableVersion: this.state.kiosk_version_available,
        }),
      }
    );

    const result = await response.json();
    if (!response.ok || !result.success) {
      throw new Error(
        (result && result.message) ||
          "Failed to update kiosk target version."
      );
    }

    return result;
  };

  nativeComponentAuthHeaders = () => {
    const token = JSON.parse(sessionStorage.getItem("user")).signInUserSession
      .idToken.jwtToken;
    return {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
  };

  updateNativeComponentTargets = async () => {
    const isIlocalUser = [true, "true"].includes(localStorage.getItem("isIlocalUser"));
    const isKioskType =
      this.state.manage_location_name === "Kiosk" ||
      this.state.location_type_id === LOCATION_TYPE.Kiosk;
    if (!isIlocalUser || !isKioskType) {
      return { success: true, skipped: true };
    }

    const boxId =
      (this.state.box && this.state.box.id) || this.state.kiosk_box_id;
    if (!boxId) {
      throw new Error("Box id is required to update native component targets.");
    }

    const headers = this.nativeComponentAuthHeaders();
    const base = `${process.env.REACT_APP_BASEURL}api/v2/box/${encodeURIComponent(boxId)}/component-updates`;
    const post = async (path, body) => {
      const response = await fetch(`${base}${path}`, {
        method: "POST",
        headers,
        body: JSON.stringify(body),
      });
      const result = await response.json();
      if (!response.ok || !result.success) {
        throw new Error(
          (result && result.message) || "Failed to update native component settings."
        );
      }
      return result;
    };

    if (
      this.state.engine_version_target !== this.state.original_engine_version_target ||
      this.state.pos_bridge_version_target !== this.state.original_pos_bridge_version_target ||
      this.state.wrapper_version_target !== this.state.original_wrapper_version_target
    ) {
      await post("/targets", {
        engineVersionTarget: this.state.engine_version_target || null,
        posBridgeVersionTarget: this.state.pos_bridge_version_target || null,
        wrapperVersionTarget: this.state.wrapper_version_target || null,
      });
    }
    if (this.state.component_update_paused !== this.state.original_component_update_paused) {
      await post("/pause", { paused: Boolean(this.state.component_update_paused) });
    }
    if (this.state.component_update_ring !== this.state.original_component_update_ring) {
      await post("/ring", { ring: this.state.component_update_ring || "fleet" });
    }
    return { success: true };
  };

  updateKioskFlags = async () => {
    const isIlocalUser = [true, "true"].includes(localStorage.getItem("isIlocalUser"));
    const isKioskType =
      this.state.manage_location_name === "Kiosk" ||
      this.state.location_type_id === LOCATION_TYPE.Kiosk;
    if (!isIlocalUser || !isKioskType) {
      return { success: true, skipped: true };
    }

    const body = {};
    if (
      typeof this.state.enable_bulk_remove === "boolean" &&
      this.state.enable_bulk_remove !== this.state.original_enable_bulk_remove
    ) {
      body.enableBulkRemove = this.state.enable_bulk_remove;
    }
    if (Object.keys(body).length === 0) {
      return { success: true, skipped: true };
    }

    const boxId =
      (this.state.box && this.state.box.id) || this.state.kiosk_box_id;
    if (!boxId) {
      throw new Error("Box id is required to update kiosk flags.");
    }

    const response = await fetch(
      `${process.env.REACT_APP_BASEURL}api/v2/box/${encodeURIComponent(boxId)}/kiosk-flags`,
      {
        method: "POST",
        headers: this.nativeComponentAuthHeaders(),
        body: JSON.stringify(body),
      }
    );
    const result = await response.json().catch(() => null);
    if (!response.ok || !result || !result.success) {
      throw new Error(
        (result && result.message) || "Failed to update kiosk flags."
      );
    }
    return result;
  };

  onChangeBoxType = (idx) => (evt) => {
    const nextExpansionId = evt.target.value;
    const boxType = this.state.addonUnits.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: addonRowId(item),
        expansion_id: nextExpansionId,
        direction: item.direction,
        connected_box_id: item.connected_box_id,
      };
    });

    this.setState({ addonUnits: boxType });
  };

  onChangeUnitDirection = (idx) => (evt) => {
    const nextDirection = evt.target.value;
    const unitDirection = this.state.addonUnits.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: addonRowId(item),
        expansion_id: item.expansion_id,
        direction: nextDirection,
        connected_box_id: item.connected_box_id,
      };
    });

    this.setState({ addonUnits: unitDirection });
  };

  onChangeConnectedDevice = (idx) => (evt) => {
    const nextConnectedBoxId = evt.target.value;
    const previousConnectedBoxId =
      this.state.addonUnits &&
      this.state.addonUnits[idx] &&
      this.state.addonUnits[idx].connected_box_id;
    const shouldUpdateMainUnitGroup =
      MAIN_UNIT_BOX_TYPES.includes(previousConnectedBoxId) &&
      MAIN_UNIT_BOX_TYPES.includes(nextConnectedBoxId);
    const connectedDevice = this.state.addonUnits.map((item, sidx) => {
      const shouldUpdateRow = shouldUpdateMainUnitGroup
        ? item.connected_box_id === previousConnectedBoxId
        : idx === sidx;
      if (!shouldUpdateRow) return item;
      return {
        id: addonRowId(item),
        expansion_id: item.expansion_id,
        direction: item.direction,
        connected_box_id: nextConnectedBoxId,
      };
    });
    this.setState({
      addonUnits: connectedDevice,
      ...(shouldUpdateMainUnitGroup
        ? {
            type_id: nextConnectedBoxId,
            boxTypeId: nextConnectedBoxId,
            box: {
              ...this.state.box,
              type_id: nextConnectedBoxId,
            },
          }
        : {}),
    });
  };

  createRow = () => {
    const {classes, t} = this.props;
    let boxType = this.state.boxTypes;
    let boxType_1 = this.state.boxTypes;
    if (boxType !== undefined) {
      boxType = boxType.filter(
        (item) => item.id !== BOX_TYPE.Locker && item.id !== BOX_TYPE.M22 && item.id !== BOX_TYPE.M24 && item.id !== BOX_TYPE.M41
      );
    }
    return this.state.addonUnits.map((val, idx) => (
      <TableRow key={idx}>
        <TableCell align="center" sx={{ width: "12%" }}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {[BOX_TYPE.COOL_12, BOX_TYPE.Cool].includes(val.expansion_id) ? (
              <div>
                <IconButton
                  onClick={() => this.handleSeetingsforCoolUnit(idx, val.id)}
                >
                  <SettingIcon className={classes.iconStyle} />
                </IconButton>
              </div>
            ) : (
              ""
            )}
            <div>
              <IconButton onClick={() => this.removeRow(idx)}>
                <RemoveIcon className={classes.iconStyle} />
              </IconButton>
            </div>
          </div>
        </TableCell>
        <TableCell align="left" sx={{ width: "40%" }}>
          <FormControl fullWidth>
            <InputLabel
              htmlFor="type_id"
              sx={{
                marginLeft: "-15px",
                "&.MuiInputLabel-formControl": { top: "5px" },
              }}
            >
              {t("Location.Addons.BoxType")}
            </InputLabel>
            <Select
              value={val.expansion_id || ""}
              onChange={this.onChangeBoxType(idx)}
              inputProps={{
                name: "expansion_id",
                id: "expansion_id1",
              }}
              variant="standard"
            >
              {boxType.map((type, index) => (
                <MenuItem
                  key={index}
                  value={type.id}
                  selected
                  sx={{ height: "46px" }}
                >
                  {type.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </TableCell>
        <TableCell sx={{ width: "13%" }}>
          <FormControl fullWidth>
            <InputLabel
              htmlFor="age-simple"
              sx={{
                marginLeft: "-15px",
                "&.MuiInputLabel-formControl": { top: "5px" },
              }}
            >
              {t("Location.Addons.Side")}
            </InputLabel>
            <Select
              value={val.direction || ""}
              onChange={this.onChangeUnitDirection(idx)}
              inputProps={{
                name: "direction",
                id: "direction1",
              }}
              variant="standard"
            >
              <MenuItem value={1} sx={{ height: "46px" }}>
                {t("Global.Left")}
              </MenuItem>
              <MenuItem value={2} sx={{ height: "46px" }}>
                {t("Global.Right")}
              </MenuItem>
            </Select>
          </FormControl>
        </TableCell>
        <TableCell sx={{ width: "45%" }}>
          <FormControl fullWidth>
            <InputLabel
              htmlFor="age-simple"
              sx={{
                marginLeft: "-15px",
                "&.MuiInputLabel-formControl": { top: "5px" },
              }}
            >
              {t("Location.Addons.Connect")}
            </InputLabel>
            <Select
              value={val.connected_box_id || ""}
              onChange={this.onChangeConnectedDevice(idx)}
              inputProps={{
                name: "connected_box_id",
                id: "connected_box_id1",
              }}
              variant="standard"
            >
              {boxType_1.map((type, index) => (
                <MenuItem
                  key={index}
                  value={type.id}
                  selected
                  sx={{ height: "46px" }}
                >
                  {type.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </TableCell>
      </TableRow>
    ));
  };

  addRow = () => {
    this.setState({
      addonUnits: this.state.addonUnits.concat([
        {
          id: createAddonClientId(),
          expansion_id: "",
          direction: "",
          connected_box_id: "",
        },
      ]),
    });
  };

  removeRow = (i) => {
    const {addonUnits, operation} = this.state;
    const deletedExtension = addonUnits[i] && addonUnits[i].id;
    const isPersistedAddon = PERSISTED_ADDON_ID.test(String(deletedExtension || ""));
    if (operation.toLowerCase() === "edit" && isPersistedAddon) {
      fetch(
        process.env.REACT_APP_BASEURL + "remove/extension/" + deletedExtension,
        {
          method: "GET",
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => response.json())
        .then((boxes) => {
          if (!boxes || boxes.isBoxExpansionDeleted !== true) {
            toast.error((boxes && boxes.message) || "The add-on unit was not removed. Please refresh and try again.");
            return;
          }
          this.setState({
            addonUnits: addonUnits.filter((s, sidx) => i !== sidx),
          });
          toast.success("Add-on unit removed successfully");
        })
        .catch(() => toast.error("Unable to remove the add-on unit. Please try again."));
    } else {
      this.setState({
        addonUnits: addonUnits.filter((s, sidx) => i !== sidx),
      });
    }
  };

  handleChangeActive = () => {
    this.setState({ IsActive: !this.state.IsActive });
  };

  handleChangeMarketplace = () => {
    this.setState({ is_marketplace: !this.state.is_marketplace });
  };

  handleShowHideXWebIdSecrets = (column, event) => {
    this.setState({ isXWebIdSecretVisible: !this.state.isXWebIdSecretVisible });
  };

  handleShowHideXWebAuthKeySecrets = (column, event) => {
    this.setState({
      isXWebAuthKeySecretVisible: !this.state.isXWebAuthKeySecretVisible,
    });
  };

  handleShowHideXWebTerminalIdSecrets = (column, event) => {
    this.setState({
      isXWebTerminalIdSecretVisible: !this.state.isXWebTerminalIdSecretVisible,
    });
  };

  handleSeetingsforCoolUnit = (index, id) => {
    this.setState({
      settingDialogOpen: true,
      box_index: index,
      box_expansion_id: id,
    });
    this.getSettings(id);
  };

  handleCloseSettings = () => {
    this.setState({
      maxtemp: "",
      setTemp: "",
      mintemp: "",
      com_port:"",
      settingDialogOpen: false,
    });
  };

  handleMaxTempChange = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ maxtemp: event.target.value });
  };

  handleSetTempChange = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ setTemp: event.target.value });
  };

  handleMinTempChange = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ mintemp: event.target.value });
  };

  isCheckBoxHandler = () => {
    let arr = this.state.selectCourierType;
    this.setState({
      Fed_Ex: false,
      UPS: false,
      DHL: false,
      third_Party: false,
      Self_Service: false,
      US_Postal: false,
    });

    for (let i = 0; i < arr.length; i++) {
      if (arr[i] === "Fed Ex") {
        this.setState({ Fed_Ex: true });
      } else if (arr[i] === "UPS") {
        this.setState({ UPS: true });
      } else if (arr[i] === "DHL") {
        this.setState({ DHL: true });
      } else if (arr[i] === "US Postal Service") {
        this.setState({ US_Postal: true });
      } else if (arr[i] === "3rd Party") {
        this.setState({ third_Party: true });
      } else if (arr[i] === "Self Service(US)") {
        this.setState({ Self_Service: true });
      }
    }
  };

  selectCourierHandler = (value) => {
    let courier = this.state.selectCourierType;
    const index = courier.indexOf(value);
    if (index > -1) {
      courier.splice(index, 1);
    } else {
      courier.push(value);
    }
    this.setState({ selectCourierType: courier }, () => {
      this.isCheckBoxHandler();
    });
  };

  saveCoolBoxSettings = () => {
    if (
      this.state.maxtemp > COOL_UNIT_TEMP.MAX_TEMP ||
      this.state.maxtemp < COOL_UNIT_TEMP.MIN_TEMP ||
      this.state.maxtemp < this.state.mintemp
    ) {
      this.setState({ errorMaxTemp: true });
    } else if (
      this.state.setTemp > this.state.maxtemp ||
      this.state.setTemp < this.state.mintemp
    ) {
      this.setState({ errorSetTemp: true });
    } else if (
      this.state.mintemp > COOL_UNIT_TEMP.MAX_TEMP ||
      this.state.mintemp < COOL_UNIT_TEMP.MIN_TEMP ||
      this.state.mintemp > this.state.maxtemp
    ) {
      this.setState({ errorMinTemp: true });
    } else {
      const settings = this.state.addonUnits.map((item, sidx) => {
        if (this.state.box_index !== sidx) return item;
        return {
          id: addonRowId(item),
          expansion_id: item.expansion_id,
          direction: item.direction,
          connected_box_id: item.connected_box_id,
          max_temp: this.state.maxtemp,
          target_temp: this.state.setTemp,
          min_temp: this.state.mintemp,
          com_port:this.state.com_port
        };
      });
      this.setState({ addonUnits: settings });
      this.setState({
        errorMaxTemp: false,
        errorSetTemp: false,
        errorMinTemp: false,
        settingDialogOpen: false,
      });
    }
  };

  getSettings = (expansionID) => {
    let obj = this.state.addonUnits.filter((x) => x.id === expansionID);
    if (obj && obj.length > 0) {
      this.setState({
        maxtemp: obj[0].max_temp,
        setTemp: obj[0].target_temp,
        mintemp: obj[0].min_temp,
        com_port: obj[0].com_port
      });
    }
  };

  handleSwitchChange = () => {
    this.setState({
      simpleOrExpressUI: !this.state.simpleOrExpressUI,
    });
  };

  handleSwitchSimplified = (name) => (event) => {
    this.setState({ SimplifiedEnrollment: event.target.checked });
  };

  handleSwitchopenpath = (event) => {
    const openpath = event.target.checked;
    this.setState({ openpath });
    localStorage.setItem("openpath", openpath);
    if (openpath) {
      this.getOpenPathUser(
        this.state.OpenPathEmailId,
        this.state.OpenPathPassword
      );
    } else {
      this.setState({ openPathUserList: [] });
    }
  };

  handleChangeOpenPathEmailId = (event) => {
    this.setState({ OpenPathEmailId: event.target.value });
  }

  handleChangeOpenPathPassword = (event) => {
    this.setState({ OpenPathPassword: event.target.value });
  }

  getPaymentGateways = () => {
    fetch(process.env.REACT_APP_BASEURL + "paymentgateways", {
      method: "GET",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => response.json())
      .then((paymentTypes) => {
        this.setState({ paymentGateways: paymentTypes });
      });
  };

  getCountryListWithRegion = () => {
    fetch(process.env.REACT_APP_BASEURL + "regions/list", {
      method: "GET",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => response.json())
      .then((countryListResponse) => {
        this.setState({
          countryList: countryListResponse && countryListResponse.results,
        });
      });
  };

  getOpenPathUser = (OpenPathEmailId, OpenPathPassword) => {
    const missingCredential = [undefined, "undefined", null, "null", ""].includes(
      typeof OpenPathEmailId === "string" ? OpenPathEmailId.trim() : OpenPathEmailId
    ) || [undefined, "undefined", null, "null", ""].includes(
      typeof OpenPathPassword === "string" ? OpenPathPassword.trim() : OpenPathPassword
    );
    if (missingCredential) {
      this.setState({ openPathUserList: [] });
      return;
    }
    let openpath_object = {
      OpenPathEmailId,
      OpenPathPassword
    }
    fetch(process.env.REACT_APP_BASEURL + "openpathuserlist", {
      method: "POST",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(openpath_object),
    })
      .then(async (response) => {
        const contentType = response.headers.get("content-type") || "";
        if (!contentType.includes("application/json")) {
          const text = await response.text();
          throw new Error(
            text || "OpenPath user list returned a non-JSON response",
          );
        }
        return response.json();
      })
      .then((reslist) => {
        let userlist = [];
        const rows = Array.isArray(reslist)
          ? reslist
          : reslist && Array.isArray(reslist.users)
            ? reslist.users
            : [];
        for (let i = 0; i < rows.length; i++) {
          if (rows[i].status === "A") {
            userlist.push({
              id: rows[i].id,
              name: rows[i].identity.fullName,
            });
          }
        }
        this.setState({
          openPathUserList: userlist,
        });
      })
      .catch((error) => {
        console.error("Failed to load OpenPath users:", error);
        this.setState({
          openPathUserList: [],
        });
      });
  }

  handleChangePaymentGateway = (event) => {
    this.setState({ paymentType: event.target.value });
  };

  handleChangePosConfigurationMode = (event) => {
    const selectedValue = event && event.target ? event.target.value : null;
    console.log("[box-list][POS] Payment gateway changed", {
      selectedValue,
      manage_location_name: this.state.manage_location_name,
      selectedTab: this.state.selectedTab,
      operation: this.state.operation,
    });

    const currentDevices = this.getPaymentDevicePayload();
    const selectedGatewayDevices = currentDevices.filter(
      (device) => device.payment_gateway_id === selectedValue
    );
    const nextDevice = selectedGatewayDevices[0] || getPaymentDeviceDefaults(selectedValue, 0);
    const nextDevices = selectedGatewayDevices.length
      ? currentDevices
      : [...currentDevices, nextDevice];

    this.setState({
      paymentType: selectedValue,
      paymentDevices: nextDevices,
      selectedPaymentDeviceId: getPaymentDeviceUiId(nextDevice),
      ...this.getPaymentDeviceStateValues(nextDevice),
    });
  };

  renderPayLaterConfiguration = () => {
    const { t, classes } = this.props;
    const payLaterMode = this.state.pay_later_mode || PAY_LATER_MODES.DISABLED;

    return (
      <Box
        sx={{
          mb: 3,
          p: 2.5,
          border: "1px solid #e2e8f0",
          borderRadius: 2,
          backgroundColor: "#ffffff",
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5, color: "#1e293b" }}>
          {t("Location.POS.PayLater.Title", { defaultValue: "Pay Later" })}
        </Typography>
        <Typography variant="body2" sx={{ mb: 1.5, color: "#64748b" }}>
          {t("Location.POS.PayLater.Help", {
            defaultValue: "Choose when patients can select Pay Later during pickup.",
          })}
        </Typography>
        <FormControl component="fieldset" disabled={this.state.operation === "View"}>
          <RadioGroup
            value={payLaterMode}
            onChange={(event) => {
              const nextMode = normalizePayLaterMode(event.target.value, false);
              this.setState({
                pay_later_mode: nextMode,
                payroll_deduct: isPayLaterEnabledForMode(nextMode),
              });
            }}
          >
            <FormControlLabel
              value={PAY_LATER_MODES.DISABLED}
              control={<Radio color="primary" />}
              label={
                <span className={classes.formControlLabel}>
                  {t("Location.POS.PayLater.Disabled", { defaultValue: "Disabled" })}
                </span>
              }
            />
            <FormControlLabel
              value={PAY_LATER_MODES.ALL_ORDERS}
              control={<Radio color="primary" />}
              label={
                <span className={classes.formControlLabel}>
                  {t("Location.POS.PayLater.AllOrders", { defaultValue: "For all orders" })}
                </span>
              }
            />
            <FormControlLabel
              value={PAY_LATER_MODES.SELECT_ORDERS}
              control={<Radio color="primary" />}
              label={
                <span className={classes.formControlLabel}>
                  {t("Location.POS.PayLater.SelectOrders", { defaultValue: "For select orders" })}
                </span>
              }
            />
          </RadioGroup>
        </FormControl>
      </Box>
    );
  };

  renderPaymentGatewayTabs = () => {
    const {t} = this.props;
    const readOnly = this.state.operation === "View";
    const gateways = [
      {
        value: PaymentGatewayTypes.GLOBAL_PAYMENTS,
        label: t("Location.POS.PaymentGatewayGlobalPayments"),
      },
      {
        value: PaymentGatewayTypes.GLOBAL_PAYMENTS_GENIUS,
        label: t("Location.POS.PaymentGatewayGlobalPaymentsGenius"),
      },
      {
        value: PaymentGatewayTypes.FISERV_CARDPOINTE,
        label: t("Location.POS.PaymentGatewayFiservIntegratedTerminal"),
      },
      {
        value: PaymentGatewayTypes.TRUST_COMMERCE,
        label: "TrustCommerce",
      },
      {
        value: PaymentGatewayTypes.JPMC_INSTAMED,
        label: "JPMC InstaMed",
      },
    ];

    return (
      <Box
        sx={{
          border: "1px solid rgba(15, 23, 42, 0.08)",
          borderRadius: "10px",
          backgroundColor: "#f8fafc",
          p: 0.75,
        }}
      >
        <Typography
          variant="caption"
          sx={{
            display: "block",
            color: "#64748b",
            fontWeight: 700,
            mb: 0.75,
            px: 0.5,
            textTransform: "uppercase",
            letterSpacing: "0.02em",
          }}
        >
          Payment Gateway
        </Typography>
        <Tabs
          value={this.state.paymentType || PaymentGatewayTypes.GLOBAL_PAYMENTS}
          onChange={(event, value) =>
            !readOnly && this.handleChangePosConfigurationMode({ target: { value } })
          }
          variant="scrollable"
          scrollButtons="auto"
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{
            minHeight: 36,
            "& .MuiTabs-flexContainer": {
              gap: "6px",
            },
            "& .MuiTab-root": {
              minHeight: 34,
              minWidth: "auto",
              px: 1.5,
              py: 0.75,
              borderRadius: "8px",
              color: "#475569",
              fontSize: "0.82rem",
              fontWeight: 700,
              textTransform: "none",
              border: "1px solid transparent",
            },
            "& .Mui-selected": {
              color: "#0f172a",
              backgroundColor: "#fff",
              borderColor: "rgba(25, 118, 210, 0.35)",
              boxShadow: "0 1px 4px rgba(15, 23, 42, 0.1)",
            },
          }}
        >
          {gateways.map((gateway) => (
            <Tab
              key={gateway.value}
              value={gateway.value}
              label={gateway.label}
              disabled={readOnly}
            />
          ))}
        </Tabs>
      </Box>
    );
  };

  renderPosBridgeGatewayConfiguration = () => {
    const {classes, t} = this.props;
    const isBridgeGateway =
      this.state.paymentType === PaymentGatewayTypes.GLOBAL_PAYMENTS_GENIUS ||
      this.state.paymentType === PaymentGatewayTypes.FISERV_CARDPOINTE ||
      this.state.paymentType === PaymentGatewayTypes.TRUST_COMMERCE ||
      this.state.paymentType === PaymentGatewayTypes.JPMC_INSTAMED;

    if (!isBridgeGateway) {
      return null;
    }

    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Box
          style={{ order: 1 }}
          sx={{
            border: "1px solid rgba(0, 0, 0, 0.08)",
            borderRadius: 2,
            p: 2,
            backgroundColor: "rgba(0, 0, 0, 0.02)",
          }}
        >
          <Typography
            variant="title"
            style={{
              color: "black",
              fontWeight: 700,
              marginTop: 0,
              marginBottom: "5px",
            }}
          >
            {t("Location.POS.MerchantCredentials")}
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Grid container spacing={2} sx={{ mt: 1, mb: 2 }}>
            {this.state.paymentType === PaymentGatewayTypes.GLOBAL_PAYMENTS_GENIUS && (
              <React.Fragment>
                <Grid item xs={12} md={6} lg={6}>
                  <TextField
                    id="pos_merchant_name"
                    name="pos_merchant_name"
                    label={t("Location.POS.GeniusMerchantName")}
                    value={this.state.pos_merchant_name || ""}
                    onChange={(e) => {
                      this.handlePaymentDeviceFieldChange("pos_merchant_name", e.target.value);
                    }}
                    disabled={this.state.operation === "View"}
                    variant="outlined"
                    size="small"
                    sx={paymentFieldSx}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <TextField
                    id="pos_merchant_site_id"
                    name="pos_merchant_site_id"
                    label={t("Location.POS.GeniusMerchantSiteId")}
                    value={this.state.pos_merchant_site_id || ""}
                    onChange={(e) => {
                      this.handlePaymentDeviceFieldChange("pos_merchant_site_id", e.target.value);
                    }}
                    disabled={this.state.operation === "View"}
                    variant="outlined"
                    size="small"
                    sx={paymentFieldSx}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <TextField
                    id="pos_merchant_key"
                    name="pos_merchant_key"
                    label={t("Location.POS.GeniusMerchantKey")}
                    value={this.state.pos_merchant_key || ""}
                    onChange={(e) => {
                      this.handlePaymentDeviceFieldChange("pos_merchant_key", e.target.value);
                    }}
                    type="password"
                    disabled={this.state.operation === "View"}
                    variant="outlined"
                    size="small"
                    sx={paymentFieldSx}
                    fullWidth
                  />
                </Grid>
              </React.Fragment>
            )}
            {this.state.paymentType === PaymentGatewayTypes.FISERV_CARDPOINTE && (
              <React.Fragment>
                <Grid item xs={12} md={6} lg={6}>
                  <TextField
                    id="pos_merchant_site_id"
                    name="pos_merchant_site_id"
                    label={t("Location.POS.CardPointeMerchantId")}
                    value={this.state.pos_merchant_site_id || ""}
                    onChange={(e) => {
                      this.handlePaymentDeviceFieldChange("pos_merchant_site_id", e.target.value);
                    }}
                    inputProps={{ autoComplete: "off" }}
                    disabled={this.state.operation === "View"}
                    variant="outlined"
                    size="small"
                    sx={paymentFieldSx}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <TextField
                    id="pos_terminal_id"
                    name="pos_terminal_id"
                    label={
                      <Box
                        component="span"
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 0.5,
                        }}
                      >
                        {t("Location.POS.CardPointeTerminalIdHsn")}
                        <Tooltip title={t("Location.POS.CardPointeTerminalIdHsnTooltip")}>
                          <IconButton
                            size="small"
                            component="span"
                            sx={{ p: 0.25 }}
                            aria-label={t("Location.POS.CardPointeTerminalIdHsnAriaLabel")}
                            onClick={(e) => e.preventDefault()}
                          >
                            <Info fontSize="small" color="action" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    }
                    value={this.state.pos_terminal_id || ""}
                    onChange={(e) => {
                      this.handlePaymentDeviceFieldChange("pos_terminal_id", e.target.value);
                    }}
                    inputProps={{ autoComplete: "off" }}
                    disabled={this.state.operation === "View"}
                    variant="outlined"
                    size="small"
                    sx={paymentFieldSx}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              </React.Fragment>
            )}
            {this.state.paymentType === PaymentGatewayTypes.JPMC_INSTAMED && (
              <React.Fragment>
                <Grid item xs={12} md={6} lg={6}>
                  <TextField
                    id="pos_merchant_site_id"
                    name="pos_merchant_site_id"
                    label="Merchant ID"
                    value={this.state.pos_merchant_site_id || ""}
                    onChange={(e) => {
                      this.handlePaymentDeviceFieldChange("pos_merchant_site_id", e.target.value);
                    }}
                    inputProps={{ autoComplete: "off" }}
                    disabled={this.state.operation === "View"}
                    variant="outlined"
                    size="small"
                    sx={paymentFieldSx}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <TextField
                    id="pos_clerk_id"
                    name="pos_clerk_id"
                    label="Store ID"
                    value={this.state.pos_clerk_id || ""}
                    onChange={(e) => {
                      this.handlePaymentDeviceFieldChange("pos_clerk_id", e.target.value);
                    }}
                    inputProps={{ autoComplete: "off" }}
                    disabled={this.state.operation === "View"}
                    variant="outlined"
                    size="small"
                    sx={paymentFieldSx}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <TextField
                    id="pos_terminal_id"
                    name="pos_terminal_id"
                    label="Terminal ID"
                    value={this.state.pos_terminal_id || ""}
                    onChange={(e) => {
                      this.handlePaymentDeviceFieldChange("pos_terminal_id", e.target.value);
                    }}
                    inputProps={{ autoComplete: "off" }}
                    disabled={this.state.operation === "View"}
                    variant="outlined"
                    size="small"
                    sx={paymentFieldSx}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <TextField
                    id="instamed_workstation_id"
                    name="instamed_workstation_id"
                    label="Workstation ID"
                    value={this.state.instamed_workstation_id || ""}
                    onChange={(e) => {
                      this.handlePaymentDeviceFieldChange("instamed_workstation_id", e.target.value);
                    }}
                    inputProps={{ autoComplete: "off" }}
                    disabled={this.state.operation === "View"}
                    variant="outlined"
                    size="small"
                    sx={paymentFieldSx}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <TextField
                    id="instamed_sso_alias"
                    name="instamed_sso_alias"
                    label="SSO Alias"
                    value={this.state.instamed_sso_alias || ""}
                    onChange={(e) => {
                      this.handlePaymentDeviceFieldChange("instamed_sso_alias", e.target.value);
                    }}
                    inputProps={{ autoComplete: "off" }}
                    disabled={this.state.operation === "View"}
                    variant="outlined"
                    size="small"
                    sx={paymentFieldSx}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <TextField
                    id="instamed_additional_info_6"
                    name="instamed_additional_info_6"
                    label="AdditionalInfo6"
                    value={this.state.instamed_additional_info_6 || ""}
                    onChange={(e) => {
                      this.handlePaymentDeviceFieldChange("instamed_additional_info_6", e.target.value);
                    }}
                    inputProps={{ autoComplete: "off" }}
                    disabled={this.state.operation === "View"}
                    variant="outlined"
                    size="small"
                    sx={paymentFieldSx}
                    fullWidth
                  />
                </Grid>
              </React.Fragment>
            )}
            {this.state.paymentType === PaymentGatewayTypes.FISERV_CARDPOINTE && (
              <Grid item xs={12} md={12} lg={12}>
                <Typography
                  variant="title"
                  style={{
                    color: "black",
                    fontWeight: 700,
                    marginTop: "10px",
                    marginBottom: "5px",
                  }}
                >
                  Manual Entry
                </Typography>
                <Divider sx={{ mb: 1 }} />
                <Box>
                  <FormControlLabel
                    label={
                      <span
                        style={{
                          fontSize: 16,
                          color: "rgb(165, 165, 165)",
                        }}
                      >
                        Start sale directly in Manual Entry mode
                      </span>
                    }
                    labelPlacement="end"
                    control={
                      <Switch
                        classes={{
                          switchBase: classes.iOSSwitchBase,
                          bar: classes.iOSBar,
                          icon: classes.iOSIcon,
                          iconChecked: classes.iOSIconChecked,
                          checked: classes.iOSChecked,
                        }}
                        checked={Boolean(this.state.pos_manual_entry_enabled)}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          this.handlePaymentDeviceFieldChange("pos_manual_entry_enabled", checked);
                          this.handlePaymentDeviceFieldChange("pos_manual_entry_button_enabled", false);
                        }}
                        disabled={this.state.operation === "View"}
                        color="primary"
                      />
                    }
                  />
                </Box>
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    color: "text.secondary",
                    mt: 0.5,
                    ml: 1,
                  }}
                >
                  Enable this to run payments through manual card entry on the terminal keypad.
                </Typography>
              </Grid>
            )}
            {this.state.paymentType === PaymentGatewayTypes.FISERV_CARDPOINTE && (
              <Grid item xs={12} md={12} lg={12}>
                <Typography
                  variant="title"
                  style={{
                    color: "black",
                    fontWeight: 700,
                    marginTop: "10px",
                    marginBottom: "5px",
                  }}
                >
                  Clover Go 3
                </Typography>
                <Divider sx={{ mb: 1 }} />
                <Box>
                  <FormControlLabel
                    label={
                      <span
                        style={{
                          fontSize: 16,
                          color: "rgb(165, 165, 165)",
                        }}
                      >
                        Use Clover Go 3 mobile reader for payments
                      </span>
                    }
                    labelPlacement="end"
                    control={
                      <Switch
                        classes={{
                          switchBase: classes.iOSSwitchBase,
                          bar: classes.iOSBar,
                          icon: classes.iOSIcon,
                          iconChecked: classes.iOSIconChecked,
                          checked: classes.iOSChecked,
                        }}
                        checked={Boolean(this.state.pos_clover_go_enabled)}
                        onChange={(e) => {
                          this.handlePaymentDeviceFieldChange("pos_clover_go_enabled", e.target.checked);
                        }}
                        disabled={this.state.operation === "View"}
                        color="primary"
                      />
                    }
                  />
                </Box>
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    color: "text.secondary",
                    mt: 0.5,
                    ml: 1,
                  }}
                >
                  Enable this to route payments through the Clover Go 3 mobile SDK in the Express app instead of the terminal bridge.
                </Typography>
              </Grid>
            )}
            {this.state.paymentType === PaymentGatewayTypes.TRUST_COMMERCE && (
              <React.Fragment>
                <Grid item xs={12} md={6} lg={6}>
                  <TextField
                    id="pos_terminal_id"
                    name="pos_terminal_id"
                    label={
                      <Box
                        component="span"
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 0.5,
                        }}
                      >
                        Terminal ID
                        <Tooltip title="Use model_serialnumber format, e.g. A920PRO_12345678910.">
                          <IconButton
                            size="small"
                            component="span"
                            sx={{ p: 0.25 }}
                            aria-label="Terminal id format info"
                            onClick={(e) => e.preventDefault()}
                          >
                            <Info fontSize="small" color="action" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    }
                    value={this.state.pos_terminal_id || ""}
                    onChange={(e) => {
                      this.handlePaymentDeviceFieldChange("pos_terminal_id", e.target.value);
                    }}
                    inputProps={{ autoComplete: "off" }}
                    disabled={this.state.operation === "View"}
                    variant="outlined"
                    size="small"
                    sx={paymentFieldSx}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <TextField
                    id="pos_api_url"
                    name="pos_api_url"
                    label="POS API URL"
                    value={this.state.pos_api_url || ""}
                    onChange={(e) => {
                      this.handlePaymentDeviceFieldChange("pos_api_url", e.target.value);
                    }}
                    inputProps={{ autoComplete: "off" }}
                    disabled={this.state.operation === "View"}
                    variant="outlined"
                    size="small"
                    sx={paymentFieldSx}
                    fullWidth
                    helperText="Optional override. Example: https://vault.trustcommerce.com/trans/"
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <Typography
                    variant="title"
                    style={{
                      color: "black",
                      fontWeight: 700,
                      marginTop: "10px",
                      marginBottom: "5px",
                    }}
                  >
                    Manual Entry (Sale)
                  </Typography>
                  <Divider sx={{ mb: 1 }} />
                  <Box>
                    <FormControlLabel
                      label={
                        <span
                          style={{
                            fontSize: 16,
                            color: "rgb(165, 165, 165)",
                          }}
                        >
                          Start sale directly in Manual Entry mode
                        </span>
                      }
                      labelPlacement="end"
                      control={
                        <Switch
                          classes={{
                            switchBase: classes.iOSSwitchBase,
                            bar: classes.iOSBar,
                            icon: classes.iOSIcon,
                            iconChecked: classes.iOSIconChecked,
                            checked: classes.iOSChecked,
                          }}
                          checked={Boolean(this.state.pos_manual_entry_enabled)}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            this.handlePaymentDeviceFieldChange("pos_manual_entry_enabled", checked);
                            if (checked) {
                              this.handlePaymentDeviceFieldChange("pos_manual_entry_button_enabled", false);
                            }
                          }}
                          disabled={this.state.operation === "View"}
                          color="primary"
                        />
                      }
                    />
                  </Box>
                  <Box>
                    <FormControlLabel
                      label={
                        <span
                          style={{
                            fontSize: 16,
                            color: "rgb(165, 165, 165)",
                          }}
                        >
                          Show Manual Entry button during Insert / Contactless / Swipe sale
                        </span>
                      }
                      labelPlacement="end"
                      control={
                        <Switch
                          classes={{
                            switchBase: classes.iOSSwitchBase,
                            bar: classes.iOSBar,
                            icon: classes.iOSIcon,
                            iconChecked: classes.iOSIconChecked,
                            checked: classes.iOSChecked,
                          }}
                          checked={Boolean(this.state.pos_manual_entry_button_enabled)}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            this.handlePaymentDeviceFieldChange("pos_manual_entry_button_enabled", checked);
                            if (checked) {
                              this.handlePaymentDeviceFieldChange("pos_manual_entry_enabled", false);
                            }
                          }}
                          disabled={this.state.operation === "View"}
                          color="primary"
                        />
                      }
                    />
                  </Box>
                  <Typography
                    variant="caption"
                    sx={{
                      display: "block",
                      color: "text.secondary",
                      mt: 0.5,
                      ml: 1,
                    }}
                  >
                    Enable only one option at a time. If both are off, the device starts in the default Insert / Contactless / Swipe flow.
                  </Typography>
                </Grid>
              </React.Fragment>
            )}
          </Grid>
        </Box>
        {this.state.paymentType === PaymentGatewayTypes.GLOBAL_PAYMENTS_GENIUS && (
          <Box
            style={{ order: 2 }}
            sx={{
              border: "1px solid rgba(0, 0, 0, 0.08)",
              borderRadius: 2,
              p: 2,
              backgroundColor: "rgba(0, 0, 0, 0.02)",
            }}
          >
            <Typography
              variant="title"
              style={{
                color: "black",
                fontWeight: 700,
                marginTop: "10px",
                marginBottom: "5px",
              }}
            >
              {t("Location.POS.PosBridgeDeviceConnectivity")}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2} sx={{ mt: 2, mb: 2 }}>
              <Grid item xs={12} md={7} lg={7}>
                <TextField
                  id="pos_bridge_hostname"
                  name="pos_bridge_hostname"
                  label={t("Location.Settings.POSBridgeHostname") || "POS Device Hostname"}
                  value={this.state.pos_bridge_hostname}
                  onChange={(e) => {
                    this.handlePaymentDeviceFieldChange("pos_bridge_hostname", e.target.value);
                  }}
                  disabled={this.state.operation === "View"}
                  variant="outlined"
                    size="small"
                    sx={paymentFieldSx}
                  fullWidth
                  helperText={
                    t("Location.Settings.POSBridgeHostnameHelp") ||
                    "e.g., ced-hostname.local or 192.168.1.100"
                  }
                />
              </Grid>
              <Grid item xs={12} md={5} lg={5}>
                <TextField
                  id="pos_bridge_port"
                  name="pos_bridge_port"
                  label={t("Location.Settings.POSBridgePort") || "POS Device Port"}
                  type="number"
                  value={this.state.pos_bridge_port}
                  onChange={(e) => {
                    this.handlePaymentDeviceFieldChange("pos_bridge_port", parseInt(e.target.value, 10) || 8080);
                  }}
                  disabled={this.state.operation === "View"}
                  variant="outlined"
                    size="small"
                    sx={paymentFieldSx}
                  fullWidth
                  helperText={t("Location.Settings.POSBridgePortHelp") || "Default: 8080"}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <FormControl variant="outlined"
                    size="small"
                    sx={paymentFieldSx} fullWidth>
                  <InputLabel id="pos_bridge_protocol-label">
                    {t("Location.Settings.POSBridgeProtocol") || "POS Device Protocol"}
                  </InputLabel>
                  <Select
                    labelId="pos_bridge_protocol-label"
                    id="pos_bridge_protocol"
                    value={this.state.pos_bridge_protocol}
                    onChange={(e) => {
                      this.handlePaymentDeviceFieldChange("pos_bridge_protocol", e.target.value);
                    }}
                    disabled={this.state.operation === "View"}
                    label={t("Location.Settings.POSBridgeProtocol") || "POS Device Protocol"}
                  >
                    <MenuItem value="http">HTTP</MenuItem>
                    <MenuItem value="https">HTTPS</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="pos_bridge_https_hostname"
                  name="pos_bridge_https_hostname"
                  label={
                    t("Location.Settings.POSBridgeHTTPSHostname") ||
                    "POS Device HTTPS Hostname (Optional)"
                  }
                  value={this.state.pos_bridge_https_hostname}
                  onChange={(e) => {
                    this.handlePaymentDeviceFieldChange("pos_bridge_https_hostname", e.target.value);
                  }}
                  disabled={this.state.operation === "View"}
                  variant="outlined"
                    size="small"
                    sx={paymentFieldSx}
                  fullWidth
                  helperText={
                    t("Location.Settings.POSBridgeHTTPSHostnameHelp") ||
                    "Optional: For HTTPS connections"
                  }
                />
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <TextField
                  id="pos_bridge_https_port"
                  name="pos_bridge_https_port"
                  label={
                    t("Location.Settings.POSBridgeHTTPSPort") ||
                    "POS Device HTTPS Port (Optional)"
                  }
                  type="number"
                  value={this.state.pos_bridge_https_port}
                  onChange={(e) => {
                    this.handlePaymentDeviceFieldChange("pos_bridge_https_port", parseInt(e.target.value, 10) || 8443);
                  }}
                  disabled={this.state.operation === "View"}
                  variant="outlined"
                    size="small"
                    sx={paymentFieldSx}
                  fullWidth
                  helperText={
                    t("Location.Settings.POSBridgeHTTPSPortHelp") || "Default: 8443"
                  }
                />
              </Grid>
            </Grid>
          </Box>
        )}
        {this.state.paymentType === PaymentGatewayTypes.GLOBAL_PAYMENTS_GENIUS && (
          <Box
            style={{ order: 3 }}
            sx={{
              border: "1px solid rgba(0, 0, 0, 0.08)",
              borderRadius: 2,
              p: 2,
              backgroundColor: "rgba(0, 0, 0, 0.02)",
            }}
          >
            <Typography
              variant="title"
              style={{
                color: "black",
                fontWeight: 700,
                marginTop: "10px",
                marginBottom: "5px",
              }}
            >
              {t("Location.POS.GeniusSoftwareMetadata")}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2} sx={{ mt: 0, mb: 2 }}>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="pos_software_name"
                  name="pos_software_name"
                  label={t("Location.POS.GeniusSoftwareName")}
                  value={this.state.pos_software_name || ""}
                  onChange={(e) => {
                    this.handlePaymentDeviceFieldChange("pos_software_name", e.target.value);
                  }}
                  disabled={this.state.operation === "View"}
                  variant="outlined"
                    size="small"
                    sx={paymentFieldSx}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="pos_software_version"
                  name="pos_software_version"
                  label={t("Location.POS.GeniusSoftwareVersion")}
                  value={this.state.pos_software_version || ""}
                  onChange={(e) => {
                    this.handlePaymentDeviceFieldChange("pos_software_version", e.target.value);
                  }}
                  disabled={this.state.operation === "View"}
                  variant="outlined"
                    size="small"
                    sx={paymentFieldSx}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="pos_terminal_id"
                  name="pos_terminal_id"
                  label={t("Location.POS.GeniusTerminalId")}
                  value={this.state.pos_terminal_id || ""}
                  onChange={(e) => {
                    this.handlePaymentDeviceFieldChange("pos_terminal_id", e.target.value);
                  }}
                  disabled={this.state.operation === "View"}
                  variant="outlined"
                    size="small"
                    sx={paymentFieldSx}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="pos_clerk_id"
                  name="pos_clerk_id"
                  label={t("Location.POS.GeniusClerkId")}
                  value={this.state.pos_clerk_id || ""}
                  onChange={(e) => {
                    this.handlePaymentDeviceFieldChange("pos_clerk_id", e.target.value);
                  }}
                  disabled={this.state.operation === "View"}
                  variant="outlined"
                    size="small"
                    sx={paymentFieldSx}
                  fullWidth
                />
              </Grid>
            </Grid>
          </Box>
        )}
      </div>
    );
  };

  renderGlobalPaymentsConfiguration = () => {
    const {classes, t} = this.props;
    const readOnly = this.state.operation === "View";
    const xWebAuthKey = t("Location.POS.WebAuthKeyTooltipTitle");
    const xWebId = t("Location.POS.WebIDTooltipTitle");
    const xWebTerminalId = t("Location.POS.WebTerminalIDTooltipTitle");

    if (
      this.state.paymentType !== PaymentGatewayTypes.GLOBAL_PAYMENTS &&
      this.state.paymentType !== PaymentGatewayTypes.GLOBAL_PAYMENTS_GENIUS
    ) {
      return null;
    }

    return (
      <Box
        sx={{
          border: "1px solid rgba(0, 0, 0, 0.08)",
          borderRadius: 2,
          p: 2,
          backgroundColor: "rgba(0, 0, 0, 0.02)",
        }}
      >
        <Typography
          variant="title"
          style={{
            color: "black",
            fontWeight: 700,
            marginTop: 0,
            marginBottom: "5px",
          }}
        >
          Hosted / Mobile Configuration
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2} sx={{ mt: 0, mb: 1 }}>
          <Grid item xs={12} md={6} lg={6}>
              <TextField
                value={this.state.XWebId || ""}
                id="XWebId"
                name="XWebId"
                label={t("Location.POS.WebID")}
                type={this.state.isXWebIdSecretVisible ? "text" : "password"}
                autoComplete="new-password"
                onChange={(event) =>
                  this.handlePaymentDeviceFieldChange("XWebId", event.target.value)
                }
                disabled={Boolean(readOnly)}
                variant="outlined"
                size="small"
                fullWidth
                sx={paymentFieldSx}
                InputProps={{
                  readOnly: Boolean(readOnly),
                  endAdornment: (
                    <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle XWebId visibility"
                      onClick={this.handleShowHideXWebIdSecrets}
                      onMouseDown={this.handleMouseDownSecrets}
                      size="small"
                    >
                      {this.state.isXWebIdSecretVisible ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                    <Tooltip title={xWebId} className={classes.customWidth}>
                      <Help className={classes.helpIcon}></Help>
                    </Tooltip>
                    </InputAdornment>
                  ),
                }}
              />
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
              <TextField
                value={this.state.XWebTerminalId || ""}
                id="XWebTerminalId"
                name="XWebTerminalId"
                label={t("Location.POS.WebTerminalID")}
                type={this.state.isXWebTerminalIdSecretVisible ? "text" : "password"}
                autoComplete="new-password"
                onChange={(event) =>
                  this.handlePaymentDeviceFieldChange("XWebTerminalId", event.target.value)
                }
                disabled={Boolean(readOnly)}
                variant="outlined"
                size="small"
                fullWidth
                sx={paymentFieldSx}
                InputProps={{
                  readOnly: Boolean(readOnly),
                  endAdornment: (
                    <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle XWebTerminalId visibility"
                      onClick={this.handleShowHideXWebTerminalIdSecrets}
                      onMouseDown={this.handleMouseDownSecrets}
                      size="small"
                    >
                      {this.state.isXWebTerminalIdSecretVisible ? (
                        <Visibility />
                      ) : (
                        <VisibilityOff />
                      )}
                    </IconButton>
                    <Tooltip title={xWebTerminalId} className={classes.customWidth}>
                      <Help className={classes.helpIcon}></Help>
                    </Tooltip>
                    </InputAdornment>
                  ),
                }}
              />
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
              <TextField
                value={this.state.XWebAuthKey || ""}
                id="XWebAuthKey"
                name="XWebAuthKey"
                label={t("Location.POS.WebAuthKey")}
                type={this.state.isXWebAuthKeySecretVisible ? "text" : "password"}
                autoComplete="new-password"
                onChange={(event) =>
                  this.handlePaymentDeviceFieldChange("XWebAuthKey", event.target.value)
                }
                disabled={Boolean(readOnly)}
                variant="outlined"
                size="small"
                fullWidth
                sx={paymentFieldSx}
                InputProps={{
                  readOnly: Boolean(readOnly),
                  endAdornment: (
                    <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle XWebAuthKey visibility"
                      onClick={this.handleShowHideXWebAuthKeySecrets}
                      onMouseDown={this.handleMouseDownSecrets}
                      size="small"
                    >
                      {this.state.isXWebAuthKeySecretVisible ? (
                        <Visibility />
                      ) : (
                        <VisibilityOff />
                      )}
                    </IconButton>
                    <Tooltip title={xWebAuthKey} className={classes.customWidth}>
                      <Help className={classes.helpIcon}></Help>
                    </Tooltip>
                    </InputAdornment>
                  ),
                }}
              />
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <FormControl variant="outlined" size="small" fullWidth sx={paymentFieldSx}>
              <InputLabel id="selected_regioin_gp1-label">
                {t("Location.POS.Region")}
              </InputLabel>
              <Select
                labelId="selected_regioin_gp1-label"
                value={this.state.selected_regioin || ""}
                onChange={this.handleChangeRegion}
                readOnly={this.state.operation === "View"}
                disabled={this.state.operation === "View"}
                label={t("Location.POS.Region")}
                inputProps={{
                  name: "selected_regioin",
                  id: "selected_regioin_gp1",
                }}
              >
                {this.state &&
                  this.state.countryList &&
                  this.state.countryList.map &&
                  this.state.countryList.map((cl, index) => (
                    <MenuItem key={index} value={cl && cl.id} selected>
                      {`${cl && cl.region} (${cl && cl.language})`}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>
    );
  };

  handleChangeRegion = (event) => {
    this.setState({ selected_regioin: event.target.value });
  };

  getPaymentDeviceFromState = (index = 0, overrides = {}) => {
    const gateway = overrides.payment_gateway_id || this.state.paymentType || PaymentGatewayTypes.GLOBAL_PAYMENTS;
    const device = {
      ...getPaymentDeviceDefaults(gateway, index),
      ...overrides,
      payment_gateway_id: gateway,
    };

    PAYMENT_DEVICE_FIELDS.forEach((field) => {
      if (overrides[field] === undefined) {
        device[field] = this.state[field];
      }
    });

    return device;
  };

  normalizePaymentDevices = (source, gateway) => {
    let devices = [];

    if (source && Array.isArray(source.payment_devices)) {
      devices = source.payment_devices;
    } else if (source && typeof source.payment_devices === "string" && source.payment_devices.trim()) {
      try {
        const parsedDevices = JSON.parse(source.payment_devices);
        devices = Array.isArray(parsedDevices) ? parsedDevices : [];
      } catch (error) {
        devices = [];
      }
    }

    if (!devices.length) {
      const legacyDevice = getPaymentDeviceDefaults(gateway, 0);
      devices = [{
        ...legacyDevice,
        XWebId: source && source.xwebid ? source.xwebid : "",
        XWebAuthKey: source && source.xwebauthkey ? source.xwebauthkey : "",
        XWebTerminalId: source && source.xwebterminalid ? source.xwebterminalid : "",
      }];
      PAYMENT_DEVICE_FIELDS.forEach((field) => {
        if (source && source[field] !== undefined && source[field] !== null) {
          devices[0][field] = source[field];
        }
      });
    }

    const normalizedDevices = devices.map((device, index) => {
      const normalizedDevice = {
        ...getPaymentDeviceDefaults(gateway, index),
        ...device,
        id: device && device.id ? device.id : "",
        local_id: device && device.local_id ? device.local_id : (device && device.id ? device.id : createPaymentDeviceLocalId()),
        name: device && device.name ? device.name : getPaymentDeviceLabel(index),
        payment_gateway_id: (device && device.payment_gateway_id) || gateway,
        is_active: device && device.is_active !== undefined ? Boolean(device.is_active) : true,
      };

      normalizedDevice.XWebId = normalizedDevice.XWebId || normalizedDevice.xwebid || "";
      normalizedDevice.XWebAuthKey = normalizedDevice.XWebAuthKey || normalizedDevice.xwebauthkey || "";
      normalizedDevice.XWebTerminalId = normalizedDevice.XWebTerminalId || normalizedDevice.xwebterminalid || "";
      normalizedDevice.pos_terminal_id = normalizedDevice.pos_terminal_id || normalizedDevice.terminal_id || "";
      normalizedDevice.pos_merchant_site_id = normalizedDevice.pos_merchant_site_id || normalizedDevice.merchant_id || "";
      normalizedDevice.pos_api_url = normalizedDevice.pos_api_url || normalizedDevice.connector_url || "";
      normalizedDevice.pos_clerk_id = normalizedDevice.pos_clerk_id || normalizedDevice.clerk_id || normalizedDevice.store_id || "";

      return normalizedDevice;
    });

    return normalizedDevices;
  };

  getPaymentDeviceStateValues = (device) =>
    PAYMENT_DEVICE_FIELDS.reduce((values, field) => {
      if (device && device[field] !== undefined) {
        values[field] = device[field];
      }
      return values;
    }, {});

  getSelectedPaymentGatewayDevices = () => {
    const selectedGateway = this.state.paymentType || PaymentGatewayTypes.GLOBAL_PAYMENTS;
    return (this.state.paymentDevices || []).filter(
      (device) => (device.payment_gateway_id || selectedGateway) === selectedGateway
    );
  };

  getSelectedPaymentDevice = () => {
    const devices = this.getSelectedPaymentGatewayDevices();
    return (
      devices.find((device) => getPaymentDeviceUiId(device) === this.state.selectedPaymentDeviceId) ||
      devices[0] ||
      null
    );
  };

  getPaymentDevicePayload = () => {
    const selectedDevice = this.getSelectedPaymentDevice();
    const devices = (this.state.paymentDevices || []).map((device, index) => {
      const isSelectedDevice = selectedDevice && getPaymentDeviceUiId(device) === getPaymentDeviceUiId(selectedDevice);
      const values = isSelectedDevice ? this.getPaymentDeviceFromState(index, device) : device;
      const { local_id, ...devicePayload } = values;
      if (!devicePayload.id) {
        delete devicePayload.id;
      }
      return {
        ...devicePayload,
        ...(local_id ? { local_id } : {}),
        payment_gateway_id: values.payment_gateway_id || this.state.paymentType,
        is_active: values.is_active !== false,
      };
    });

    if (!devices.length) {
      return [this.getPaymentDeviceFromState(0)];
    }

    return devices;
  };

  getSelectedPaymentDeviceSubmissionValues = () => {
    const devices = this.getPaymentDevicePayload();
    const selectedGateway = this.state.paymentType || PaymentGatewayTypes.GLOBAL_PAYMENTS;
    const selectedDevice =
      devices.find((device) => getPaymentDeviceUiId(device) === this.state.selectedPaymentDeviceId) ||
      devices.find((device) => device.payment_gateway_id === selectedGateway) ||
      devices[0] ||
      {};
    return {
      ...PAYMENT_DEVICE_FIELDS.reduce((values, field) => {
        values[field] = this.state[field];
        return values;
      }, {}),
      ...this.getPaymentDeviceStateValues(selectedDevice),
      payment_devices: JSON.stringify(devices.map(({ local_id, ...device }) => device)),
    };
  };

  handlePaymentDeviceFieldChange = (field, value) => {
    const selectedGatewayDevices = this.getSelectedPaymentGatewayDevices();
    const selectedDevice = this.getSelectedPaymentDevice();
    const selectedDeviceId =
      (selectedDevice && getPaymentDeviceUiId(selectedDevice)) ||
      createPaymentDeviceLocalId();
    const draftDevice = selectedDevice || this.getPaymentDeviceFromState(selectedGatewayDevices.length, {
      local_id: selectedDeviceId,
      payment_gateway_id: this.state.paymentType,
    });
    const existingDevices = this.state.paymentDevices && this.state.paymentDevices.length
      ? this.state.paymentDevices
      : [];
    const deviceExists = existingDevices.some(
      (device) => getPaymentDeviceUiId(device) === selectedDeviceId
    );
    const nextDevices = deviceExists ? existingDevices : [...existingDevices, draftDevice];

    this.setState({
      [field]: value,
      paymentDevices: nextDevices.map((device) =>
        getPaymentDeviceUiId(device) === selectedDeviceId
          ? {
              ...device,
              payment_gateway_id: this.state.paymentType,
              [field]: value,
            }
          : device
      ),
      selectedPaymentDeviceId: selectedDeviceId,
    });
  };

  handlePaymentDeviceNameChange = (deviceId, name) => {
    this.setState({
      paymentDevices: (this.state.paymentDevices || []).map((device) =>
        getPaymentDeviceUiId(device) === deviceId ? { ...device, name } : device
      ),
    });
  };

  handleSelectPaymentDevice = (deviceId) => {
    const device = this.getSelectedPaymentGatewayDevices().find((item) => getPaymentDeviceUiId(item) === deviceId);
    if (!device) {
      return;
    }

    this.setState({
      selectedPaymentDeviceId: getPaymentDeviceUiId(device),
      ...this.getPaymentDeviceStateValues(device),
    });
  };

  handleAddPaymentDevice = () => {
    const devices = this.getPaymentDevicePayload();
    const selectedGatewayDevices = devices.filter(
      (device) => device.payment_gateway_id === this.state.paymentType
    );
    const nextDevice = getPaymentDeviceDefaults(this.state.paymentType, selectedGatewayDevices.length);
    const nextDevices = [...devices, nextDevice];

    this.setState({
      paymentDevices: nextDevices,
      selectedPaymentDeviceId: getPaymentDeviceUiId(nextDevice),
      ...this.getPaymentDeviceStateValues(nextDevice),
    });
  };

  handleRemovePaymentDevice = (deviceId) => {
    const devices = (this.state.paymentDevices || []).filter((device) => getPaymentDeviceUiId(device) !== deviceId);
    const selectedGatewayDevices = devices.filter(
      (device) => device.payment_gateway_id === this.state.paymentType
    );
    if (!selectedGatewayDevices.length) {
      const fallbackDevice = getPaymentDeviceDefaults(this.state.paymentType, 0);
      const nextDevices = [...devices, fallbackDevice];
      this.setState({
        paymentDevices: nextDevices,
        selectedPaymentDeviceId: getPaymentDeviceUiId(fallbackDevice),
        ...this.getPaymentDeviceStateValues(fallbackDevice),
      });
      return;
    }

    const selectedDevice = selectedGatewayDevices.find((device) => getPaymentDeviceUiId(device) === this.state.selectedPaymentDeviceId) ||
      selectedGatewayDevices[0];

    this.setState({
      paymentDevices: devices,
      selectedPaymentDeviceId: getPaymentDeviceUiId(selectedDevice),
      ...this.getPaymentDeviceStateValues(selectedDevice),
    });
  };

  getPaymentDeviceSummary = (device) => {
    if (!device) {
      return "No device selected";
    }

    const values = [
      device.pos_terminal_id,
      device.pos_merchant_site_id,
      device.pos_clerk_id,
      device.instamed_workstation_id,
      device.XWebTerminalId,
      device.pos_bridge_hostname,
    ].filter((value) => value !== undefined && value !== null && String(value).trim() !== "");

    return values.length ? values.slice(0, 2).join(" • ") : "Details not configured";
  };

  getPaymentDeviceFacts = (device) => {
    if (!device) {
      return [];
    }

    const gateway = this.state.paymentType;
    const facts = [];
    const addFact = (label, value) => {
      if (value !== undefined && value !== null && String(value).trim() !== "") {
        facts.push({ label, value: String(value) });
      }
    };

    if (gateway === PaymentGatewayTypes.FISERV_CARDPOINTE) {
      addFact("Terminal", device.pos_terminal_id);
      addFact("Merchant", device.pos_merchant_site_id);
      addFact("Mode", device.pos_clover_go_enabled ? "Clover Go" : device.pos_manual_entry_enabled ? "Manual Entry" : "Terminal");
    } else if (gateway === PaymentGatewayTypes.TRUST_COMMERCE) {
      addFact("Terminal", device.pos_terminal_id);
      addFact("API", device.pos_api_url);
      addFact("Mode", device.pos_manual_entry_enabled ? "Manual Entry" : device.pos_manual_entry_button_enabled ? "Manual Button" : "Terminal");
    } else if (gateway === PaymentGatewayTypes.JPMC_INSTAMED) {
      addFact("Terminal", device.pos_terminal_id);
      addFact("Merchant", device.pos_merchant_site_id);
      addFact("Store", device.pos_clerk_id);
      addFact("Workstation", device.instamed_workstation_id);
      addFact("SSO Alias", device.instamed_sso_alias);
    } else if (gateway === PaymentGatewayTypes.GLOBAL_PAYMENTS_GENIUS) {
      addFact("Terminal", device.pos_terminal_id);
      addFact("Merchant", device.pos_merchant_site_id);
      addFact("Host", device.pos_bridge_hostname);
      addFact("Protocol", device.pos_bridge_protocol);
    } else {
      addFact("Terminal", device.XWebTerminalId);
      addFact("Web ID", device.XWebId);
    }

    addFact("HTTPS Host", device.pos_bridge_https_hostname);
    return facts.slice(0, 5);
  };

  getPaymentDeviceTableValues = (device) => {
    if (!device) {
      return {
        terminal: "",
        merchant: "",
        connector: "",
        mode: "",
      };
    }

    const gateway = this.state.paymentType;

    if (gateway === PaymentGatewayTypes.FISERV_CARDPOINTE) {
      return {
        terminal: device.pos_terminal_id || "",
        merchant: device.pos_merchant_site_id || "",
        connector: device.pos_bridge_hostname || device.pos_bridge_https_hostname || "",
        mode: device.pos_clover_go_enabled ? "Clover Go" : device.pos_manual_entry_enabled ? "Manual" : "Terminal",
      };
    }

    if (gateway === PaymentGatewayTypes.TRUST_COMMERCE) {
      return {
        terminal: device.pos_terminal_id || "",
        merchant: "",
        connector: device.pos_api_url || "",
        mode: device.pos_manual_entry_enabled ? "Manual" : device.pos_manual_entry_button_enabled ? "Manual Button" : "Terminal",
      };
    }

    if (gateway === PaymentGatewayTypes.JPMC_INSTAMED) {
      return {
        terminal: device.pos_terminal_id || "",
        merchant: [device.pos_merchant_site_id, device.pos_clerk_id].filter(Boolean).join(" / "),
        connector: [device.instamed_workstation_id, device.instamed_sso_alias].filter(Boolean).join(" / "),
        mode: "Terminal",
      };
    }

    if (gateway === PaymentGatewayTypes.GLOBAL_PAYMENTS_GENIUS) {
      return {
        terminal: device.pos_terminal_id || "",
        merchant: device.pos_merchant_site_id || "",
        connector: device.pos_bridge_hostname || "",
        mode: device.pos_bridge_protocol || "http",
      };
    }

    return {
      terminal: device.XWebTerminalId || "",
      merchant: device.XWebId || "",
      connector: "",
      mode: "Hosted",
    };
  };

  getPaymentDeviceTableColumns = () => {
    const gateway = this.state.paymentType;

    if (gateway === PaymentGatewayTypes.GLOBAL_PAYMENTS_GENIUS) {
      return [
        { label: "Device", size: 3, type: "device" },
        { label: "Terminal", size: 2, valueKey: "terminal" },
        { label: "Merchant", size: 2, valueKey: "merchant" },
        { label: "Connector", size: 4, valueKey: "connector" },
        { label: "Remove", size: 1, type: "remove" },
      ];
    }

    if (gateway === PaymentGatewayTypes.TRUST_COMMERCE) {
      return [
        { label: "Device", size: 3, type: "device" },
        { label: "Terminal", size: 3, valueKey: "terminal" },
        { label: "API URL", size: 5, valueKey: "connector" },
        { label: "Remove", size: 1, type: "remove" },
      ];
    }

    if (gateway === PaymentGatewayTypes.JPMC_INSTAMED) {
      return [
        { label: "Device", size: 3, type: "device" },
        { label: "Terminal", size: 2, valueKey: "terminal" },
        { label: "Merchant / Store", size: 3, valueKey: "merchant" },
        { label: "Workstation / SSO", size: 3, valueKey: "connector" },
        { label: "Remove", size: 1, type: "remove" },
      ];
    }

    if (gateway === PaymentGatewayTypes.FISERV_CARDPOINTE) {
      return [
        { label: "Device", size: 3, type: "device" },
        { label: "Terminal", size: 3, valueKey: "terminal" },
        { label: "Merchant", size: 5, valueKey: "merchant" },
        { label: "Remove", size: 1, type: "remove" },
      ];
    }

    return [
      { label: "Device", size: 3, type: "device" },
      { label: "Terminal", size: 3, valueKey: "terminal" },
      { label: "Web ID", size: 5, valueKey: "merchant" },
      { label: "Remove", size: 1, type: "remove" },
    ];
  };

  renderPaymentDevicesConfiguration = () => {
    const readOnly = this.state.operation === "View";
    const devices = this.getSelectedPaymentGatewayDevices().length
      ? this.getSelectedPaymentGatewayDevices()
      : [getPaymentDeviceDefaults(this.state.paymentType, 0)];
    const selectedDevice = this.getSelectedPaymentDevice() || devices[0];
    const tableColumns = this.getPaymentDeviceTableColumns();
    return (
      <Box
        sx={{
          border: "1px solid rgba(0, 0, 0, 0.08)",
          borderRadius: 1,
          p: 1.5,
          mb: 2,
          backgroundColor: "#f8fafc",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: 1,
            mb: 2,
          }}
        >
          <Box>
            <Typography
              variant="title"
              style={{
                color: "black",
                fontWeight: 700,
                marginTop: 0,
                marginBottom: "3px",
              }}
            >
              Payment Devices
            </Typography>
            <Typography variant="caption" sx={{ display: "block", color: "text.secondary" }}>
              Devices for this location
            </Typography>
          </Box>
          <Button
            color="primary"
            variant="outlined"
            size="small"
            startIcon={<AddIcon />}
            onClick={this.handleAddPaymentDevice}
            disabled={readOnly}
            sx={{
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 700,
              backgroundColor: "#fff",
            }}
          >
            Add Device
          </Button>
        </Box>
        <Box
          sx={{
            border: "1px solid rgba(15, 23, 42, 0.08)",
            borderRadius: "8px",
            backgroundColor: "#fff",
            overflow: "hidden",
            mb: 1.5,
          }}
        >
          <Grid
            container
            sx={{
              px: 1.25,
              py: 0.75,
              backgroundColor: "#f1f5f9",
              borderBottom: "1px solid rgba(15, 23, 42, 0.08)",
            }}
          >
            {tableColumns.map((column) => (
              <Grid item xs={column.size} key={column.label}>
                <Typography
                  variant="caption"
                  sx={{
                    color: "#64748b",
                    fontSize: "0.66rem",
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: "0.02em",
                  }}
                >
                  {column.label}
                </Typography>
              </Grid>
            ))}
          </Grid>
          {devices.map((device) => {
            const deviceUiId = getPaymentDeviceUiId(device);
            const isSelected = selectedDevice && getPaymentDeviceUiId(selectedDevice) === deviceUiId;
            const values = this.getPaymentDeviceTableValues(device);
            const cellSx = {
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              fontSize: "0.8rem",
              color: "#0f172a",
              fontWeight: 600,
              lineHeight: 1.3,
            };
            const emptyCellSx = {
              ...cellSx,
              color: "#94a3b8",
              fontWeight: 500,
            };

            return (
              <Grid
                container
                key={deviceUiId}
                role="button"
                tabIndex={readOnly ? -1 : 0}
                onClick={() => !readOnly && this.handleSelectPaymentDevice(deviceUiId)}
                onKeyDown={(event) => {
                  if (!readOnly && (event.key === "Enter" || event.key === " ")) {
                    this.handleSelectPaymentDevice(deviceUiId);
                  }
                }}
                alignItems="center"
                sx={{
                  px: 1.25,
                  py: 1,
                  borderLeft: isSelected ? "4px solid #1976d2" : "4px solid transparent",
                  borderBottom: "1px solid rgba(15, 23, 42, 0.06)",
                  cursor: readOnly ? "default" : "pointer",
                  backgroundColor: isSelected ? "rgba(25, 118, 210, 0.05)" : "#fff",
                  "&:last-child": {
                    borderBottom: "none",
                  },
                  "&:hover": readOnly
                    ? {}
                    : {
                        backgroundColor: isSelected ? "rgba(25, 118, 210, 0.07)" : "#f8fafc",
                      },
                }}
              >
                {tableColumns.map((column) => {
                  if (column.type === "device") {
                    return (
                      <Grid item xs={column.size} sx={{ minWidth: 0 }} key={column.label}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
                          <Box
                            sx={{
                              width: 30,
                              height: 30,
                              borderRadius: "8px",
                              backgroundColor: isSelected ? "#1976d2" : "#e2e8f0",
                              color: isSelected ? "#fff" : "#334155",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flex: "0 0 auto",
                            }}
                          >
                            <CreditCard fontSize="small" />
                          </Box>
                          <Box sx={{ minWidth: 0, width: "100%" }}>
                            <TextField
                              value={device.name || ""}
                              onClick={(event) => event.stopPropagation()}
                              onFocus={() => !readOnly && this.handleSelectPaymentDevice(deviceUiId)}
                              onChange={(event) =>
                                this.handlePaymentDeviceNameChange(deviceUiId, event.target.value)
                              }
                              disabled={readOnly}
                              variant="outlined"
                              size="small"
                              placeholder="Device name"
                              sx={{
                                width: "100%",
                                maxWidth: 220,
                                "& .MuiOutlinedInput-root": {
                                  height: 34,
                                  borderRadius: "7px",
                                  backgroundColor: isSelected ? "#fff" : "transparent",
                                  fontWeight: 700,
                                  fontSize: "0.85rem",
                                  "& fieldset": {
                                    borderColor: isSelected ? "rgba(25, 118, 210, 0.22)" : "transparent",
                                  },
                                  "&:hover fieldset": {
                                    borderColor: "rgba(25, 118, 210, 0.35)",
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: "#1976d2",
                                    borderWidth: "1px",
                                  },
                                },
                                "& .MuiOutlinedInput-input": {
                                  py: 0.6,
                                  px: 1,
                                  color: "#0f172a",
                                  fontWeight: 700,
                                },
                              }}
                            />
                          </Box>
                        </Box>
                      </Grid>
                    );
                  }

                  if (column.type === "remove") {
                    return (
                      <Grid
                        item
                        xs={column.size}
                        sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: 34 }}
                        key={column.label}
                      >
                        <Tooltip title={devices.length <= 1 ? "At least one payment device is required" : "Remove device"}>
                          <span>
                            <IconButton
                              size="small"
                              onClick={(event) => {
                                event.stopPropagation();
                                this.handleRemovePaymentDevice(deviceUiId);
                              }}
                              disabled={readOnly || devices.length <= 1}
                              sx={{
                                color: "#8e2430",
                                border: "1px solid rgba(142, 36, 48, 0.2)",
                                borderRadius: "8px",
                                width: 32,
                                height: 32,
                                "&:hover": {
                                  backgroundColor: "rgba(142, 36, 48, 0.06)",
                                },
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </Grid>
                    );
                  }

                  const cellValue = values[column.valueKey] || "";
                  return (
                    <Grid
                      item
                      xs={column.size}
                      sx={{ display: "flex", alignItems: "center", minHeight: 34 }}
                      key={column.label}
                    >
                      <Typography variant="body2" sx={cellValue ? cellSx : emptyCellSx}>
                        {cellValue || "Not set"}
                      </Typography>
                    </Grid>
                  );
                })}
              </Grid>
            );
          })}
        </Box>
      </Box>
    );
  };

  renderLocationDialogActions = (padding = "8px 12px 8px 8px") => {
    const {classes, t} = this.props;

    return (
      <DialogActions
        sx={{
          padding,
          borderTop: "1px solid rgba(0, 0, 0, 0.08)",
          backgroundColor: "background.paper",
        }}
      >
        <Button
          onClick={this.handleClose}
          color="primary"
          className={classes.primaryButton}
        >
          {this.state.operation === "View"
            ? t("Location.CloseButton")
            : t("Location.CancelButton")}
        </Button>
        {this.state.operation !== "View" && (
          <Button
            onClick={
              this.state.operation === "Add"
                ? this.handleSubmit
                : this.handleUpdate
            }
            disabled={this.state.isButtonDisabled}
            color="primary"
            className={classes.primaryButton}
          >
            {this.state.operation === "Edit"
              ? t("Location.UpdateLocationButton")
              : t("Location.AddLocationButton")}
          </Button>
        )}
      </DialogActions>
    );
  };

  handleChangeDoorOpenDebounceInterval = (event) => {
    this.setState({ door_open_debounce_interval: event.target.value });
  };

  handleChangeDoorIntervalBetweenTwoBins = (event) => {
    this.setState({ door_interval_between_two_bins: event.target.value });
  };

  handleallowMultiBinsPickupForFastlane = (name) => (event) => {
    this.setState({
      allow_multi_bins_pickup: event.target.checked,
    });
  };

  /** Account is_pre_assignment (session) or box enable_preassign — Canada uses account flag + region, not Unplugged-only. */
  shouldSyncPreAssignmentMatrix = (box) => {
    if (isPreAssignmentAccountFromSession()) {
      return true;
    }
    return isTruthyPreAssignmentFlag(box && box.enable_preassign);
  };

  callPreAssignmentBoxesApi = async (method, boxId) => {
    const response = await fetch(
      process.env.REACT_APP_BASEURL + "pre-assignment/preAssignmentBoxes",
      {
        method,
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "content-type": "application/json",
        },
        body: JSON.stringify({ box_id: boxId }),
      }
    );
    try {
      return await response.json();
    } catch (error) {
      return null;
    }
  };

  syncPreAssignmentMatrix = async (res) => {
    const box = res && res.box;
    const boxId = box && box.id;
    if (!boxId || !this.shouldSyncPreAssignmentMatrix(box)) {
      return;
    }
    console.log(
      "Pre-assignment enabled — syncing pre_assignment bins for box",
      boxId
    );
    const postResult = await this.callPreAssignmentBoxesApi("POST", boxId);
    if (postResult && postResult.success) {
      console.log("Pre-assignment matrix seeded (POST).", postResult.message);
      return;
    }
    const putResult = await this.callPreAssignmentBoxesApi("PUT", boxId);
    if (putResult && putResult.success) {
      console.log("Pre-assignment matrix updated (PUT).", putResult.message);
      return;
    }
    const message =
      (putResult && putResult.message) ||
      (postResult && postResult.message) ||
      "Pre-assignment sync did not apply changes.";
    console.warn(message, { postResult, putResult });
  };

  savePreAssignmentEntries = (res) => this.syncPreAssignmentMatrix(res);

  updatePreAssignmentEntries = (res) => this.syncPreAssignmentMatrix(res);

  handlePortChange = (e) => {
    this.setState({ com_port: e.target.value })
  }

  handleKioskOpentimeChange = (index) => (event) => {
    event.preventDefault && event.preventDefault();
    const HoursOfOperation =
      this.state &&
      this.state.KioskHoursOfOperaionsArray &&
      this.state.KioskHoursOfOperaionsArray.map((item, idx) => {
        if (idx !== index) return item;
        return {
          id: idx,
          value: item.value,
          openTime: event.target.value,
          closeTime: item.closeTime,
          isClosed: item.isClosed,
          isOpenAll: item.isOpenAll
        };
      });
    this.setState({ KioskHoursOfOperaionsArray: HoursOfOperation });
  };

  handleKioskClosetimeChange = (index) => (event) => {
    event.preventDefault && event.preventDefault();
    const HoursOfOperation =
      this.state &&
      this.state.KioskHoursOfOperaionsArray &&
      this.state.KioskHoursOfOperaionsArray.map((item, idx) => {
        if (idx !== index) return item;
        return {
          id: idx,
          value: item.value,
          openTime: item.openTime,
          closeTime: event.target.value,
          isClosed: item.isClosed,
          isOpenAll: item.isOpenAll
        };
      });
    this.setState({ KioskHoursOfOperaionsArray: HoursOfOperation });
  };

  handleKioskBlurTime = (event) => {
    if (event && event.target && event.target.value > '23:59') {
      this.setState({ TimevalidateDialog: true });
    }
  };

  handleClosedCheckBox = (index) => (event) => {
    event.preventDefault && event.preventDefault();
    const _isChecked = event.target.checked;
    const HoursOfOperation =
      this.state &&
      this.state.KioskHoursOfOperaionsArray &&
      this.state.KioskHoursOfOperaionsArray.map((item, idx) => {
        if (idx !== index) return item;
        return {
          id: idx,
          value: item.value,
          openTime: item.openTime,
          closeTime: item.closeTime,
          isClosed: _isChecked,
          isOpenAll: item.isOpenAll
        };
      });
    this.setState({ KioskHoursOfOperaionsArray: HoursOfOperation });
  };

  handleOpenAllCheckBox = (index) => (event) => {
    event.preventDefault && event.preventDefault();
    const _isChecked = event.target.checked;
    const HoursOfOperation =
      this.state &&
      this.state.KioskHoursOfOperaionsArray &&
      this.state.KioskHoursOfOperaionsArray.map((item, idx) => {
        if (idx !== index) return item;
        return {
          id: idx,
          value: item.value,
          openTime: item.openTime,
          closeTime: item.closeTime,
          isClosed: item.isClosed,
          isOpenAll: _isChecked
        };
      });
    this.setState({ KioskHoursOfOperaionsArray: HoursOfOperation });
  };

  convertAccountHoursOfOperationsObject = async (selectedObject) => {
    if (
      selectedObject !== '' &&
      selectedObject !== null &&
      selectedObject !== 'null' &&
      selectedObject !== undefined &&
      selectedObject !== 'undefined'
    ) {
      const {
        id,
        account_id,
        created_on,
        deleted_on,
        modified_on,
        is_deleted,
        is_enabled,
        closed_msg,
        closedimg_url,
        hop_type,
        box_id,
        lunch_start,
        lunch_end,
        ...filteredObject
      } = selectedObject;
      return filteredObject;
    }
  };

  hanldeAccountHoursOfOperations = async (selectedObject) => {
    let AccountHoursOfOperationArray = [];
    if (
      selectedObject !== '' &&
      selectedObject !== null &&
      selectedObject !== 'null' &&
      selectedObject !== undefined &&
      selectedObject !== 'undefined'
    ) {
      const Keys = Object.keys(selectedObject);
      const Values = Object.values(selectedObject);
      if (Keys && Keys.length && Keys.length > 0) {
        for (let i = 0; i < Keys.length; i++) {
          const KeyName = Keys && Keys[i];
          const HoursOfTime = Values && Values[i] && Values[i].split(',');
          AccountHoursOfOperationArray.push({
            id: i,
            value: KeyName[0].toUpperCase() + KeyName.slice(1),
            openTime: HoursOfTime && HoursOfTime[0],
            closeTime: HoursOfTime && HoursOfTime[1],
            isClosed: HoursOfTime && HoursOfTime[2],
            isOpenAll: HoursOfTime && HoursOfTime[3],
          });
        }
      }
    }
    return AccountHoursOfOperationArray;
  };

  setPermissions = () => {
    let permissions = JSON.parse(sessionStorage.getItem("permissions"));
    let _checkUserRole = JSON.parse(sessionStorage.getItem("permissionUser"));
    const isIlocalUser = localStorage.getItem("isIlocalUser");
    const manageBoxes = (permissions || []).filter((item) => {
      return item && item.permission_entity_type === "Manage Boxes";
    });
    const isAllowedFlag = isAllowedPermissionFlag;
    const hasBoxPermission = (name) =>
      manageBoxes.some((x) => {
        const label = String(
          (x && (x.name || x.permission_name || x.name_lang_key)) || ""
        )
          .trim()
          .toLowerCase();
        return label === String(name).toLowerCase() && isAllowedFlag(x.is_allowed);
      });
    const isPrivilegedUser =
      [true, "true"].includes(isIlocalUser) ||
      _checkUserRole === userroles.SUPERADMIN;
    // Pickup switching applies to every location type, not Kiosk only.
    const canManagePickupSwitching =
      isPrivilegedUser || hasPickupSwitchingPermission(permissions);

    // If logged in user is ilocalbox user, always allow managing column mappings
    if ([true, "true"].includes(isIlocalUser)) {
      this.setState({
        boxedit: true,
        boxview: true,
        boxdelete: true,
        boxadd: true,
        canManageColumnMappings: true,
        canManagePickupSwitching,
      });
      return;
    }

    // Super Admin always has full access
    if (_checkUserRole === userroles.SUPERADMIN) {
      this.setState({
        boxedit: true,
        boxview: true,
        boxdelete: true,
        boxadd: true,
        canManageColumnMappings: true,
        canManagePickupSwitching,
      });
    } else if (permissions && permissions.length > 0) {
      if (manageBoxes.length > 0) {
        this.setState({
          boxadd: hasBoxPermission("Add"),
          boxedit: hasBoxPermission("Modify"),
          boxview: hasBoxPermission("View"),
          boxdelete: hasBoxPermission("Delete"),
          canManageColumnMappings: hasBoxPermission("Manage Column Mappings"),
          canManagePickupSwitching,
        });
      } else {
        this.setState({
          boxedit: false,
          boxview: false,
          boxdelete: false,
          boxadd: false,
          canManageColumnMappings: false,
          canManagePickupSwitching: hasPickupSwitchingPermission(permissions)
        });
      }
    } else {
      this.setState({
        boxedit: false,
        boxview: false,
        boxdelete: false,
        boxadd: false,
        canManageColumnMappings: false,
        canManagePickupSwitching: false
      });
    }
  }

  handleESeekChange = (name) => (event) => {
    this.setState({ is_eseek: event.target.checked });
  };

  handleInstallModeChange = (name) => (event) => {
    this.setState({ is_install_mode: event.target.checked})
  }

  handleExternalIdChangeEvent = (event) => {
    event.persist();
    this.setState({ external_id: event.target.value });
  };

  handleStrictIdChange = (name) => (event) => {
    this.setState({ is_strict_check: event.target.checked });
  };

  handleAutoReleaseOnIdScanChange = (name) => (event) => {
    this.setState({ auto_release_on_id_scan: event.target.checked });
  };

  handleEnableLifeBoat = (name) => (event) => {
    this.setState({ is_lifeboat_enabled: event.target.checked });
  };

  handleEnablePOS = (name) => (event) => {
    this.setState({ is_pos: event.target.checked });
  };

  handleEnableEcom = (name) => (event) => {
    this.setState({ is_ecom_enabled: event.target.checked });
  };

  handleEnableNonRxDeliver = (name) => (event) => {
    this.setState({ is_non_rx_deliver_enabled: event.target.checked });
  };

  handleEnableConsult = (name) => (event) => {
    this.setState({ is_consult: event.target.checked });
  };

  handleEnableIDCapture = (name) => (event) => {
    this.setState({ is_dl_capture: event.target.checked });
  };

  handleEnableKioskDobStep = (name) => (event) => {
    this.setState({ is_kiosk_dob_enabled: event.target.checked });
  };

  handleEnableKioskDobCamera = (name) => (event) => {
    this.setState({ is_kiosk_dob_camera_enabled: event.target.checked });
  };

  handleEnableSurvey = (name) => (event) => {
    this.setState({ is_survey: event.target.checked });
  };

  handleStrictPatientVerification = (name) => (event) => {
    this.setState({ strict_patient_verification: event.target.checked });
  };

  handleEnableTrim = (name) => (event) => {
    this.setState({ enable_trim: event.target.checked });
  };

  handleTrimChars = (event) => {
    this.setState({ trim_chars: event.target.value });
  };

  handleOpenCloneDialog = () => {
    const selectedObject = this.state.data.find((x) => x.id === this.state.selectedRowId);
    this.setState({
      parent_id: selectedObject.parent_account_id,
      isCloneDialog: true
    })
  }

  handleCloseCloneDialog = () => {
    this.setState({
      isCloneDialog: false,
      anchorEl: null,
      selectedRowId: null,
      parent_id: ''
    })
  }

  generateShortUniqueSuffix() {
    const timestamp = Date.now().toString(36).slice(-6); // Get the last 6 characters of the timestamp in base 36
    const randomString = Math.random().toString(36).slice(2, 6); // Short random string of 4 characters
    return `${timestamp}${randomString}`;
  }

  handleCreateClone = async (data) => {
    this.setState({ isCloneDialog: false })
    this.setState({ loader: true });
    const result = fetch(process.env.REACT_APP_BASEURL + "boxes", {
      method: "POST",
      withCredentials: true,
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
      body: data,
    });
    result
      .then((result) => {
        result.json().then(async(res) => {
          this.setState({ loader: false });
          this.handleCloseCloneDialog()
          if (res.message) {
            toast.error(this.props.t("Error while creating a clone location!"));
            console.log("Error while cloning the location!", res.message)
          } else {
            console.log("Getting body for clone", res);
            await this.syncPreAssignmentMatrix(res);
            this.BindBoxes();
            if (res.save_outcome === 'partial') toast.warn('Some location settings were not saved: ' + (res.failed_sections || []).join(', '));
            else toast.success(this.props.t("Toast.Success.BoxAdded"));
          }
        });
      })
      .catch((error) => {
        this.setState({ loader: false });
        toast.error(this.props.t("Error while creating a clone location!"));
        console.log("Error while cloning the location!", error)
        this.handleCloseCloneDialog()
      });
  }

  handleClone = async () => {
    const boxId = this.state.selectedRowId;
    if (!boxId) {
      return;
    }
    const selectedObject = this.state.data.find((x) => x.id === boxId);
    if (!selectedObject) {
      return;
    }

    this.setState({ loader: true });
    let boxDetails;
    try {
      boxDetails = await this.fetchBoxForManage(boxId);
    } catch (error) {
      this.setState({ loader: false });
      toast.error(this.props.t("Toast.Error.Generic") || "Failed to load location");
      return;
    }
    this.setState({ loader: false });
    if (!boxDetails) {
      toast.error(this.props.t("Toast.Error.Generic") || "Failed to load location");
      return;
    }

    const kiosk_hoursof_operations = this.getBoxLevelKioskHours(
      boxDetails,
      boxId
    );
    const KioskHOPObject = await this.convertAccountHoursOfOperationsObject(kiosk_hoursof_operations[0]);
    const KioskHoursOfOperations = await this.hanldeAccountHoursOfOperations(KioskHOPObject);
    const clonePaymentGateway =
      boxDetails.selected_payment_gateway === null ||
      boxDetails.selected_payment_gateway === "" ||
      boxDetails.selected_payment_gateway === "null" ||
      boxDetails.selected_payment_gateway === undefined ||
      boxDetails.selected_payment_gateway === "undefined"
        ? PaymentGatewayTypes.GLOBAL_PAYMENTS
        : boxDetails.selected_payment_gateway;
    const clonePaymentDevices = this.normalizePaymentDevices(boxDetails, clonePaymentGateway).map((device) => {
      const { id, local_id, ...devicePayload } = device;
      return id ? { ...devicePayload, id } : devicePayload;
    });
    const clonePrimaryPaymentDevice = clonePaymentDevices[0] || {};

    var data = new FormData();

    data.append('file', ![undefined, 'undefined', null, 'null', ''].includes(selectedObject.picture_url) ? selectedObject.picture_url : '');
    data.append("parent_account_id", this.state.parent_id);
    data.append("description", '');
    data.append("type_id", ![undefined, 'undefined', null, 'null', ''].includes(selectedObject.type.id) ? selectedObject.type.id : '');
    data.append("address_line_1", "");
    data.append("address_line_2", "");
    data.append("city", "");
    data.append("state", "");
    data.append("zip", "");
    data.append("box_expansions", JSON.stringify(selectedObject && selectedObject.box_expansions));
    data.append("IsActive", false);
    data.append("kiosk_box_id", "");
    data.append("Sunday", false);
    data.append("Monday", false);
    data.append("Tuesday", false);
    data.append("Wednesday", false);
    data.append("Thursday", false);
    data.append("Friday", false);
    data.append("Saturday", false);
    data.append("OpenTime", "");
    data.append("CloseTime", "");
    data.append("HopType", "BoxLevel");
    data.append("xwebid", clonePrimaryPaymentDevice.XWebId || "");
    data.append("xwebauthkey", clonePrimaryPaymentDevice.XWebAuthKey || "");
    data.append("xwebterminalid", clonePrimaryPaymentDevice.XWebTerminalId || "");
    data.append("pos_merchant_name", clonePrimaryPaymentDevice.pos_merchant_name || "");
    data.append("pos_merchant_site_id", clonePrimaryPaymentDevice.pos_merchant_site_id || "");
    data.append("pos_merchant_key", clonePrimaryPaymentDevice.pos_merchant_key || "");
    data.append("pos_software_name", clonePrimaryPaymentDevice.pos_software_name || "");
    data.append("pos_software_version", clonePrimaryPaymentDevice.pos_software_version || "");
    data.append("pos_terminal_id", clonePrimaryPaymentDevice.pos_terminal_id || "");
    data.append("pos_api_url", clonePrimaryPaymentDevice.pos_api_url || "");
    data.append("pos_clerk_id", clonePrimaryPaymentDevice.pos_clerk_id || "");
    data.append("pos_bridge_hostname", clonePrimaryPaymentDevice.pos_bridge_hostname || "");
    data.append("pos_bridge_port", clonePrimaryPaymentDevice.pos_bridge_port || 8080);
    data.append("pos_bridge_https_hostname", clonePrimaryPaymentDevice.pos_bridge_https_hostname || "");
    data.append("pos_bridge_https_port", clonePrimaryPaymentDevice.pos_bridge_https_port || 8443);
    data.append("pos_bridge_protocol", clonePrimaryPaymentDevice.pos_bridge_protocol || "http");
    data.append("instamed_sso_alias", clonePrimaryPaymentDevice.instamed_sso_alias || "");
    data.append("instamed_workstation_id", clonePrimaryPaymentDevice.instamed_workstation_id || "");
    data.append("instamed_additional_info_6", clonePrimaryPaymentDevice.instamed_additional_info_6 || "");
    data.append("pos_manual_entry_enabled", clonePrimaryPaymentDevice.pos_manual_entry_enabled || false);
    data.append("pos_manual_entry_button_enabled", clonePrimaryPaymentDevice.pos_manual_entry_button_enabled || false);
    data.append("pos_clover_go_enabled", clonePrimaryPaymentDevice.pos_clover_go_enabled || false);
    data.append("payment_devices", JSON.stringify(clonePaymentDevices));
    data.append("location_notes", selectedObject.location_notes);
    data.append("branding_name", selectedObject.branding_name || "");
    data.append("courier_type", selectedObject.courier_type && selectedObject.courier_type.length > 0 ? selectedObject.courier_type.map((val) => { return val.courier_type; }) : []);
    data.append("default_courier_type", selectedObject.courier_type && selectedObject.courier_type.length > 0 ? selectedObject.courier_type[0].default_courier_type : []);
    data.append("SimpleStart", !selectedObject.simple_start);
    data.append("express_ui", !selectedObject.simple_start);
    data.append("SimplifiedEnrollment", selectedObject.simplified_enrollment);
    data.append("openpath", selectedObject.openpath);
    data.append("openpathemail", selectedObject.openpathemail);
    data.append("openpathpassword", selectedObject.openpathpassword);
    data.append("selected_payment_gateway", clonePaymentGateway);
    data.append("location_type_id", selectedObject.location_type_id);
    data.append("is_marketplace", false);
    data.append("selected_regioin", selectedObject.selected_regioin);
    data.append("preferredlanguage", selectedObject && selectedObject.preferred_language);
    data.append("door_open_debounce_interval", selectedObject && selectedObject.door_open_debounce_interval);
    data.append("door_interval_between_two_bins", selectedObject && selectedObject.door_interval_between_two_bins);
    data.append("allow_multi_bins_pickup", selectedObject && selectedObject.allow_multi_bins_pickup);
    const selectedPayLaterMode = normalizePayLaterMode(
      selectedObject && selectedObject.pay_later_mode,
      selectedObject && selectedObject.payroll_deduct
    );
    data.append('payroll_deduct', isPayLaterEnabledForMode(selectedPayLaterMode));
    data.append('pay_later_mode', selectedPayLaterMode);
    data.append('openpathuser', selectedObject && selectedObject.openpathuser);
    if (KioskHoursOfOperations && KioskHoursOfOperations.length) {
      data.append('kiosk_hoursof_operations', JSON.stringify(KioskHoursOfOperations));
      data.append('lunch_start', kiosk_hoursof_operations[0] && kiosk_hoursof_operations[0].lunch_start);
      data.append('lunch_end', kiosk_hoursof_operations[0] && kiosk_hoursof_operations[0].lunch_end);
    }
    data.append('selected_location_id', localStorage.getItem('selectedLocation'));
    data.append('is_eseek', selectedObject && selectedObject.is_eseek);
    data.append('is_install_mode', selectedObject && selectedObject.is_install_mode);
    data.append('external_id', '');
    data.append('is_strict_check', selectedObject && selectedObject.is_strict_check);
    data.append('auto_release_on_id_scan', (selectedObject && selectedObject.auto_release_on_id_scan) || false);
    data.append('is_lifeboat_enabled', selectedObject && selectedObject.is_lifeboat_enabled);
    data.append('is_pos', selectedObject && selectedObject.is_pos);
    data.append('is_consult', selectedObject && selectedObject.is_consult);
    data.append('is_dl_capture', selectedObject && selectedObject.is_dl_capture);
    data.append(
      'is_kiosk_dob_enabled',
      selectedObject && selectedObject.is_kiosk_dob_enabled !== undefined
        ? selectedObject.is_kiosk_dob_enabled
        : true,
    );
    data.append(
      'is_kiosk_dob_camera_enabled',
      selectedObject && selectedObject.is_kiosk_dob_camera_enabled !== undefined
        ? selectedObject.is_kiosk_dob_camera_enabled
        : true,
    );
    data.append('is_survey', selectedObject && selectedObject.is_survey);
    data.append('enable_preassign', selectedObject && selectedObject.enable_preassign);
    data.append('binoccupancy_check', selectedObject && selectedObject.binoccupancy_check);
    data.append('show_request_assistance', selectedObject && selectedObject.show_request_assistance);
    data.append('enable_evaporator_temperature', selectedObject && selectedObject.enable_evaporator_temperature);
    data.append('strict_patient_verification', selectedObject && selectedObject.strict_patient_verification);
    data.append('enable_trim', selectedObject && selectedObject.enable_trim !== undefined ? selectedObject.enable_trim : false);
    data.append('trim_chars', selectedObject && typeof selectedObject.trim_chars === "string" ? selectedObject.trim_chars : SearchUtils.defaultTrimChars);

    for (let i = 0; i < (this.state.cloneCount || 1); i++) {
      const generatedName = this.generateShortUniqueSuffix();
      let currentLocationName = `${selectedObject.name} (${generatedName})`;
      data.set('name', currentLocationName);
      const brandingBase = storedText(selectedObject.branding_name);
      data.set(
        'branding_name',
        brandingBase ? `${brandingBase} (${generatedName})` : ''
      );

      await this.handleCreateClone(data, currentLocationName);

      // Add a delay of, say, 1 second (1000 ms) before the next iteration
      await new Promise(resolve => setTimeout(resolve, 1000));
    }
  }

  handleEnablePartialPayment = (name) => (event) => {
    this.setState({ is_partial_payment_enabled: event.target.checked });
  }

  handleBinOccupancyCheck = (name) => (event) => {
    this.setState({ binoccupancy_check: event.target.checked });
  }

  handleShowRequestAssistance = (name) => (event) => {
    this.setState({ show_request_assistance: event.target.checked });
  }

  handleEnableEvaoperatorTemperature = (name) => (event) => {
    this.setState({ enable_evaporator_temperature: event.target.checked });
  }

  componentWillUnmount() {
    TransactionFilterObj.searchtext = '';
  }

  render() {
    const {classes, theme, t} = this.props;
    const {selected, boxTypes, TimevalidateDialog, preferLanguage, preferredLanguage, door_open_debounce_interval, box, boxTypeId, enable_evaporator_temperature} = this.state;
    const manageLocation = this.getManageLocationOptions(t);
    const readOnly = this.state.operation === "View";
    const isIlocalUser = [true, "true"].includes(
      localStorage.getItem("isIlocalUser")
    );
    const showAutoUpdateSettingsTab =
      isIlocalUser && this.state.manage_location_name === "Kiosk";
    const showColumnMappingTab = Boolean((this.state.kiosk_box_id || (box && box.id)) && this.state.canManageColumnMappings);
    const isLocationTypeReadOnly = this.state.operation === "View" || this.state.operation === "Edit";
    var disableSelect = false;
    if (this.state.operation === "View") {
      disableSelect = true;
    } else {
      disableSelect = false;
    }
    const doorOpenTitle =
      "Add the time interval in seconds, allows patient to pick up the items. It waits till configured time";
    // const doorOpenTitleBetweenTwoBins =
    //   "Add tht time interval in seconds, allows to wait for next bin tobe opened";
    return (
      <div>
        {this.state.loader ? (
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt="loading" />
          </div>
        ) : null}
        <div>
          <Dialog
            open={TimevalidateDialog || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <div
              style={{
                background: "linear-gradient(155deg, #ce907b 0%,#ffcfa6 90%)",
              }}
            >
              <DialogContent>
                <DialogContentText
                  style={{ color: "#387371", textAlign: "center" }}
                  id="alert-dialog-description"
                >
                  <p style={{ fontSize: "30px" }}>
                    {t("Location.EnterValidTime")}
                  </p>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={(event) => this.handleCloseTimeDialog(event)}
                  color="primary"
                >
                  {t("Location.OkButton")}
                </Button>
              </DialogActions>
            </div>
          </Dialog>
        </div>

        <div className={classes.root}>
          <Dialog
            open={this.state.deleteDialogOpen || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {t("Location.AreYouSureToDelete")}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {t("Location.AreYouSureToDeleteBox")}:
                <ul>
                  {this.state.forDeletion &&
                    this.state.forDeletion.map(function (a) {
                      return <li>{a.name}</li>;
                    })}
                </ul>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.deleteConfirmClose}
                color="primary"
                className={classes.primaryButton}
              >
                {t("Location.CancelButton")}
              </Button>
              <Button
                onClick={this.deleteConfirmed}
                color="primary"
                autoFocus
                className={classes.primaryButton}
              >
                {t("Location.DeleteActions")}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Insufficient addon unit box */}

          <Dialog
            open={this.state.isInsufficientBin || false}
            // onClose={this.handleDeleteDialogClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {t("Location.AddOnsUnitExceedText")}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.addonConfigClose}
                color="primary"
                className={classes.primaryButton}
              >
                {t("Location.CloseButton")}
              </Button>
            </DialogActions>
          </Dialog>

          {/* settings for cool unit */}

          <Dialog
            open={this.state.settingDialogOpen || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              sx: { borderRadius: "5px", maxWidth: "100%", width: "35%" },
            }}
          >
            <DialogTitle id="alert-dialog-title">
              {t("Location.Addons.Settings")}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <Box component="div">
                  <TextField
                    error={this.state.errorMaxTemp}
                    variant="standard"
                    margin="normal"
                    value={this.state.maxtemp}
                    id="maxtemp"
                    InputProps={{
                      readOnly: Boolean(readOnly),
                      autocomplete: "new-password",
                      form: {
                        autocomplete: "off",
                      },
                      startAdornment: <InputAdornment position="start">{t("Location.Addons.MaxTempAlert")}</InputAdornment>,
                    }}
                    placeholder={t(
                      "Location.Addons.MaxTemperaturePlaceHolder"
                    )}
                    onChange={this.handleMaxTempChange}
                    helperText={
                      this.state.errorMaxTemp === true ? "error" : ""
                    }
                    sx={{ width: "70%" }}
                  />
                  <TextField
                    error={this.state.errorSetTemp}
                    variant="standard"
                    className={classes.oneThirdTextField}
                    margin="normal"
                    value={this.state.setTemp}
                    id="settemp"
                    InputProps={{
                      readOnly: Boolean(readOnly),
                      autocomplete: "new-password",
                      form: {
                        autocomplete: "off",
                      },
                      startAdornment: <InputAdornment position="start">{t("Location.Addons.TargetTemperature")}</InputAdornment>,
                    }}
                    placeholder={t("Location.Addons.SetTempPlaceHolder")}
                    onChange={this.handleSetTempChange}
                    helperText={
                      this.state.errorSetTemp === true ? "error" : ""
                    }
                    sx={{ width: "70%" }}
                  />
                  <TextField
                    error={this.state.errorMinTemp}
                    variant="standard"
                    className={classes.oneThirdTextField}
                    margin="normal"
                    value={this.state.mintemp}
                    id="mintemp"
                    InputProps={{
                      readOnly: Boolean(readOnly),
                      autocomplete: "new-password",
                      form: {
                        autocomplete: "off",
                      },
                      startAdornment: <InputAdornment position="start">{t("Location.Addons.MnTempAlert")}</InputAdornment>,
                    }}
                    placeholder={t(
                      "Location.Addons.MinTemperaturePlaceHolder"
                    )}
                    onChange={this.handleMinTempChange}
                    helperText={
                      this.state.errorMinTemp === true ? "error" : ""
                    }
                    sx={{ width: "70%" }}
                  />
                  <FormControl variant="standard" sx={{width: "70%" }}>
                    <InputLabel id="demo-simple-select-standard-label">{t("Location.Addons.Port")}</InputLabel>
                    <Select
                      value={this.state.com_port}
                      defaultValue={"COM2"}
                      onChange={(e)=>this.handlePortChange(e)}
                    >
                      <MenuItem value={"COM2"}>COM 2</MenuItem>
                      <MenuItem value={"COM3"}>COM 3</MenuItem>
                      <MenuItem value={"COM4"}>COM 4</MenuItem>
                      <MenuItem value={"COM5"}>COM 5</MenuItem>
                      <MenuItem value={"COM6"}>COM 6</MenuItem>
                      <MenuItem value={"COM7"}>COM 7</MenuItem>
                      <MenuItem value={"COM8"}>COM 8</MenuItem>
                      <MenuItem value={"COM9"}>COM 9</MenuItem>
                      <MenuItem value={"COM10"}>COM 10</MenuItem>
                      <MenuItem value={"COM11"}>COM 11</MenuItem>
                      <MenuItem value={"COM12"}>COM 12</MenuItem>
                      <MenuItem value={"COM13"}>COM 13</MenuItem>
                      <MenuItem value={"COM14"}>COM 14</MenuItem>
                      <MenuItem value={"COM15"}>COM 15</MenuItem>
                      <MenuItem value={"COM16"}>COM 16</MenuItem>
                      <MenuItem value={"COM17"}>COM 17</MenuItem>
                      <MenuItem value={"COM18"}>COM 18</MenuItem>
                      <MenuItem value={"COM19"}>COM 19</MenuItem>
                      <MenuItem value={"COM20"}>COM 20</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleCloseSettings}
                color="primary"
                className={classes.primaryButton}
              >
                {t("Location.Addons.CancelButton")}
              </Button>
              <Button
                onClick={this.saveCoolBoxSettings}
                color="primary"
                autoFocus
                className={classes.primaryButton}
              >
                {t("Location.Addons.SaveButton")}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Edit dialog box */}
          <Dialog
            maxWidth={"sm"}
            fullWidth={true}
            open={this.state.showNewBoxDialog || false}
            onClose={this.handleClose}
            aria-labelledby="form-dialog-title"
            classes={{ paper: classes.Paper }}
            PaperProps={{
              sx: {
                display: "flex",
                flexDirection: "column",
                height: "min(717px, calc(100vh - 64px))",
                maxHeight: "calc(100vh - 64px)",
                overflow: "hidden",
              },
            }}
          >
            {this.state.loader ? (
              <div className={classes.spinner}>
                <img
                  className={classes.spinnerImage}
                  src={spinner}
                  alt="loading"
                />
              </div>
            ) : null}
            {this.state.manage_location_name === "Kiosk" ? (
              <div style={{ display: "flex", flexDirection: "column", minHeight: 0 }}>
                <AppBar position="static" color="default">
                  <Tabs
                    value={this.state.selectedTab}
                    onChange={this.handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                  >
                    <Tab
                      label={t("Location.Details.Details")}
                      style={{ minWidth: LOCATION_TAB_MIN_WIDTH }}
                    />
                    <Tab
                      label={t("Location.Settings.Settings")}
                      style={{ minWidth: LOCATION_TAB_MIN_WIDTH }}
                    />
                    <Tab
                      label={t("Location.Addons.AddOns")}
                      style={{ minWidth: LOCATION_TAB_MIN_WIDTH }}
                    />
                    <Tab
                      label={t("Location.POS.PosConfiguration")}
                      style={{ minWidth: LOCATION_TAB_MIN_WIDTH }}
                    />
                    {showAutoUpdateSettingsTab ? (
                      <Tab
                        label={t("Location.AutoUpdate.Tab")}
                        style={{ minWidth: "200px" }}
                      />
                    ) : null}
                    {showColumnMappingTab && (
                      <Tab
                        label={t("Location.ColumnMapping.ColumnMapping")}
                        style={{ minWidth: LOCATION_TAB_MIN_WIDTH }}
                      />
                    )}
                    {this.state.canManagePickupSwitching ? (
                      <Tab
                        icon={<PickupSwitchingTabIcon fontSize="small" />}
                        iconPosition="start"
                        label={t("Location.PickupSwitching.Tab", {
                          defaultValue: "Pickup switching",
                        })}
                        style={{ minWidth: LOCATION_TAB_MIN_WIDTH }}
                      />
                    ) : null}
                    {this.state.operation === 'View' ?
                      <Tab
                        label={t("Location.TestDetails.TestDetails")}
                        style={{ minWidth: "160px" }}
                      /> : ""}
                    <Tab label="Windows" style={{ minWidth: LOCATION_TAB_MIN_WIDTH }} />
                  </Tabs>
                </AppBar>

                <SwipeableViews
                  style={{
                    maxWidth: "1025px",
                    flex: "1 1 auto",
                    overflowY: "auto",
                    minHeight: 0,
                  }}
                  axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                  index={this.state.selectedTab}
                  onChangeIndex={index => this.handleChangeIndex(index)}
                >
                  {React.Children.toArray([
                  <TabContainer dir={theme.direction}>
                    <div className={classes.paddedBoxDivEdit}>
                      {/* Box title */}
                      <ValidatorForm
                        ref="form"
                        instantValidate={false}
                        onSubmit={
                          this.state.operation === "Add"
                            ? this.handleSubmit
                            : this.handleUpdate
                        }
                      >
                        <DialogTitle id="form-dialog-title">
                          {t(this.state.operation)}{" "}
                          {t("Location.Details.Locations")}
                        </DialogTitle>
                        <DialogContent>
                          <div className={classes.errorDiv}>
                            {this.state.errorMessage}
                          </div>
                          <div style={{ display: "flex", alignItems: "end" }}>
                            <div ref={this.firstErrorRef} style={{ width: "500px" }}>
                              <Selector
                                id="parent_id"
                                label={t("Location.Details.ParentAccount")}
                                values={this.state.accountValues}
                                selected={this.state.parent_id}
                                onBlur={this.handleChange}
                                disableWhenViewSelect={disableSelect}
                              />
                              {this.state.validationErrors && this.state.validationErrors.parent_id && (
                                <FormHelperText error>{this.state.validationErrors.parent_id}</FormHelperText>
                              )}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginLeft: "5%",
                              }}
                            >
                              <div
                                className={classNames(classes.title)}
                                style={{
                                  color: "#a5a5a5",
                                  float: "left",
                                }}
                              >
                                <span>
                                  {t("Location.Details.LocationIsActiveToggle")}
                                </span>
                              </div>
                              <div
                                className={classNames(classes.flexItemToggle)}
                                style={{ color: "#a5a5a5" }}
                              >
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  disableRipple
                                  checked={this.state.IsActive}
                                  onChange={this.handleChangeActive}
                                  value={this.state.IsActive}
                                  color="primary"
                                  // style={{marginTop:"3%"}}
                                  disabled={this.state.operation === "View"}
                                />
                              </div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginLeft: "2%",
                              }}
                            >
                              <div
                                className={classNames(classes.title)}
                                style={{
                                  color: "#a5a5a5",
                                  float: "left",
                                }}
                              >
                                <span>
                                  {t("Location.Details.MarketplaceToggle")}
                                </span>
                              </div>
                              <div
                                className={classNames(classes.flexItemToggle)}
                                style={{ color: "#a5a5a5" }}
                              >
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  disableRipple
                                  checked={this.state.is_marketplace}
                                  onChange={this.handleChangeMarketplace}
                                  value={this.state.is_marketplace}
                                  color="primary"
                                  disabled={this.state.operation === "View"}
                                />
                              </div>
                            </div>
                          </div>
                          <div className={classes.twoChildren}>
                            <div className={classes.leftChild}>
                              <div style={{ display: "flex" }}>
                                {/* <TextValidator
                                    autoFocus
                                    className={classes.halfTextField}
                                    margin="normal"
                                    value={this.state.name}
                                    id="name"
                                    name="name"
                                    inputProps={{ readOnly: Boolean(readOnly), maxLength: 50 }}
                                    label="Location Name"
                                    placeholder=""
                                    onChange={this.handleChange}
                                  validators={['required','matchRegexp:^[a-zA-Z0-9 ]*$']}
                                  errorMessages={[t('Validation.EnterFirstName'),t('Validation.UseAlphaDigits')]}
                                  />
                                  <TextValidator
                                    className={classes.halfTextField}
                                    margin="normal"
                                    value={this.state.description}
                                    id="description"
                                    name="description"
                                    inputProps={{ readOnly: Boolean(readOnly), maxLength: 100 }}
                                    label="Description"
                                    placeholder=""
                                    onChange={this.handleChange}
                                  /> */}
                              </div>
                              {/* <br />
                                  <br /> */}
                              <div
                                style={{ display: "flex", marginTop: "1rem" }}
                              >
                                <FormControl
                                  className={classes.boxType}
                                  error={!!this.state.validationErrors && this.state.validationErrors.location_type}
                                >
                                  <InputLabel
                                    htmlFor="type_id"
                                    sx={{ marginLeft: "-12px" }}
                                  >
                                    {t("Location.Details.LocationType")}
                                  </InputLabel>
                                  <Select
                                    value={
                                      this.state.manage_location_name || ""
                                    }
                                    onChange={(e) =>
                                      this.handleLocationType(e.target.value)
                                    }
                                    inputProps={{
                                      name: "type_id",
                                      id: "type_id",
                                    }}
                                    readOnly={readOnly}
                                    disabled={isLocationTypeReadOnly}
                                    variant="standard"
                                  >
                                    {manageLocation &&
                                      manageLocation.map((type, index) => (
                                        <MenuItem
                                          key={index}
                                          value={type.value}
                                          selected
                                          className={classes.menuItem}
                                          sx={{ height: "46px" }}
                                        >
                                          {type.label}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                  {this.state.validationErrors && this.state.validationErrors.location_type && (
                                    <FormHelperText error>{this.state.validationErrors.location_type}</FormHelperText>
                                  )}
                                  {this.renderLocationTypeLicenseHelp(t)}
                                </FormControl>

                                {this.state.manage_location_name !== "Kiosk" ? (
                                  ""
                                ) : (
                                  <FormControl
                                    className={classes.boxType}
                                    error={!!this.state.validationErrors && this.state.validationErrors.box_type}
                                  >
                                    <InputLabel
                                      htmlFor="type_id"
                                      sx={{ marginLeft: "-12px" }}
                                    >
                                      {t("Location.Details.BoxType")}
                                    </InputLabel>
                                    <Select
                                      value={this.state.type_id || ""}
                                      onChange={this.handleChange}
                                      inputProps={{
                                        name: "type_id",
                                        id: "type_id",
                                      }}
                                      readOnly={readOnly}
                                      disabled={
                                        this.state.manage_location_name !==
                                        "Kiosk"
                                      }
                                      variant="standard"
                                    >
                                      {boxTypes &&
                                        boxTypes.map((type, index) => (
                                          <MenuItem
                                            key={index}
                                            value={type.id}
                                            selected
                                            className={classes.menuItem}
                                            sx={{ height: "46px" }}
                                          >
                                            {type.label}
                                          </MenuItem>
                                        ))}
                                    </Select>
                                    {this.state.validationErrors && this.state.validationErrors.box_type && (
                                      <FormHelperText error>{this.state.validationErrors.box_type}</FormHelperText>
                                    )}
                                  </FormControl>
                                )}
                              </div>
                              <div style={{ display: "flex" }}>
                                <TextValidator
                                  autoFocus
                                  className={classes.halfTextField}
                                  margin="normal"
                                  value={this.state.name}
                                  id="name"
                                  name="name"
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    maxLength: 50,
                                  }}
                                  label={locationFieldLabel(
                                    t("Location.Details.LocationName"),
                                    t("Location.Details.LocationNameInfo")
                                  )}
                                  placeholder=""
                                  onChange={this.handleChange}
                                  validators={["required"]}
                                  errorMessages={t("Validation.Required")}
                                  error={!!this.state.validationErrors && this.state.validationErrors.name}
                                  helperText={this.state.validationErrors && this.state.validationErrors.name}
                                  variant="standard"
                                />
                                <TextValidator
                                  className={classes.halfTextField}
                                  margin="normal"
                                  value={this.state.branding_name}
                                  id="branding_name"
                                  name="branding_name"
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    maxLength: 100,
                                  }}
                                  label={locationFieldLabel(
                                    t("Location.Details.BrandingName"),
                                    t("Location.Details.BrandingNameInfo")
                                  )}
                                  placeholder=""
                                  onChange={this.handleChange}
                                  variant="standard"
                                />
                              </div>
                              <div style={{ display: "flex" }}>
                                <TextField
                                  className={classes.halfTextField}
                                  margin="normal"
                                  value={this.state.location_notes}
                                  id="location_notes"
                                  inputProps={{
                                    maxLength: 100,
                                    readOnly: Boolean(readOnly),
                                    autocomplete: "new-password",
                                    form: {
                                      autocomplete: "off",
                                    },
                                  }}
                                  label={t("Location.Details.LocationNotes")}
                                  placeholder=""
                                  onChange={(e) =>
                                    this.handleChangeHandler(e.target.value)
                                  }
                                  style={{ marginTop: "10px" }}
                                  variant="standard"
                                />
                                <TextValidator
                                  className={classes.halfTextField}
                                  margin="normal"
                                  value={this.state.description}
                                  id="description"
                                  name="description"
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    maxLength: 100,
                                  }}
                                  label={t("Location.Details.Description")}
                                  placeholder=""
                                  onChange={this.handleChange}
                                  variant="standard"
                                />
                              </div>
                            </div>
                            <div className={classes.rightChild}>
                              <div className={classes.dropbox}>
                                {readOnly ? (
                                  <div>
                                    {!this.state.avatarPreview && (
                                      <AddBoxImage
                                        className={classes.dropImage}
                                      />
                                    )}
                                    {this.state.avatarPreview && (
                                      <img
                                        alt=""
                                        src={this.state.avatarPreview}
                                        className={classes.dropPic}
                                      />
                                    )}
                                  </div>
                                ) : (
                                  <Dropzone
                                    id="avatardropzone"
                                    onDrop={this.handleDrop.bind(this)}
                                    className={classes.innerBox}
                                  >
                                    {!this.state.avatarPreview && (
                                      <AddBoxImage
                                        className={classes.dropImage}
                                      />
                                    )}
                                    {this.state.avatarPreview && (
                                      <img
                                        alt=""
                                        src={this.state.avatarPreview}
                                        className={classes.dropPic}
                                      />
                                    )}
                                  </Dropzone>
                                )}
                              </div>
                              <div
                                variant="caption"
                                style={{ paddingTop: "40px" }}
                              >
                                <p className={classes.captionText}>
                                  {t("Location.Details.UploadImageTitle")}
                                </p>
                                <Button onClick={this.removeImg}>
                                  {t("Location.Details.RemoveImageButton")}
                                </Button>
                              </div>
                            </div>
                          </div>
                          <Typography
                            variant="title"
                            style={{
                              paddingTop: "40px",
                              fontSize: "1.3125rem",
                              fontWeight: 500,
                              lineHeight: "1.16667em",
                            }}
                          >
                            {t("Location.Details.LocationAddress")}
                          </Typography>
                          <div style={{ display: "flex" }}>
                            <TextValidator
                              margin="dense"
                              className={classes.halfTextField}
                              value={this.state.address1}
                              id="address1"
                              name="address1"
                              inputProps={{
                                readOnly: Boolean(readOnly),
                                maxLength: 100,
                              }}
                              label={t("Location.Details.AddressLine1")}
                              placeholder=""
                              onChange={this.handleChange}
                              validators={["required"]}
                              errorMessages={[
                                t("Validation.EnterAddressLine"),
                                t("Validation.UseAlphaDigits"),
                              ]}
                              error={!!this.state.validationErrors && this.state.validationErrors.address1}
                              helperText={this.state.validationErrors && this.state.validationErrors.address1}
                              variant="standard"
                            />
                            <TextField
                              className={classes.halfTextField}
                              margin="normal"
                              defaultValue={this.state.address2}
                              id="address2"
                              inputProps={{
                                maxLength: 100,
                                readOnly: Boolean(readOnly),
                                autocomplete: "new-password",
                                form: {
                                  autocomplete: "off",
                                },
                              }}
                              label={t("Location.Details.AddressLine2")}
                              placeholder=""
                              onBlur={this.handleChange}
                              style={{ marginTop: "4px" }}
                              variant="standard"
                            />
                          </div>
                          <br />
                          <div style={{ display: "flex" }}>
                            <TextValidator
                              className={classes.ThirdTextField}
                              margin="normal"
                              value={this.state.city}
                              id="city"
                              name="city"
                              inputProps={{
                                readOnly: Boolean(readOnly),
                                maxLength: 50,
                              }}
                              label={t("Location.Details.City")}
                              placeholder=""
                              onChange={this.handleChange}
                              validators={["required"]}
                              errorMessages={[
                                t("Validation.EnterCity"),
                                t("Validation.UseAlphabets"),
                              ]}
                              error={!!this.state.validationErrors && this.state.validationErrors.city}
                              helperText={this.state.validationErrors && this.state.validationErrors.city}
                              variant="standard"
                            />
                            <TextValidator
                              className={classes.ThirdTextField}
                              margin="normal"
                              value={this.state.state}
                              id="state"
                              name="state"
                              inputProps={{
                                readOnly: Boolean(readOnly),
                                maxLength: 50,
                              }}
                              label={t("Location.Details.State")}
                              placeholder=""
                              onChange={this.handleChange}
                              validators={["required"]}
                              errorMessages={[
                                t("Validation.EnterState"),
                                t("Validation.UseAlphabets"),
                              ]}
                              error={!!this.state.validationErrors && this.state.validationErrors.state}
                              helperText={this.state.validationErrors && this.state.validationErrors.state}
                              variant="standard"
                            />
                            <TextValidator
                              className={classes.ThirdTextField}
                              margin="normal"
                              value={this.state.zip}
                              id="zip"
                              name="zip"
                              inputProps={{
                                readOnly: Boolean(readOnly),
                              }}
                              label={t("Location.Details.Zip")}
                              placeholder=""
                              onChange={this.handleChange}
                              validators={["required"]}
                              errorMessages={[t("Validation.zip")]}
                              error={!!this.state.validationErrors && this.state.validationErrors.zip}
                              helperText={this.state.validationErrors && this.state.validationErrors.zip}
                              variant="standard"
                            />
                          </div>
                          <br />
                        </DialogContent>
                      </ValidatorForm>
                    </div>
                  </TabContainer>,
                  /* Settings tab */
                  <TabContainer dir={theme.direction}>
                  <ValidatorForm
                    ref="form"
                    onSubmit={
                      this.state.operation === "Add"
                        ? this.handleSubmit
                        : this.handleUpdate
                    }
                  >
                    <TabContainer dir={theme.direction}>
                      <Grid
                        xs={12}
                        container
                        gap={4}
                        spacing={2}
                        sx={{ p: "24px !important" }}
                      >
                        <Grid item xs={5} md={5} lg={5}>
                          <Box sx={{ m: "0 16px 16px", width: "60%" }}>
                            <TextField
                              id="BoxId"
                              name="BoxId"
                              autoFocus={true}
                              autoComplete="off"
                              label={t("Location.Settings.BoxID")}
                              onChange={(event) =>
                                this.handleKioskBoxIDChangeEvent(event)
                              }
                              value={this.state.kiosk_box_id || ""}
                              disabled={readOnly}
                              inputProps={{
                                autocomplete: "new-password",
                                form: {
                                  autocomplete: "off",
                                },
                              }}
                              variant="standard"
                              fullWidth
                            />
                          </Box>
                          <Box sx={{ m: "0 16px 16px", width: "60%" }}>
                            <FormControl
                              variant="standard"
                              fullWidth
                            >
                              <InputLabel id="preferred-language-label">
                                {t("Users.UserDetails.PreferredLanguage")}
                              </InputLabel>
                              <Select
                                labelId="preferred-language-label"
                                id="preferred-language-select-standard"
                                value={preferLanguage || ""}
                                readOnly={readOnly}
                                onChange={(e) => {
                                  this.setState({
                                    preferLanguage: e.target.value,
                                  });
                                }}
                                label={t("Users.UserDetails.PreferredLanguage")}
                              >
                                {preferredLanguage.map((item, index) => (
                                  <MenuItem
                                    key={index}
                                    value={item && item.id}
                                    selected
                                  >
                                    {item && item.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Box>
                          <Box sx={{ m: "0 16px 16px", width: "60%" }}>
                            <TextField
                              id="ExternalId"
                              name="ExternalId"
                              label={t("Location.lblExternalId")}
                              onChange={(event) =>
                                this.handleExternalIdChangeEvent(event)
                              }
                              value={this.state.external_id || ""}
                              disabled={readOnly}
                              inputProps={{
                                autocomplete: "new-password",
                                form: {
                                  autocomplete: "off",
                                },
                              }}
                              variant="standard"
                              fullWidth
                            />
                          </Box>
                          {[true, "true"].includes(localStorage.getItem("isIlocalUser")) &&
                          (this.state.manage_location_name === "Kiosk" ||
                            this.state.location_type_id === LOCATION_TYPE.Kiosk) &&
                          typeof this.state.enable_bulk_remove === "boolean" ? (
                            <Box sx={{ m: "0 16px 16px", width: "60%" }}>
                              <FormControlLabel
                                label={
                                  <span style={{ fontSize: 16, color: "rgb(165, 165, 165)" }}>
                                    {t("Location.Settings.EnableBulkRemove")}
                                  </span>
                                }
                                control={
                                  <Switch
                                    id="EnableBulkRemove"
                                    checked={this.state.enable_bulk_remove}
                                    color="primary"
                                    onChange={(event) =>
                                      this.setState({
                                        enable_bulk_remove: event.target.checked,
                                      })
                                    }
                                    disabled={readOnly}
                                  />
                                }
                              />
                              <FormHelperText sx={{ mt: 0 }}>
                                {t("Location.Settings.EnableBulkRemoveHelp")}
                              </FormHelperText>
                            </Box>
                          ) : null}
                          <Box sx={{ mt: '16px' }}>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                  {t(
                                    "Location.Settings.SimplifiedEnrollmentToggle"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.SimplifiedEnrollment}
                                  color="primary"
                                  onChange={this.handleSwitchSimplified("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                          {/* <Box>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                  {t("Location.Exxpress.UI")}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.simpleOrExpressUI}
                                  color="primary"
                                  onChange={this.handleSwitchChange}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box> */}
                          <Box>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                  {t("Location.Settings.OpenPath")}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.openpath}
                                  color="primary"
                                  onChange={this.handleSwitchopenpath}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                          {(box && box.type_id === BOX_TYPE.FASTLANE) ||
                            boxTypeId === BOX_TYPE.FASTLANE ? (
                            <div>
                              <Box sx={{ mt: "5px", ml: "16px", mb: "5px" }}>
                                <FormControl style={{ marginBottom: "5px" }}>
                                  <InputLabel
                                    htmlFor="door_open_debounce_interval"
                                    sx={{ ml: "-15px" }}
                                  >
                                    Door Open Interval
                                  </InputLabel>
                                  <Input
                                    margin="normal"
                                    style={{ width: "235px", minWidth: "235px" }}
                                    value={door_open_debounce_interval || 0}
                                    id="door_open_debounce_interval"
                                    name="door_open_debounce_interval"
                                    autoComplete="new-password"
                                    label="Door Open Debounce Interval"
                                    placeholder="door_open_debounce_interval"
                                    onChange={
                                      this.handleChangeDoorOpenDebounceInterval
                                    }
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <Tooltip
                                          title={doorOpenTitle}
                                          className={classes.customWidth}
                                        >
                                          <Help
                                            className={classes.helpIcon}
                                          ></Help>
                                        </Tooltip>
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>
                              </Box>
                            </div>
                          ) : (
                            ""
                          )}
                          <Box>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                  {t(
                                    "Location.Settings.isESeek"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.is_eseek}
                                  color="primary"
                                  onChange={this.handleESeekChange("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                          <Box>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                  {t(
                                    "Location.Settings.isInstallMode"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.is_install_mode}
                                  color="primary"
                                  onChange={this.handleInstallModeChange("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                          <Box style={{display:"flex",alignItems:"center"}}>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                  {t(
                                    "Location.Settings.isStrictIdCheck"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.is_strict_check}
                                  color="primary"
                                  onChange={this.handleStrictIdChange("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                            <Tooltip title={t('Location.Settings.StrictIdCheckInfo')}>
                              <Help
                                className={classes.helpIcon}
                              ></Help>
                            </Tooltip>
                          </Box>
                          <Box style={{display:"flex",alignItems:"center"}}>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                  {t(
                                    "Location.Settings.AutoReleaseOnIdScan"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.auto_release_on_id_scan}
                                  color="primary"
                                  onChange={this.handleAutoReleaseOnIdScanChange("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                            <Tooltip title={t('Location.Settings.AutoReleaseOnIdScanInfo')}>
                              <Help
                                className={classes.helpIcon}
                              ></Help>
                            </Tooltip>
                          </Box>
                          <Box style={{display:"flex",alignItems:"center"}}>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                 {t(
                                    "Location.Settings.EnableLifeboat"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.is_lifeboat_enabled}
                                  color="primary"
                                  onChange={this.handleEnableLifeBoat("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                          <Box style={{display:"flex",alignItems:"center"}}>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                 {t(
                                    "Location.Settings.EnablePartialPayment"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.is_partial_payment_enabled}
                                  color="primary"
                                  onChange={this.handleEnablePartialPayment("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                          <Box style={{display:"flex",alignItems:"center"}}>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                 {t(
                                    "Location.Settings.BinOccupancyCheck"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.binoccupancy_check}
                                  color="primary"
                                  onChange={this.handleBinOccupancyCheck("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                          <Box style={{display:"flex",alignItems:"center"}}>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                 {t(
                                    "Location.WorkFlow.Ecom"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.is_ecom_enabled}
                                  color="primary"
                                  onChange={this.handleEnableEcom("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                          {[true, "true"].includes(localStorage.getItem("isIlocalUser")) && (
                          <Box style={{display:"flex",alignItems:"center"}}>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                 {t(
                                    "Location.WorkFlow.NonRxDeliver"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.is_non_rx_deliver_enabled}
                                  color="primary"
                                  onChange={this.handleEnableNonRxDeliver("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                            <Tooltip title={t("Location.WorkFlow.NonRxDeliverTooltip")}>
                              <Help className={classes.helpIcon}></Help>
                            </Tooltip>
                          </Box>
                          )}
                          <Box style={{display:"flex",alignItems:"center"}}>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                 {t(
                                    "Location.Settings.EnableEvaoperatorTemperature"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={enable_evaporator_temperature}
                                  color="primary"
                                  onChange={this.handleEnableEvaoperatorTemperature("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                          <Box style={{display:"flex",alignItems:"center", marginBottom: '5%'}}>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                 {t(
                                    "Location.Settings.ShowRequestAssistance"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.show_request_assistance}
                                  color="primary"
                                  onChange={this.handleShowRequestAssistance("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                          
                          {/* POS Bridge Configuration - Only show for Counter locations */}
                          
                          
                          <Typography
                            variant="title"
                            style={{ color: "black", fontWeight: 500 }}
                          >
                            {t(
                              "Location.WorkFlow.Title"
                            )}
                          </Typography>
                          <Box style={{display:"flex",alignItems:"center", marginTop: '5%'}}>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                 {t(
                                    "Location.WorkFlow.POS"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.is_pos}
                                  color="primary"
                                  onChange={this.handleEnablePOS("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                          <Box style={{display:"flex",alignItems:"center"}}>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                 {t(
                                    "Location.WorkFlow.Consult"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.is_consult}
                                  color="primary"
                                  onChange={this.handleEnableConsult("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                          <Box style={{display:"flex",alignItems:"center"}}>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                 {t(
                                    "Location.WorkFlow.IDCapture"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.is_dl_capture}
                                  color="primary"
                                  onChange={this.handleEnableIDCapture("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                          <Box style={{display:"flex",alignItems:"center"}}>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                 {t(
                                    "Location.WorkFlow.KioskDobStep"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.is_kiosk_dob_enabled}
                                  color="primary"
                                  onChange={this.handleEnableKioskDobStep("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                            <Tooltip title={t("Location.WorkFlow.KioskDobStepTooltip")}>
                              <Help className={classes.helpIcon}></Help>
                            </Tooltip>
                          </Box>
                          <Box style={{display:"flex",alignItems:"center"}}>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                 {t(
                                    "Location.WorkFlow.KioskDobCamera"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.is_kiosk_dob_camera_enabled}
                                  color="primary"
                                  onChange={this.handleEnableKioskDobCamera("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                            <Tooltip title={t("Location.WorkFlow.KioskDobCameraTooltip")}>
                              <Help className={classes.helpIcon}></Help>
                            </Tooltip>
                          </Box>
                          <Box style={{display:"flex",alignItems:"center", marginBottom: '5%'}}>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                 {t(
                                    "Location.WorkFlow.Survey"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.is_survey}
                                  color="primary"
                                  onChange={this.handleEnableSurvey("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={5}>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <Typography
                              variant="title"
                              style={{ color: "black", fontWeight: 500 }}
                            >
                              {t("Location.Settings.LocationBusinessHours")}
                            </Typography>
                            <Tooltip
                              title={t('Accounts.AccountDetail.KioskBusinessHoursHelpText')}
                              className={classes.customWidth}
                              style={{ marginLeft: '3%' }}
                            >
                              <Help
                                className={classes.helpIcon}
                              ></Help>
                            </Tooltip>
                          </div>
                          <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <p>{t('Accounts.AccountDetail.Day')}</p>
                            <p>{t('Accounts.AccountDetail.OpenAll')}</p>
                            <p>{t('Accounts.AccountDetail.OpenTime')}</p>
                            <p>{t('Accounts.AccountDetail.CloseTime')}</p>
                            <p>{t("Accounts.AccountDetail.Closed")}</p>
                          </div>
                          <div>
                            <Grid container gap={2}>
                              <Grid item xs={3} style={{ marginTop: '15px' }}>
                                <label
                                  style={{
                                    color: '#000',
                                    fontSize: '0.875rem',
                                    lineHeight: '1.46429em',
                                  }}
                                >
                                  {t("Accounts.AccountDetail.Lunch")}
                                </label>
                                <Tooltip
                                    title={t('Accounts.AccountDetail.LunchHelpText')}
                                    className={classes.customWidth}
                                    style={{ marginLeft: '10px' }}
                                  >
                                    <Help
                                      className={classes.helpIcon}
                                    ></Help>
                                  </Tooltip>
                              </Grid>
                              <Grid item xs={1} style={{ marginTop: '15px', maxWidth: "5px"}}/>
                              <Grid item xs={3} style={{ marginTop: '15px', maxWidth: "75px" }}>
                                <TextField
                                  id="lunchStart"
                                  autoComplete='off'
                                  value={this.state.lunchStart}
                                  InputProps={{
                                    inputComponent: TextMaskCustom,
                                    maxLength: 8,
                                    readOnly: Boolean(readOnly),
                                  }}
                                  InputLabelProps={{ shrink: true, }}
                                  onChange={(e)=>this.setState({lunchStart:e.target.value})}
                                  onBlur={this.handleKioskBlurTime}
                                  variant='standard'
                                />
                              </Grid>
                              <Grid item xs={3} style={{ marginTop: '15px', maxWidth: "75px" }}>
                                  <TextField
                                    id="lunchEnd"
                                    autoComplete='off'
                                    value={this.state.lunchEnd}
                                    InputProps={{
                                      inputComponent: TextMaskCustom,
                                      maxLength: 8,
                                      readOnly: Boolean(readOnly),
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e)=>this.setState({lunchEnd:e.target.value})}
                                    onBlur={this.handleKioskBlurTime}
                                    variant='standard'
                                  />
                              </Grid>
                              <Grid item xs={1} style={{ marginTop: '15px'}}/>
                            </Grid>
                          </div>
                          {this.state.KioskHoursOfOperaionsArray &&
                            this.state.KioskHoursOfOperaionsArray.length &&
                            this.state.KioskHoursOfOperaionsArray.length > 0 &&
                            this.state.KioskHoursOfOperaionsArray.map(
                              (ele, index) => {
                                return (
                                  <React.Fragment key={index} disabled={this.state.operation === 'View'}>
                                    <Grid container gap={2}>
                                      <Grid item xs={2} style={{ marginTop: '25px' }}>
                                        <label
                                          style={{
                                            color: '#000',
                                            fontSize: '0.875rem',
                                            lineHeight: '1.46429em',
                                          }}
                                          key={index}
                                        >
                                          {ele && ele.value}
                                        </label>
                                      </Grid>
                                      <Grid item xs={2} style={{ marginTop: '15px', maxWidth: "35px" }}>
                                        <Checkbox
                                          id={"checkbox" + index}
                                          checked={[true, "true"].includes(ele.isOpenAll) ? true : false}
                                          onChange={this.handleOpenAllCheckBox(index)}
                                          color="primary"
                                          disabled={[true, "true"].includes(ele.isClosed) || this.state.operation === 'View'}
                                        />
                                      </Grid>
                                      <Grid item xs={3} style={{ marginTop: '15px', maxWidth: "75px" }}>
                                        <TextField
                                          id={'open' + index}
                                          name={'OpenTime' + index}
                                          autoComplete='off'
                                          value={ele && ele.openTime}
                                          InputProps={{
                                            inputComponent: TextMaskCustom,
                                            maxLength: 8,
                                            readOnly: Boolean(readOnly),
                                          }}
                                          InputLabelProps={{ shrink: true, }}
                                          onChange={this.handleKioskOpentimeChange(index)}
                                          onBlur={this.handleKioskBlurTime}
                                          variant='standard'
                                          disabled={[true, "true"].includes(ele.isClosed) || [true, "true"].includes(ele.isOpenAll)}
                                        />
                                      </Grid>
                                      <Grid item xs={3} style={{ marginTop: '15px', maxWidth: "75px" }}>
                                        <div>
                                          <TextField
                                            id={'close' + index}
                                            name={'ClosingTime' + index}
                                            autoComplete='off'
                                            value={ele && ele.closeTime}
                                            InputProps={{
                                              inputComponent: TextMaskCustom,
                                              maxLength: 8,
                                              readOnly: Boolean(readOnly),
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                            onChange={this.handleKioskClosetimeChange(index)}
                                            onBlur={this.handleKioskBlurTime}
                                            variant='standard'
                                            disabled={[true, "true"].includes(ele.isClosed) || [true, "true"].includes(ele.isOpenAll)}
                                          />
                                        </div>
                                      </Grid>
                                      <Grid item xs={2} style={{ marginTop: '15px', maxWidth: "55px", display: "flex", justifyContent: "flex-end" }}>
                                        <Checkbox
                                          id={"checkbox" + index}
                                          checked={[true, "true"].includes(ele.isClosed) ? true : false}
                                          onChange={this.handleClosedCheckBox(index)}
                                          color="primary"
                                          disabled={[true, "true"].includes(ele.isOpenAll) || this.state.operation === 'View'}
                                        />
                                      </Grid>
                                    </Grid>
                                  </React.Fragment>
                                );
                              }
                            )}
                        </Grid>
                        {this.state.openpath ? (
                          <Grid item xs={3}>
                            <TextValidator
                              id="OpenPathEmailId"
                              name="OpenPathEmailId"
                              label={t("Location.Settings.OpenPathEmailId")}
                              value={this.state.OpenPathEmailId}
                              onChange={this.handleChangeOpenPathEmailId}
                              onBlur={() =>
                                this.getOpenPathUser(
                                  this.state.OpenPathEmailId,
                                  this.state.OpenPathPassword
                                )
                              }
                              variant="standard"
                              validators={['required', 'isEmail']}
                              errorMessages={['this field is required', 'email is not valid']}
                            />
                            <TextValidator
                              sx={{ mt: "1rem" }}
                              id="OpenPathPassword"
                              name="OpenPathPassword"
                              type="password"
                              label={t("Location.Settings.OpenPathPassword")}
                              value={this.state.OpenPathPassword}
                              onChange={this.handleChangeOpenPathPassword}
                              onBlur={() =>
                                this.getOpenPathUser(
                                  this.state.OpenPathEmailId,
                                  this.state.OpenPathPassword
                                )
                              }
                              variant="standard"
                              validators={['required']}
                              errorMessages={['this field is required']}
                              inputProps={{
                                name: 'random-name',
                                autocomplete: 'new-password',
                                form: {
                                  autocomplete: 'off',
                                },
                              }}
                            />
                            <FormControl
                              variant="standard"
                              sx={{ mt: "1rem", minWidth: 235 }}
                            >
                              <InputLabel>
                                {t("Location.Settings.OpenPathUserList")}
                              </InputLabel>
                              <Select
                                value={this.state.openPathUser || ""}
                                readOnly={readOnly}
                                onChange={(e) => {
                                  this.setState({
                                    openPathUser: e.target.value,
                                  });
                                }}
                                label={t("Location.Settings.OpenPathUserList")}
                              >
                                {this.state.openPathUserList && this.state.openPathUserList.map((item, index) => {
                                  return (
                                    <MenuItem
                                      key={index}
                                      value={item && item.id}
                                      selected
                                    >
                                      {item && item.name}
                                    </MenuItem>
                                  )
                                }

                                )}
                              </Select>
                            </FormControl>
                          </Grid>) : (
                          ""
                        )}
                      </Grid>
                    </TabContainer>
                  </ValidatorForm>
                  </TabContainer>,
                  

                  <TabContainer dir={theme.direction}>
                    <div>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell align="center" sx={{ width: "12%" }}>
                              <div>
                                <IconButton
                                  onClick={this.addRow}
                                  disabled={Boolean(readOnly)}
                                >
                                  <AddIcon className={classes.iconStyle} />
                                </IconButton>
                              </div>
                            </TableCell>
                            <TableCell
                              sx={{ width: "40%", color: "rgb(0, 0, 0, 0.54)" }}
                              align="left"
                            >
                              {t("Location.Addons.Type")}
                            </TableCell>
                            <TableCell align="left" sx={{ width: "13%" }}>
                              <div>
                                <IconButton>
                                  <ArrowBackIcon
                                    className={classes.tableIcon}
                                  />
                                </IconButton>
                                <IconButton>
                                  <ArrowForward className={classes.tableIcon} />
                                </IconButton>
                              </div>
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                color: "rgb(0, 0, 0, 0.54)",
                                width: "45%",
                              }}
                            >
                              {t("Location.Addons.Connected")}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>{this.createRow()}</TableBody>
                      </Table>
                    </div>
                  </TabContainer>,

                  <TabContainer dir={theme.direction}>
                    <div
                      className={classes.paddedBoxDivEdit}
                      style={{ paddingLeft: "2%" }}
                    >
                      <ValidatorForm
                        ref="form"
                        onSubmit={
                          this.state.operation === "Add"
                            ? this.handleSubmit
                            : this.handleUpdate
                        }
                      >
                        <Grid
                          container
                          spacing={4}
                          style={{padding: "0px 25px"}}
                        >
                          <Grid item xs={12} md={12}>
                            {this.renderPayLaterConfiguration()}
                            {this.renderPaymentGatewayTabs()}
                          </Grid>
                          <Grid item xs={12} md={12} className={classes.leftChild} style={{ marginLeft: 0 }}>
                            {this.renderPaymentDevicesConfiguration()}
                            {this.renderGlobalPaymentsConfiguration()}
                            {this.renderPosBridgeGatewayConfiguration()}
                          </Grid>
                        </Grid>
                      </ValidatorForm>
                    </div>
                  </TabContainer>,

                  showAutoUpdateSettingsTab && (
                    <TabContainer dir={theme.direction}>
                      <AutoUpdateSettingsTab
                        readOnly={readOnly}
                        values={{
                          kiosk_version_current: this.state.kiosk_version_current,
                          kiosk_version_available: this.state.kiosk_version_available,
                          engine_version_current: this.state.engine_version_current,
                          engine_version_target: this.state.engine_version_target,
                          wrapper_version_current: this.state.wrapper_version_current,
                          wrapper_version_target: this.state.wrapper_version_target,
                          pos_bridge_version_current: this.state.pos_bridge_version_current,
                          pos_bridge_version_target: this.state.pos_bridge_version_target,
                          component_update_ring: this.state.component_update_ring,
                          component_update_paused: this.state.component_update_paused,
                          component_update_mismatch: this.state.component_update_mismatch,
                          updater_last_check_at: this.state.updater_last_check_at,
                        }}
                        onChange={(patch) => this.setState(patch)}
                      />
                    </TabContainer>
                  ),

                  showColumnMappingTab && (
                    <TabContainer dir={theme.direction}>
                      <ColumnMappingTab
                        locationId={this.state.kiosk_box_id || this.state.box.id}
                        isSuperAdmin={(() => {
                          // Check if user has SUPERADMIN role stored in sessionStorage
                          // This is how other components check for super admin (see user-list/index.js)
                          const hasSuperAdmin = sessionStorage.hasOwnProperty("superadmin");
                          const superAdminId = hasSuperAdmin ? JSON.parse(sessionStorage.getItem("superadmin")) : null;
                          const isSuperAdmin = hasSuperAdmin && superAdminId === ROLES_TYPE.SUPERADMIN;
                          return isSuperAdmin;
                        })()}
                        userGroupType={this.state.userGroupType}
                        expansions={this.state.addonUnits || []}
                        boxTypeId={this.state.boxTypeId}
                        boxTypes={this.state.boxTypes || []}
                        operation={this.state.operation}
                        onClose={this.handleClose}
                        onColumnMappingsSaved={this.handleColumnMappingsSaved}
                        columnMappings={this.state.columnMappings || []}
                      />
                    </TabContainer>
                  ),

                  this.state.canManagePickupSwitching ? (
                    <TabContainer dir={theme.direction}>
                      <PickupSwitchingTab
                        t={t}
                        value={this.state.pickupSwitching}
                        onChange={(pickupSwitching) =>
                          this.setState({ pickupSwitching })
                        }
                        entitlements={this.state.featureEntitlements}
                        entitlementsBusy={!this.state.featureEntitlements}
                        readOnly={this.state.operation === "View"}
                      />
                    </TabContainer>
                  ) : null,

                  this.state.operation === 'View' && (
                    <TabContainer dir={theme.direction}>
                      <div>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell align="left">
                                {t("Location.TestDetails.Date")}
                              </TableCell>
                              <TableCell align="left">
                                {t("Location.TestDetails.DoorTest")}
                              </TableCell>
                              <TableCell align="left">
                                {t("Location.TestDetails.NetworkTest")}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>{this.createTestDetailsRow()}</TableBody>
                        </Table>
                      </div>
                    </TabContainer>
                  ),
                  <TabContainer dir={theme.direction}>
                    <LocationWindowsTab key={`${this.state.locationWindowsBoxId}:${this.state.operation}`} boxId={this.state.operation === 'Add' ? null : this.state.locationWindowsBoxId} value={this.state.locationWindows} onChange={this.handleLocationWindowsChange} devices={this.getPaymentDevicePayload()} gatewayId={this.state.paymentType || PaymentGatewayTypes.GLOBAL_PAYMENTS} readOnly={this.state.operation === 'View' || !this.state.boxedit} busy={this.state.isButtonDisabled} />
                  </TabContainer>,
                  ])}
                </SwipeableViews>
                {this.renderLocationDialogActions("8px 28px 8px 8px")}
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", minHeight: 0 }}>
                <AppBar
                  style={{ maxWidth: "1025px" }}
                  position="static"
                  color="default"
                >
                  <Tabs
                    value={this.state.selectedTab}
                    onChange={this.handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                  >
                    <Tab
                      label={t("Location.Details.Details")}
                      style={{ minWidth: LOCATION_TAB_MIN_WIDTH }}
                    />
                     <Tab
                      label={t("Location.Settings.Settings")}
                      style={{ minWidth: LOCATION_TAB_MIN_WIDTH }}
                    />
                    <Tab
                      label={t("Location.POS.PosConfiguration")}
                      style={{ minWidth: LOCATION_TAB_MIN_WIDTH }}
                    />
                    {this.state.canManagePickupSwitching ? (
                      <Tab
                        icon={<PickupSwitchingTabIcon fontSize="small" />}
                        iconPosition="start"
                        label={t("Location.PickupSwitching.Tab", {
                          defaultValue: "Pickup switching",
                        })}
                        style={{ minWidth: LOCATION_TAB_MIN_WIDTH }}
                      />
                    ) : null}
                    <Tab label="Windows" style={{ minWidth: LOCATION_TAB_MIN_WIDTH }} />
                  </Tabs>
                </AppBar>
                <SwipeableViews
                  style={{
                    maxWidth: "1025px",
                    flex: "1 1 auto",
                    overflowY: "auto",
                    minHeight: 0,
                  }}
                  axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                  index={this.state.selectedTab}
                  onChangeIndex={index => this.handleChangeIndex(index)}
                >
                  {React.Children.toArray([
                  <TabContainer dir={theme.direction}>
                    <div className={classes.paddedBoxDivEdit}>
                      <ValidatorForm
                        ref="form"
                        instantValidate={false}
                        onSubmit={
                          this.state.operation === "Add"
                            ? this.handleSubmit
                            : this.handleUpdate
                        }
                      >
                        <DialogTitle id="form-dialog-title">
                          {t(this.state.operation)}{" "}
                          {t("Location.Details.Locations")}
                        </DialogTitle>
                        <DialogContent>
                          <div className={classes.errorDiv}>
                            {this.state.errorMessage}
                          </div>
                          <div style={{ display: "flex", alignItems: "end" }}>
                            <div ref={this.firstErrorRef} style={{ width: "500px" }}>
                              <Selector
                                id="parent_id"
                                label={t("Location.Details.ParentAccount")}
                                values={this.state.accountValues}
                                selected={this.state.parent_id}
                                onBlur={this.handleChange}
                                disableWhenViewSelect={disableSelect}
                              />
                              {this.state.validationErrors && this.state.validationErrors.parent_id && (
                                <FormHelperText error>{this.state.validationErrors.parent_id}</FormHelperText>
                              )}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                marginLeft: "5%",
                                alignItems: "center",
                              }}
                            >
                              <div
                                className={classNames(classes.title)}
                                style={{
                                  color: "#a5a5a5",
                                  float: "left",
                                }}
                              >
                                <span>
                                  {t("Location.Details.LocationIsActiveToggle")}
                                </span>
                              </div>
                              <div
                                className={classNames(classes.flexItemToggle)}
                                style={{ color: "#a5a5a5" }}
                              >
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  disableRipple
                                  checked={this.state.IsActive}
                                  onChange={this.handleChangeActive}
                                  value={this.state.IsActive}
                                  color="primary"
                                  disabled={this.state.operation === "View"}
                                />
                              </div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                marginLeft: "2%",
                                alignItems: "center",
                              }}
                            >
                              <div
                                className={classNames(classes.title)}
                                style={{
                                  color: "#a5a5a5",
                                  float: "left",
                                }}
                              >
                                <span>
                                  {t("Location.Details.MarketplaceToggle")}
                                </span>
                              </div>
                              <div
                                className={classNames(classes.flexItemToggle)}
                                style={{ color: "#a5a5a5" }}
                              >
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  disableRipple
                                  checked={this.state.is_marketplace}
                                  onChange={this.handleChangeMarketplace}
                                  value={this.state.is_marketplace}
                                  color="primary"
                                  disabled={this.state.operation === "View"}
                                  sx={{ "&.Mui-checked": { color: "red" } }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className={classes.twoChildren}>
                            <div className={classes.leftChild}>
                              <div
                                style={{ display: "flex", marginTop: "1rem" }}
                              >
                                <FormControl
                                  className={classes.boxType}
                                  error={!!this.state.validationErrors && this.state.validationErrors.location_type}
                                >
                                  <InputLabel
                                    htmlFor="type_id"
                                    sx={{ marginLeft: "-12px" }}
                                  >
                                    {t("Location.Details.LocationType")}
                                  </InputLabel>
                                  <Select
                                    value={
                                      this.state.manage_location_name || ""
                                    }
                                    onChange={(e) =>
                                      this.handleLocationType(e.target.value)
                                    }
                                    inputProps={{
                                      name: "type_id",
                                      id: "type_id",
                                    }}
                                    readOnly={readOnly}
                                    disabled={isLocationTypeReadOnly}
                                    variant="standard"
                                  >
                                    {manageLocation &&
                                      manageLocation.map((type, index) => (
                                        <MenuItem
                                          key={index}
                                          value={type.value}
                                          selected
                                          className={classes.menuItem}
                                          sx={{ height: "46px" }}
                                        >
                                          {type.label}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                  {this.state.validationErrors && this.state.validationErrors.location_type && (
                                    <FormHelperText error>{this.state.validationErrors.location_type}</FormHelperText>
                                  )}
                                  {this.renderLocationTypeLicenseHelp(t)}
                                </FormControl>
                              </div>
                              <div style={{ display: "flex" }}>
                                <TextValidator
                                  autoFocus
                                  className={classes.halfTextField}
                                  margin="normal"
                                  value={this.state.name}
                                  id="name"
                                  name="name"
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    maxLength: 50,
                                  }}
                                  label={locationFieldLabel(
                                    t("Location.Details.LocationName"),
                                    t("Location.Details.LocationNameInfo")
                                  )}
                                  placeholder=""
                                  onChange={this.handleChange}
                                  validators={["required"]}
                                  errorMessages={[t("Validation.Required")]}
                                  error={!!this.state.validationErrors && this.state.validationErrors.name}
                                  helperText={this.state.validationErrors && this.state.validationErrors.name}
                                  variant="standard"
                                />
                                <TextValidator
                                  className={classes.halfTextField}
                                  margin="normal"
                                  value={this.state.branding_name}
                                  id="branding_name"
                                  name="branding_name"
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    maxLength: 100,
                                  }}
                                  label={locationFieldLabel(
                                    t("Location.Details.BrandingName"),
                                    t("Location.Details.BrandingNameInfo")
                                  )}
                                  placeholder=""
                                  onChange={this.handleChange}
                                  variant="standard"
                                />
                              </div>
                              <div style={{ display: "flex" }}>
                                <TextField
                                  className={classes.halfTextField}
                                  margin="normal"
                                  value={this.state.location_notes}
                                  id="location_notes"
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    maxLength: 100,
                                  }}
                                  label={t("Location.Details.LocationNotes")}
                                  placeholder=""
                                  onChange={(e) =>
                                    this.handleChangeHandler(e.target.value)
                                  }
                                  style={{ marginTop: "4px" }}
                                  variant="standard"
                                />
                                <TextValidator
                                  className={classes.halfTextField}
                                  margin="normal"
                                  value={this.state.description}
                                  id="description"
                                  name="description"
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    maxLength: 100,
                                  }}
                                  label={t("Location.Details.Description")}
                                  placeholder=""
                                  onChange={this.handleChange}
                                  variant="standard"
                                />
                              </div>
                              {this.state.manage_location_name === "Courier" ? (
                                <div
                                  className={classNames(classes.flexContainer)}
                                >
                                  <Table>
                                    <TableRow>
                                      <TableCell
                                        style={{
                                          borderBottom: "0px",
                                          padding: "8px",
                                        }}
                                      >
                                        <div>
                                          <div style={{ marginTop: "4px" }}>
                                            <FormControlLabel
                                              label={
                                                <span style={{ color: "#000" }}>
                                                  {t(
                                                    "Location.Details.Courier.FedEx"
                                                  )}
                                                </span>
                                              }
                                              control={
                                                <Checkbox
                                                  onChange={() =>
                                                    this.selectCourierHandler(
                                                      "Fed Ex"
                                                    )
                                                  }
                                                  color="primary"
                                                  checked={this.state.Fed_Ex}
                                                  disabled={
                                                    this.state.selectedRadio ===
                                                    "Fed Ex"
                                                  }
                                                />
                                              }
                                            />
                                          </div>
                                          <div style={{ marginTop: "4px" }}>
                                            <FormControlLabel
                                              label={
                                                <span tyle={{ color: "#000" }}>
                                                  {t(
                                                    "Location.Details.Courier.UPS"
                                                  )}
                                                </span>
                                              }
                                              control={
                                                <Checkbox
                                                  onChange={() =>
                                                    this.selectCourierHandler(
                                                      "UPS"
                                                    )
                                                  }
                                                  color="primary"
                                                  checked={this.state.UPS}
                                                  disabled={
                                                    this.state.selectedRadio ===
                                                    "UPS"
                                                  }
                                                />
                                              }
                                            />
                                          </div>
                                          <div style={{ marginTop: "4px" }}>
                                            <FormControlLabel
                                              label={
                                                <span style={{ color: "#000" }}>
                                                  {t(
                                                    "Location.Details.Courier.DHL"
                                                  )}
                                                </span>
                                              }
                                              control={
                                                <Checkbox
                                                  onChange={() =>
                                                    this.selectCourierHandler(
                                                      "DHL"
                                                    )
                                                  }
                                                  color="primary"
                                                  checked={this.state.DHL}
                                                  disabled={
                                                    this.state.selectedRadio ===
                                                    "DHL"
                                                  }
                                                />
                                              }
                                            />
                                          </div>
                                          <div style={{ marginTop: "4px" }}>
                                            <FormControlLabel
                                              label={
                                                <span style={{ color: "#000" }}>
                                                  {t(
                                                    "Location.Details.Courier.USPostalService"
                                                  )}
                                                </span>
                                              }
                                              control={
                                                <Checkbox
                                                  onChange={() =>
                                                    this.selectCourierHandler(
                                                      "US Postal Service"
                                                    )
                                                  }
                                                  color="primary"
                                                  checked={this.state.US_Postal}
                                                  disabled={
                                                    this.state.selectedRadio ===
                                                    "US Postal Service"
                                                  }
                                                />
                                              }
                                            />
                                          </div>
                                          <div style={{ marginTop: "4px" }}>
                                            <FormControlLabel
                                              label={
                                                <span style={{ color: "#000" }}>
                                                  {t(
                                                    "Location.Details.Courier.3rdParty"
                                                  )}
                                                </span>
                                              }
                                              control={
                                                <Checkbox
                                                  onChange={() =>
                                                    this.selectCourierHandler(
                                                      "3rd Party"
                                                    )
                                                  }
                                                  color="primary"
                                                  checked={
                                                    this.state.third_Party
                                                  }
                                                  disabled={
                                                    this.state.selectedRadio ===
                                                    "3rd Party"
                                                  }
                                                />
                                              }
                                            />
                                          </div>
                                          <div style={{ marginTop: "4px" }}>
                                            <FormControlLabel
                                              label={
                                                <span style={{ color: "#000" }}>
                                                  {t(
                                                    "Location.Details.Courier.SelfServices"
                                                  )}
                                                </span>
                                              }
                                              control={
                                                <Checkbox
                                                  onChange={() =>
                                                    this.selectCourierHandler(
                                                      "Self Service(US)"
                                                    )
                                                  }
                                                  color="primary"
                                                  checked={
                                                    this.state.Self_Service
                                                  }
                                                  disabled={
                                                    this.state.selectedRadio ===
                                                    "Self Service(US)"
                                                  }
                                                />
                                              }
                                            />
                                          </div>
                                        </div>
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          borderBottom: "0px",
                                          padding: "8px",
                                        }}
                                      >
                                        <FormControl component="fieldset">
                                          <RadioGroup
                                            aria-label="gender"
                                            name="gender1"
                                            value={this.state.selectedRadio}
                                            onChange={(evt) =>
                                              this.handleChangeRadio(
                                                evt.target.value
                                              )
                                            }
                                          >
                                            <FormControlLabel
                                              value="Fed Ex"
                                              control={<Radio />}
                                              label={t(
                                                "Location.Details.Courier.MakeFedExDefault"
                                              )}
                                              style={{ marginTop: "4px" }}
                                            />
                                            <FormControlLabel
                                              value="UPS"
                                              control={<Radio />}
                                              label={t(
                                                "Location.Details.Courier.MakeUPSDefault"
                                              )}
                                              style={{ marginTop: "4px" }}
                                            />
                                            <FormControlLabel
                                              value="DHL"
                                              control={<Radio />}
                                              label={t(
                                                "Location.Details.Courier.MakeDHLDefault"
                                              )}
                                              style={{ marginTop: "4px" }}
                                            />
                                            <FormControlLabel
                                              value="US Postal Service"
                                              control={<Radio />}
                                              label={t(
                                                "Location.Details.Courier.MakeUSPostalService"
                                              )}
                                              style={{ marginTop: "4px" }}
                                            />
                                            <FormControlLabel
                                              value="3rd Party"
                                              control={<Radio />}
                                              label={t(
                                                "Location.Details.Courier.Make3rdParty"
                                              )}
                                              style={{ marginTop: "4px" }}
                                            />
                                            <FormControlLabel
                                              value="Self Service(US)"
                                              control={<Radio />}
                                              label={t(
                                                "Location.Details.Courier.SelfServiceUS"
                                              )}
                                              style={{ marginTop: "4px" }}
                                            />
                                          </RadioGroup>
                                        </FormControl>
                                      </TableCell>
                                    </TableRow>
                                  </Table>
                                </div>
                              ) : (
                                ""
                              )}
                              {this.state.manage_location_name !== "Kiosk" ? (
                                ""
                              ) : (
                                <FormControl className={classes.boxType}>
                                  <InputLabel
                                    htmlFor="type_id"
                                    sx={{ marginLeft: "-12px" }}
                                  >
                                    {t("Location.Details.BoxType")}
                                  </InputLabel>
                                  <Select
                                    value={this.state.type_id || ""}
                                    onChange={this.handleChange}
                                    inputProps={{
                                      name: "type_id",
                                      id: "type_id",
                                    }}
                                    readOnly={readOnly}
                                    disabled={
                                      this.state.manage_location_name !==
                                      "Kiosk"
                                    }
                                  >
                                    {boxTypes &&
                                      boxTypes.map((type, index) => (
                                        <MenuItem
                                          key={index}
                                          value={type.id}
                                          selected
                                          className={classes.menuItem}
                                        >
                                          {type.label}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                </FormControl>
                              )}
                            </div>
                            <div className={classes.rightChild}>
                              <div className={classes.dropbox}>
                                {readOnly ? (
                                  <div>
                                    {!this.state.avatarPreview && (
                                      <AddBoxImage
                                        className={classes.dropImage}
                                      />
                                    )}
                                    {this.state.avatarPreview && (
                                      <img
                                        alt=""
                                        src={this.state.avatarPreview}
                                        className={classes.dropPic}
                                      />
                                    )}
                                  </div>
                                ) : (
                                  <Dropzone
                                    id="avatardropzone"
                                    onDrop={this.handleDrop.bind(this)}
                                    className={classes.innerBox}
                                  >
                                    {!this.state.avatarPreview && (
                                      <AddBoxImage
                                        className={classes.dropImage}
                                      />
                                    )}
                                    {this.state.avatarPreview && (
                                      <img
                                        alt=""
                                        src={this.state.avatarPreview}
                                        className={classes.dropPic}
                                      />
                                    )}
                                  </Dropzone>
                                )}
                              </div>
                              <div
                                variant="caption"
                                style={{ paddingTop: "40px" }}
                              >
                                <p className={classes.captionText}>
                                  {t("Location.Details.UploadImageTitle")}
                                </p>
                                <Button onClick={this.removeImg}>
                                  {t("Location.Details.RemoveImageButton")}
                                </Button>
                              </div>
                            </div>
                          </div>
                          <Typography
                            variant="title"
                            style={{
                              paddingTop: "40px",
                              fontSize: "1.3125rem",
                              fontWeight: 500,
                              lineHeight: "1.16667em",
                            }}
                          >
                            {t("Location.Details.LocationAddress")}
                          </Typography>
                          <div style={{ display: "flex" }}>
                            <TextValidator
                              margin="dense"
                              className={classes.halfTextField}
                              value={this.state.address1}
                              id="address1"
                              name="address1"
                              inputProps={{
                                readOnly: Boolean(readOnly),
                                maxLength: 100,
                              }}
                              label={t("Location.Details.AddressLine1")}
                              placeholder=""
                              onChange={this.handleChange}
                              validators={["required"]}
                              errorMessages={[
                                t("Validation.EnterAddressLine"),
                                t("Validation.UseAlphaDigits"),
                              ]}
                              error={!!this.state.validationErrors && this.state.validationErrors.address1}
                              helperText={this.state.validationErrors && this.state.validationErrors.address1}
                              variant="standard"
                            />
                            <TextField
                              className={classes.halfTextField}
                              margin="normal"
                              defaultValue={this.state.address2}
                              id="address2"
                              inputProps={{
                                readOnly: Boolean(readOnly),
                                maxLength: 100,
                                autocomplete: "new-password",
                                form: {
                                  autocomplete: "off",
                                },
                              }}
                              label={t("Location.Details.AddressLine2")}
                              placeholder=""
                              onBlur={this.handleChange}
                              style={{ marginTop: "4px" }}
                              variant="standard"
                            />
                          </div>
                          <br />
                          <div style={{ display: "flex" }}>
                            <TextValidator
                              className={classes.ThirdTextField}
                              margin="normal"
                              value={this.state.city}
                              id="city"
                              name="city"
                              inputProps={{
                                readOnly: Boolean(readOnly),
                                maxLength: 50,
                              }}
                              label={t("Location.Details.City")}
                              placeholder=""
                              onChange={this.handleChange}
                              validators={["required"]}
                              errorMessages={[
                                t("Validation.EnterCity"),
                                t("Validation.UseAlphabets"),
                              ]}
                              error={!!this.state.validationErrors && this.state.validationErrors.city}
                              helperText={this.state.validationErrors && this.state.validationErrors.city}
                              variant="standard"
                            />
                            <TextValidator
                              className={classes.ThirdTextField}
                              margin="normal"
                              value={this.state.state}
                              id="state"
                              name="state"
                              inputProps={{
                                readOnly: Boolean(readOnly),
                                maxLength: 50,
                              }}
                              label={t("Location.Details.State")}
                              placeholder=""
                              onChange={this.handleChange}
                              validators={["required"]}
                              errorMessages={[
                                t("Validation.EnterState"),
                                t("Validation.UseAlphabets"),
                              ]}
                              error={!!this.state.validationErrors && this.state.validationErrors.state}
                              helperText={this.state.validationErrors && this.state.validationErrors.state}
                              variant="standard"
                            />
                            <TextValidator
                              className={classes.ThirdTextField}
                              margin="normal"
                              value={this.state.zip}
                              id="zip"
                              name="zip"
                              inputProps={{
                                readOnly: Boolean(readOnly),
                                maxLength: 6,
                              }}
                              label={t("Location.Details.Zip")}
                              placeholder=""
                              onChange={this.handleChange}
                              validators={["required"]}
                              errorMessages={[
                                t("Validation.zip"),
                                t("Validation.UseDigits"),
                              ]}
                              error={!!this.state.validationErrors && this.state.validationErrors.zip}
                              helperText={this.state.validationErrors && this.state.validationErrors.zip}
                              variant="standard"
                            />
                          </div>
                          <br />
                        </DialogContent>
                      </ValidatorForm>
                    </div>
                  </TabContainer>,
                
                  <ValidatorForm
                    ref="form"
                    onSubmit={
                      this.state.operation === "Add"
                        ? this.handleSubmit
                        : this.handleUpdate
                    }
                  >
                    <TabContainer dir={theme.direction}>
                      <Grid
                        xs={12}
                        container
                        gap={4}
                        spacing={2}
                        sx={{ p: "24px !important" }}
                      >
                        <Grid item xs={5} md={5} lg={5}>
                          <Typography
                            variant="title"
                            style={{ color: "black", fontWeight: 500 }}
                          >
                            {t(
                              "Location.WorkFlow.Title"
                            )}
                          </Typography>
                          <Box style={{display:"flex",alignItems:"center", marginTop: '5%'}}>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                 {t(
                                    "Location.WorkFlow.POS"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.is_pos}
                                  color="primary"
                                  onChange={this.handleEnablePOS("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                          <Box style={{display:"flex",alignItems:"center"}}>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                 {t(
                                    "Location.WorkFlow.Consult"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.is_consult}
                                  color="primary"
                                  onChange={this.handleEnableConsult("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                          <Box style={{display:"flex",alignItems:"center"}}>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                 {t(
                                    "Location.WorkFlow.IDCapture"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.is_dl_capture}
                                  color="primary"
                                  onChange={this.handleEnableIDCapture("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                          <Box style={{display:"flex",alignItems:"center"}}>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                 {t(
                                    "Location.WorkFlow.Ecom"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.is_ecom_enabled}
                                  color="primary"
                                  onChange={this.handleEnableEcom("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                          {[true, "true"].includes(localStorage.getItem("isIlocalUser")) && (
                          <Box style={{display:"flex",alignItems:"center"}}>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                 {t(
                                    "Location.WorkFlow.NonRxDeliver"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.is_non_rx_deliver_enabled}
                                  color="primary"
                                  onChange={this.handleEnableNonRxDeliver("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                            <Tooltip title={t("Location.WorkFlow.NonRxDeliverTooltip")}>
                              <Help className={classes.helpIcon}></Help>
                            </Tooltip>
                          </Box>
                          )}
                          <Box style={{display:"flex",alignItems:"center"}}>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                 {t(
                                    "Location.WorkFlow.StrictPatientVerification"
                                  )}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.strict_patient_verification}
                                  color="primary"
                                  onChange={this.handleStrictPatientVerification("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                          <Box style={{display:"flex",alignItems:"center"}}>
                            <FormControlLabel
                              label={
                                <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                  <span
                                    style={{
                                      fontSize: 18,
                                      color: "rgb(165, 165, 165)",
                                    }}
                                  >
                                    {t("Location.WorkFlow.EnableTrim")}
                                  </span>
                                  <Tooltip title={t("Location.WorkFlow.EnableTrimTooltip")} placement="top" arrow>
                                    <Info style={{ fontSize: 20, color: "rgb(165, 165, 165)", cursor: "help" }} />
                                  </Tooltip>
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.enable_trim}
                                  color="primary"
                                  onChange={this.handleEnableTrim("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                          {this.state.enable_trim && (
                            <Box style={{ marginTop: 8, marginLeft: 0 }}>
                              <TextField
                                fullWidth
                                label={t("Location.WorkFlow.TrimChars")}
                                placeholder={t("Location.WorkFlow.TrimCharsPlaceholder")}
                                value={this.state.trim_chars != null ? this.state.trim_chars : SearchUtils.defaultTrimChars}
                                onChange={this.handleTrimChars}
                                disabled={this.state.operation === "View"}
                                size="small"
                              />
                            </Box>
                          )}
                        </Grid>
                        
                      </Grid>
                    </TabContainer>
                  </ValidatorForm>,
                  /* Add on tab */
                  <TabContainer dir={theme.direction}>
                    <div
                      className={classes.paddedBoxDivEdit}
                      style={{ paddingLeft: "2%" }}
                    >
                      <ValidatorForm
                        ref="form"
                        onSubmit={
                          this.state.operation === "Add"
                            ? this.handleSubmit
                            : this.handleUpdate
                        }
                      >
                        <Grid
                          container
                          spacing={4}
                          style={{ padding: "0px 25px" }}
                        >
                          <Grid item xs={12} md={12}>
                            {this.renderPayLaterConfiguration()}
                            {this.renderPaymentGatewayTabs()}
                          </Grid>
                          <Grid item xs={12} md={12} className={classes.leftChild} style={{ marginLeft: 0 }}>
                            {this.renderPaymentDevicesConfiguration()}
                            {this.renderGlobalPaymentsConfiguration()}
                            {this.renderPosBridgeGatewayConfiguration()}
                          </Grid>
                        </Grid>
                      </ValidatorForm>
                    </div>
                  </TabContainer>,
                  this.state.canManagePickupSwitching ? (
                    <TabContainer dir={theme.direction}>
                      <PickupSwitchingTab
                        t={t}
                        value={this.state.pickupSwitching}
                        onChange={(pickupSwitching) =>
                          this.setState({ pickupSwitching })
                        }
                        entitlements={this.state.featureEntitlements}
                        entitlementsBusy={!this.state.featureEntitlements}
                        readOnly={this.state.operation === "View"}
                      />
                    </TabContainer>
                  ) : null,
                  <TabContainer dir={theme.direction}>
                    <LocationWindowsTab key={`${this.state.locationWindowsBoxId}:${this.state.operation}`} boxId={this.state.operation === 'Add' ? null : this.state.locationWindowsBoxId} value={this.state.locationWindows} onChange={this.handleLocationWindowsChange} devices={this.getPaymentDevicePayload()} gatewayId={this.state.paymentType || PaymentGatewayTypes.GLOBAL_PAYMENTS} readOnly={this.state.operation === 'View' || !this.state.boxedit} busy={this.state.isButtonDisabled} />
                  </TabContainer>,
                  ])}
                </SwipeableViews>
                {this.renderLocationDialogActions("8px 28px 8px 8px")}
              </div>
            )}
          </Dialog>

          {/* Clone dialog */}
          <Dialog
            open={this.state.isCloneDialog || false}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle id='alert-dialog-title'>
              {t('Accounts.CloneDialog.Title')}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id='alert-dialog-description'>
                <FormControl fullWidth  sx={{ mt: 4 }}>
                  <InputLabel id="clone-count-label">{t("Location.CloneDialog.CloneCount")}</InputLabel>
                  <Select
                    labelId="clone-count-label"
                    className={classes.halfTextFieldNew}
                    variant='standard'
                    value={this.state.cloneCount || 1}
                    onChange={(e) => this.setState({ cloneCount: parseInt(e.target.value, 10) })}
                  >
                    {[...Array(10)].map((_, i) => (
                      <MenuItem key={i + 1} value={i + 1}>{i + 1}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth sx={{ mt: 4 }}>
                  <InputLabel id="parent-id-label">{t("Location.ParentAccount")}</InputLabel>
                  <Select
                    labelId="parent-id-label"
                    id="parent_id"
                    variant="standard"
                    value={this.state.parent_id || ''}
                    onChange={(e) => this.setState({ parent_id: e.target.value })}
                    disabled={disableSelect}
                  >
                    {this.state.accountValues && this.state.accountValues.map((account) => (
                      <MenuItem key={account.value} value={account.value}>
                        {account.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ mt: 4 }}>
              <Button
                onClick={this.handleCloseCloneDialog}
                color='primary'
                className={classes.primaryButton}
              >
                {t('Location.CancelButton')}
              </Button>
              <Button
                onClick={this.handleClone}
                color='primary'
                autoFocus
                className={classes.primaryButton}
              >
                {t('Location.CloneActions')}
              </Button>
            </DialogActions>
          </Dialog>

          <EnhancedTableToolbar
            numSelected={selected.length}
            add={this.addBox}
            deleteBoxes={this.deleteBoxes}
            editBox={this.editBox}
            confirmDelete={this.confirmDelete}
            badd={this.state.boxadd}
            bdelete={this.state.boxdelete}
          />
          <div className={classes.tableWrapper}>
            <Divider
              style={{
                marginTop: "10px",
                height: "5px",
                borderColor: "rgba(0, 0, 0, 0.12)",
                borderStyle: "solid",
                borderBottomWidth: "5px",
              }}
            />
                        <ILocalAGGrid
              columnDefs={[
                {
                  field: "picture_url",
                  headerName: t("Location.Picture"),
                  sortable: false,
                  filter: false,
                  maxWidth: 100,
                  cellRenderer: (params) => (
                    <Avatar alt="" src={params.data && params.data.picture_url} />
                  ),
                },
                { field: "name", headerName: t("Location.Name") },
                { field: "description", headerName: t("Location.Description") },
                {
                  field: "type",
                  headerName: t("Location.Type"),
                  sortable: false,
                  filter: false,
                  valueGetter: (params) => {
                    const n = params.data;
                    if (!n || n.location_type_id === undefined) return "";
                    if (n.location_type_id === LOCATION_TYPE.Kiosk) {
                      return (n.type && n.type.name) || "";
                    }
                    if (n.location_type_id === LOCATION_TYPE.Curbside) return "Curb Side";
                    if (n.location_type_id === LOCATION_TYPE.Courier) return "Courier";
                    if (n.location_type_id === LOCATION_TYPE.Counter) return "Counter";
                    if (n.location_type_id === LOCATION_TYPE.Bedside) return "Bedside";
                    if (n.location_type_id === LOCATION_TYPE.Other) return "Other";
                    return "";
                  },
                },
                ...getAddressColumns({
                  t,
                  prefix: "address",
                  keys: ["city", "state"],
                }),
                {
                  field: "account.name",
                  headerName: t("Location.ParentAccount"),
                  valueGetter: (params) =>
                    (params.data && params.data.account && params.data.account.name) || "",
                },
                getActionsColumn({
                  headerName: t("Location.Actions"),
                  onActionsClick: (event, params, menuHelpers) =>
                    this.openRowActionsMenu(event, params, menuHelpers),
                }),
              ]}
              defaultColDef={getDefaultColDef()}
              rowSelection="multiple"
              rowModelType="serverSide"
              cacheBlockSize={TransactionFilterObj.pageSize || 10}
              paginationPageSize={TransactionFilterObj.pageSize || 10}
              paginationPageSizeSelector={[10, 20, 25]}
              rowHeight={45}
              getRowId={(params) => params.data && params.data.id}
              onGridReady={this.onGridReady}
              onRowSelected={this.onRowSelected}
              onPaginationChanged={this.onPaginationChanged}
              getContextMenuItems={this.getContextMenuItems}
            />
          </div>
        </div>
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(
  withTranslation()(EnhancedTable)
);



// WEBPACK FOOTER //
// ./src/components/box-list/index.js